
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("48Eol", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $T1bCI = parcelRequire("T1bCI");


var $6cnUO = parcelRequire("6cnUO");


var $k7Tf7 = parcelRequire("k7Tf7");


var $9wGTI = parcelRequire("9wGTI");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $4kfV4 = parcelRequire("4kfV4");


var $l998X = parcelRequire("l998X");







const $75d67dd405790b85$export$79cc7820899d3234 = /*#__PURE__*/ (0, $42omo.createContext)(false);



var $9gVcn = parcelRequire("9gVcn");

const $1274ccb8dddd72cd$export$797f6437373337da = ({ children: children, value: value })=>{
    const isCustomIsFhsEnabled = (0, $42omo.useContext)((0, $75d67dd405790b85$export$79cc7820899d3234));
    if (isCustomIsFhsEnabled) throw new Error('A custom value for IsFhsEnabledContext has already been provided');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $75d67dd405790b85$export$79cc7820899d3234).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9gVcn.IsFhsEnabledContext).Provider, {
            value: value,
            children: children
        })
    });
};



var $eK5zz = parcelRequire("eK5zz");

/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $dEIJ1 = parcelRequire("dEIJ1");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");


var $8jREP = parcelRequire("8jREP");


var $dGAIk = parcelRequire("dGAIk");


var $bgZhH = parcelRequire("bgZhH");

const $f0df34b67538a54c$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat",
    fullHeightSidebar: "_1pby11wp"
}; /**
    * The banner layout area. It will always be displayed at the top of the screen.
    *
    * Should be used to render a `Banner` component from `@atlaskit/banner`.
    */ 
function $f0df34b67538a54c$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = 48, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)(); /**
                                           * Don't show the skip link if the slot has 0 height.
                                           */ 
    (0, $dEIJ1.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $gMc0m.default)([
            $f0df34b67538a54c$var$styles.root,
            isFhsEnabled && $f0df34b67538a54c$var$styles.fullHeightSidebar,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.HoistCssVarToLocalGrid), {
                variableName: (0, $K0HEo.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}



var $1imNS = parcelRequire("1imNS");


var $82dFP = parcelRequire("82dFP");


var $58PBI = parcelRequire("58PBI");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7xVCs = parcelRequire("7xVCs");


var $jmjWc = parcelRequire("jmjWc");


const $e36ff8521eaa3fdf$export$f316edcbf748c37b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bTjE2",
    name: "BannerContainer",
    loader: async ()=>(await (parcelRequire("3Rwpv"))).BannerContainer
});



var $hrAmX = parcelRequire("hrAmX");


var $cgsIj = parcelRequire("cgsIj");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $hZpML = parcelRequire("hZpML");





const $c9ec1f4c06aad517$export$23822a00be419508 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KYiA6",
    name: "GlobalComponentsLoader",
    loader: async ()=>(await (parcelRequire("1I5mg"))).GlobalComponents
});



var $3u0dr = parcelRequire("3u0dr");











var $dpPtd = parcelRequire("dpPtd");





var $bssir = parcelRequire("bssir");


var $6tLpM = parcelRequire("6tLpM");

var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");


var $gz8ZY = parcelRequire("gz8ZY");


var $h82at = parcelRequire("h82at");

const $36b11f7822ba6f88$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    panelSplitter: {
        id: "preview-panel-api.resize.label",
        defaultMessage: "Resize panel"
    }
});


const $2c25ef82052c394f$var$PreviewPanelSplitter = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const intl = (0, $1cfRh.default)();
    const { setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    let t0;
    if ($[0] !== setPanelWidth) {
        t0 = (t1)=>{
            const { finalWidth: finalWidth } = t1;
            setPanelWidth(finalWidth);
        };
        $[0] = setPanelWidth;
        $[1] = t0;
    } else t0 = $[1];
    const onResizeEnd = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onResizeEnd || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bssir.PanelSplitter), {
            label: t1,
            onResizeEnd: onResizeEnd
        });
        $[4] = onResizeEnd;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $1cfRh.default)();
    const { setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const onResizeEnd = (0, $42omo.useCallback)(({ finalWidth: finalWidth })=>{
        setPanelWidth(finalWidth);
    }, [
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bssir.PanelSplitter), {
        label: intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter),
        onResizeEnd: onResizeEnd
    });
};
const $2c25ef82052c394f$var$NavWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children, width: width } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eK5zz.Panel), {
            defaultWidth: width
        }, t1, children);
        $[1] = children;
        $[2] = width;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eK5zz.Panel), {
        defaultWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null), children);
const $2c25ef82052c394f$export$f143b4bd86d1e004 = (0, $3u0dr.isReactCompilerActiveV2)() ? function PreviewPanelContainer() {
    const $ = (0, $frIzR.c)(5);
    const panel = (0, $6tLpM.useCurrentPreviewPanel)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (!(0, $6mKj3.expValEquals)("confluence_preview_panels_exp", "isEnabled", true)) return null;
    if (!isNav4Enabled) return null;
    if (panel == null) return null;
    const { content: PanelContent, width: width } = panel;
    let t0;
    if ($[0] !== PanelContent) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PanelContent, null));
        $[0] = PanelContent;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0 || $[3] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$NavWrapper, {
            width: width
        }, t0);
        $[2] = t0;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function PreviewPanelContainer() {
    const panel = (0, $6tLpM.useCurrentPreviewPanel)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (!(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) return null;
    if (!isNav4Enabled) return null;
    if (panel == null) return null;
    const { content: PanelContent, width: width } = panel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$NavWrapper, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PanelContent, null)));
};










const $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zbjaW",
    name: "ObjectSidebarContent",
    loader: async ()=>(await (parcelRequire("ireve"))).ObjectSidebarContent
});



var $jvYFk = parcelRequire("jvYFk");


var $aWwYt = parcelRequire("aWwYt");


var $2vuKf = parcelRequire("2vuKf");


var $8zMP3 = parcelRequire("8zMP3");


var $fZAJP = parcelRequire("fZAJP");








var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $4l6Wo = parcelRequire("4l6Wo");

const $bd996ec529999f47$export$ac3e7903e24ee02d = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { view: view, children: children, navVersion: navVersion } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker || $[1] !== navVersion) {
        t1 = (name)=>experienceTracker.abort({
                name: name,
                reason: "navigation container view changed",
                attributes: {
                    navVersion: navVersion
                }
            });
        $[0] = experienceTracker;
        $[1] = navVersion;
        $[2] = t1;
    } else t1 = $[2];
    const abortExp = t1;
    let t2;
    if ($[3] !== experienceTracker || $[4] !== navVersion) {
        t2 = (name_0)=>experienceTracker.start({
                name: name_0,
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: navVersion
                }
            });
        $[3] = experienceTracker;
        $[4] = navVersion;
        $[5] = t2;
    } else t2 = $[5];
    const startExp = t2;
    let t3;
    let t4;
    if ($[6] !== abortExp || $[7] !== startExp || $[8] !== view) {
        t3 = ()=>{
            bb6: switch(view){
                case 0, $4l6Wo.CONTAINER_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $4l6Wo.PRODUCT_HOME_ID:
                case 0, $4l6Wo.PRODUCT_ADDONS_ID:
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $4l6Wo.ADMIN_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
            }
        };
        t4 = [
            view,
            startExp,
            abortExp
        ];
        $[6] = abortExp;
        $[7] = startExp;
        $[8] = view;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $42omo.useLayoutEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== startExp) {
        t5 = ()=>{
            startExp((0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE));
        };
        t6 = [
            startExp
        ];
        $[11] = startExp;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $42omo.useLayoutEffect)(t5, t6);
    let t7;
    if ($[14] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[14] = children;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
};














var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");




var $dcJ7R = parcelRequire("dcJ7R");










var $1fdQV = parcelRequire("1fdQV");

var $lxWrw = parcelRequire("lxWrw");

var $4hWZe = parcelRequire("4hWZe");

var $622t3 = parcelRequire("622t3");


var $fwDOR = parcelRequire("fwDOR");


var $1pSma = parcelRequire("1pSma");


var $1Sim2 = parcelRequire("1Sim2");


var $b3j2Y = parcelRequire("b3j2Y");





var $hSqtY = parcelRequire("hSqtY");


var $1uFM6 = parcelRequire("1uFM6");





var $8YePs = parcelRequire("8YePs");


var $7aRa9 = parcelRequire("7aRa9");


var $jFFx4 = parcelRequire("jFFx4");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $de2j9 = parcelRequire("de2j9");





const $f92bf53981932d65$export$347b3004b45f815 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "x9Mbz",
    name: "AdminNavigationLoader",
    loader: async ()=>(await (parcelRequire("5DPHR"))).AdminNavigation
});











var $hiS1z = parcelRequire("hiS1z");




var $6bJyJ = parcelRequire("6bJyJ");




var $1GzhS = parcelRequire("1GzhS");




var $kpYGL = parcelRequire("kpYGL");


var $7yDmn = parcelRequire("7yDmn");





var $7p8VW = parcelRequire("7p8VW");

var $c8gOp = parcelRequire("c8gOp");


var $9x2sR = parcelRequire("9x2sR");





var $dVkip = parcelRequire("dVkip");





var $iKskQ = parcelRequire("iKskQ");


var $bQm3c = parcelRequire("bQm3c");





var $hXDOc = parcelRequire("hXDOc");

const $38b2da651c37b412$var$StarredSpacesListComponent = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { flags: flags } = t0;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const intl = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { starredSpaces: starredSpaces, error: error, loading: loading } = (0, $dVkip.useStarredData)(isLicensed);
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = ()=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "fixedItem",
                itemId: "viewAllSpaces",
                section: "starredSpaces"
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const onViewAllClick = t1;
    let t2;
    if ($[2] !== createAnalyticsEvent) {
        t2 = (spaceId)=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "customItem",
                itemType: "space",
                itemId: spaceId,
                section: "starredSpaces"
            });
        };
        $[2] = createAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const onStarredSpaceItemClick = t2;
    let t3;
    let t4;
    if ($[4] !== error || $[5] !== flags || $[6] !== loading) {
        t3 = ()=>{
            if (!loading && error) flags.showErrorFlag({
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $38b2da651c37b412$var$i18n.errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $38b2da651c37b412$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
        };
        t4 = [
            loading,
            error,
            flags
        ];
        $[4] = error;
        $[5] = flags;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8gOp.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $38b2da651c37b412$var$i18n.title));
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== loading) {
        t6 = loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($38b2da651c37b412$var$LoadingSkeletons, null);
        $[10] = loading;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== intl || $[13] !== loading || $[14] !== starredSpaces) {
        t7 = !loading && starredSpaces.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.100",
            xcss: $38b2da651c37b412$var$emptySpacesTextStyles
        }, intl.formatMessage($38b2da651c37b412$var$i18n.empty));
        $[12] = intl;
        $[13] = loading;
        $[14] = starredSpaces;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== loading || $[17] !== onStarredSpaceItemClick || $[18] !== starredSpaces) {
        t8 = !loading && starredSpaces && starredSpaces.map((space)=>{
            const spaceAlias = space.alias || space.key;
            const url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                spaceKey: spaceAlias
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
                key: space.id,
                name: "starred-spaces",
                preloadUrl: url,
                preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                key: space.id,
                href: url,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
                    size: "xsmall",
                    src: space.icon?.path
                }),
                onClick: ()=>onStarredSpaceItemClick(space.id)
            }, space.name));
        });
        $[16] = loading;
        $[17] = onStarredSpaceItemClick;
        $[18] = starredSpaces;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== loading || $[21] !== onViewAllClick) {
        t9 = !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: (0, $1NBp8.SPACE_DIRECTORY).toUrl(),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onViewAllClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $38b2da651c37b412$var$i18n.viewAll));
        $[20] = loading;
        $[21] = onViewAllClick;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p8VW.MenuSection), null, t5, t6, t7, t8, t9);
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    return t10;
};
const $38b2da651c37b412$export$79ffca654f6ab234 = (0, $7aRa9.withFlags)($38b2da651c37b412$var$StarredSpacesListComponent);
const $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics = (createAnalyticsEvent, navVersion, options = {})=>{
    const { componentType: componentType, itemId: itemId, itemType: itemType, section: section } = options;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'spacesNavigationMenuItem',
            source: 'globalNavigation',
            attributes: {
                navigationLayer: 'global',
                navigationContainer: 'sidebar',
                navVersion: navVersion,
                componentType: componentType,
                itemId: itemId,
                itemType: itemType,
                section: section
            }
        }
    }).fire();
};
const $38b2da651c37b412$var$LoadingSkeletons = ()=>{
    const $ = (0, $frIzR.c)(1);
    const skeletonBorderRadius = (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? "var(--ds-radius-small, 4px)" : "3px";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlockStart: "space.075",
            paddingInlineStart: "space.075",
            testId: "loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $38b2da651c37b412$var$emptySpacesTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small'
});
const $38b2da651c37b412$var$i18n = (0, $h82at.defineMessages)({
    title: {
        id: "side-navigation.starred-spaces-list.title",
        defaultMessage: "Starred spaces"
    },
    viewAll: {
        id: "side-navigation.starred-spaces-list.view-all",
        defaultMessage: "View all spaces"
    },
    empty: {
        id: "side-navigation.starred-spaces-list.empty-message",
        defaultMessage: "Spaces you star will appear here"
    },
    errorFlagTitle: {
        id: "side-navigation.starred-spaces-list.error-flag-title",
        defaultMessage: "We couldn\u2019t load starred spaces"
    },
    errorFlagDescription: {
        id: "side-navigation.starred-spaces-list.error-flag-description",
        defaultMessage: "We are unable to show your spaces at this time. Refresh the page or try again."
    }
});






const $4ad4ea954990a797$export$9c64eb3c7e74d13c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zC56Y",
    loader: async ()=>(await (parcelRequire("lrHai"))).HubSettingsNavigation,
    name: 'HubSettingsNavigation'
});









var $jZM59 = parcelRequire("jZM59");














var $feuG2 = parcelRequire("feuG2");


var $cLo2u = parcelRequire("cLo2u");

const $5a5cd25c242b4596$var$SpaceAdminNavigationInternal = ()=>{
    const $ = (0, $frIzR.c)(13);
    const spaceAlias = (0, $cLo2u.useSpaceKey)();
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = (0, $jZM59.usePageLayoutResize)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { location: location, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const t0 = location?.pathname || "";
    let t1;
    if ($[0] !== matchRoute || $[1] !== t0) {
        t1 = matchRoute(t0);
        $[0] = matchRoute;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const route = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== isLeftSidebarCollapsed || $[5] !== route?.name) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "spaceAdminSideNavigation",
                    attributes: {
                        tab: route?.name || "",
                        isVisible: !isLeftSidebarCollapsed
                    }
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = isLeftSidebarCollapsed;
        $[5] = route?.name;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = route?.name;
    let t4;
    if ($[7] !== createAnalyticsEvent || $[8] !== isLeftSidebarCollapsed || $[9] !== t3) {
        t4 = [
            createAnalyticsEvent,
            isLeftSidebarCollapsed,
            t3
        ];
        $[7] = createAnalyticsEvent;
        $[8] = isLeftSidebarCollapsed;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    (0, $42omo.useEffect)(t2, t4);
    const t5 = spaceAlias || "";
    let t6;
    if ($[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsSideNavigation), {
            spaceAlias: t5
        });
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};
const $5a5cd25c242b4596$export$a5608b5e4da20698 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a5cd25c242b4596$var$SpaceAdminNavigationInternal, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};












var $io723 = parcelRequire("io723");


var $1uFsv = parcelRequire("1uFsv");


const $4ccde8579962336f$var$GlobalNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6E8ob",
    name: "GlobalNavigationLoader",
    loader: async ()=>(await (parcelRequire("kcly4"))).GlobalNavigationComponent
});
const $4ccde8579962336f$export$796d3395e4dcf32b = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ccde8579962336f$var$GlobalNavigationLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};



var $2qRJj = parcelRequire("2qRJj");


var $l65Bo = parcelRequire("l65Bo");


var $6GD8y = parcelRequire("6GD8y");


var $bflGB = parcelRequire("bflGB");


var $gnkil = parcelRequire("gnkil");





var $cEgMD = parcelRequire("cEgMD");


var $ep3mz = parcelRequire("ep3mz");


var $hQnHK = parcelRequire("hQnHK");








var $efvKr = parcelRequire("efvKr");


var $i8GdI = parcelRequire("i8GdI");


var $gsSsC = parcelRequire("gsSsC");


var $jMyy4 = parcelRequire("jMyy4");




const $da0a91219ee54603$export$b1d9964175452d0b = ({ spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $gsSsC.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skipQuery || !spaceKey
    });
    // For restricted spaces the preloader's query returns a 403 which Apollo evicts from
    // its cache. This leaves `useQueryInterop` in a perpetual `loading: true` state during
    // SSR, while on the client the same query resolves with `loading: false` and
    // `space: null`. The resulting mismatch causes a hydration error in the SideNav footer.
    //
    // The preloader detects this case and persists the space key in a global
    // (`__RESTRICTED_SPACES_FROM_PRELOAD__`). When present, we short-circuit here so both
    // SSR and client agree on `{ loading: false, isUserViewingSpaceAsAnon: false }`.
    if ((0, $6mKj3.expVal)('confluence_preload_user_viewing_space_as_anon', 'isEnabled', false)) {
        const restrictedSpaces = typeof window !== 'undefined' ? window.__RESTRICTED_SPACES_FROM_PRELOAD__ : globalThis.__RESTRICTED_SPACES_FROM_PRELOAD__;
        if (restrictedSpaces?.[spaceKey]) return {
            isUserViewingSpaceAsAnon: false,
            loading: false,
            error: undefined
        };
    }
    return {
        isUserViewingSpaceAsAnon: Boolean(data?.space?.currentUser?.isAnonymouslyAuthorized),
        loading: loading,
        error: error
    };
};



var $j2aYM = parcelRequire("j2aYM");


var $7Sm4c = parcelRequire("7Sm4c");













var $92JEG = parcelRequire("92JEG");


const $f542602a6e0f4176$export$4283c4ef2b834aa2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "USWMG",
    name: "Nav4CollapseReminderSpotlightLoader",
    loader: async ()=>(await (parcelRequire("4T2bk"))).Nav4CollapseReminderSpotlight
});



var $4q9NN = parcelRequire("4q9NN");


var $gEtAQ = parcelRequire("gEtAQ");


var $b0EGa = parcelRequire("b0EGa");











const $95859b7288e22ff6$var$PlatformNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xsgSo",
    name: "PlatformNavigationLoader",
    loader: async ()=>(await (parcelRequire("3sspZ"))).PlatformNavigationComponent
});
const $95859b7288e22ff6$export$446e292f3fdcabd = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95859b7288e22ff6$var$PlatformNavigationLoader, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};












var $i3jcY = parcelRequire("i3jcY");





var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");










const $e486084baed62696$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $e486084baed62696$export$7b73ec245f6c47f8 = ()=>{
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const showRecap2025QueryParam = $e486084baed62696$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isEditorPage;
    // Check if user has already collapsed the sidebar for recap before
    const hasCollapsedBefore = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED) === 'true';
    const shouldCollapse = isEligible && !hasCollapsedBefore;
    // Set the persisted flag when we determine we should collapse
    // This marks that the user has seen this behavior (first visit)
    (0, $42omo.useEffect)(()=>{
        if (shouldCollapse && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED, 'true');
    }, [
        shouldCollapse
    ]);
    return shouldCollapse;
};



var $e4o8D = parcelRequire("e4o8D");







const $1b5aa9dc12e56400$export$444990cc7caeb4e0 = 320;
const $1b5aa9dc12e56400$export$6deddaa54d32585b = ()=>{
    const $ = (0, $frIzR.c)(6);
    const shouldCollapseForRecap = (0, $e486084baed62696$export$7b73ec245f6c47f8)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = !userId;
    if ((0, $i3jcY.isStableUIEnabledForTests)()) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                initialCollapsedState: "expanded",
                initialWidth: $1b5aa9dc12e56400$export$444990cc7caeb4e0,
                shouldForceExpand: true,
                needsPostHydrationCollapse: false
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? "expanded";
        $[1] = t0;
    } else t0 = $[1];
    const persistedCollapseState = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH) || $1b5aa9dc12e56400$export$444990cc7caeb4e0;
        $[2] = t1;
    } else t1 = $[2];
    let persistedWidth = parseInt(t1, 10);
    if (Number.isNaN(persistedWidth)) persistedWidth = $1b5aa9dc12e56400$export$444990cc7caeb4e0;
    const isWidthTooLarge = persistedWidth > window.innerWidth;
    const fittedSidebarWidth = isWidthTooLarge ? $1b5aa9dc12e56400$export$444990cc7caeb4e0 : persistedWidth;
    if (isAnonymousUser && renderServerPlaceholder && (0, $6mKj3.expVal)("confluence_frontend_sidebar_hydration_fix", "isEnabled", false)) {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                initialCollapsedState: "expanded",
                initialWidth: fittedSidebarWidth,
                shouldForceExpand: false,
                needsPostHydrationCollapse: persistedCollapseState === "collapsed"
            };
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let initialCollapsedState;
    if (shouldCollapseForRecap) initialCollapsedState = "collapsed";
    else initialCollapsedState = persistedCollapseState;
    let t2;
    if ($[4] !== initialCollapsedState) {
        t2 = {
            initialCollapsedState: initialCollapsedState,
            initialWidth: fittedSidebarWidth,
            shouldForceExpand: false,
            needsPostHydrationCollapse: false
        };
        $[4] = initialCollapsedState;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};





// Paths
const $ba0a4d7f1b78ed67$export$4b542de2568592b5 = 'container/home/loading';
const $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae = 'container/home';
const $ba0a4d7f1b78ed67$export$c3f826fbea17177 = 'container/admin/home';
const $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b = 'container/admin/company-hub';
const $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1 = 'admin/home';
const $ba0a4d7f1b78ed67$export$823dfce5c2bceecb = 'product/home';


const $ad0ecba6dc7e91fa$export$ccd8c615ba434dec = ({ view: view })=>{
    const pageTreeUpdater = (0, $42omo.useRef)();
    const scrollTree = (0, $42omo.useCallback)(()=>{
        if (view === (0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae) && pageTreeUpdater.current) pageTreeUpdater.current.scrollToCurrentPage();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        view,
        pageTreeUpdater.current
    ]);
    return {
        pageTreeUpdater: pageTreeUpdater,
        scrollTree: scrollTree
    };
};




var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6be64d70b45c3bb0$var$initialState = {
    isCollapsed: false
};
const $6be64d70b45c3bb0$var$actions = {
    setIsCollapsed: (collapsed)=>({ setState: setState })=>{
            setState({
                isCollapsed: collapsed
            });
        }
};
const $6be64d70b45c3bb0$export$c0c3c6fb1b0fe561 = (0, $1P1Tu.createStore)({
    initialState: $6be64d70b45c3bb0$var$initialState,
    actions: $6be64d70b45c3bb0$var$actions
});
const $6be64d70b45c3bb0$export$7d924aef7db527f0 = (0, $9zUhf.createHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);
const $6be64d70b45c3bb0$export$ee6f665bc19ef05d = (0, $9zUhf.createActionsHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);


/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $lAJUP = parcelRequire("lAJUP");


var $keVvA = parcelRequire("keVvA");


var $141Kq = parcelRequire("141Kq");

// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























const $9f7a555e7f9dfa42$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("6yQVJ")),
    da: ()=>(parcelRequire("bzSID")),
    de: ()=>(parcelRequire("2FP6T")),
    'en-GB': ()=>(parcelRequire("25qh2")),
    'en-ZZ': ()=>(parcelRequire("3tbTt")),
    en: ()=>Promise.resolve((parcelRequire("141Kq"))),
    es: ()=>(parcelRequire("5HmEI")),
    fi: ()=>(parcelRequire("2JrHA")),
    fr: ()=>(parcelRequire("7K1vi")),
    hu: ()=>(parcelRequire("lvhk9")),
    it: ()=>(parcelRequire("dolI8")),
    ja: ()=>(parcelRequire("hqns1")),
    ko: ()=>(parcelRequire("1vs1T")),
    nb: ()=>(parcelRequire("BAT91")),
    nl: ()=>(parcelRequire("l079O")),
    pl: ()=>(parcelRequire("jEFBo")),
    'pt-BR': ()=>(parcelRequire("gTjoB")),
    ru: ()=>(parcelRequire("kq4sh")),
    sv: ()=>(parcelRequire("bbLxs")),
    th: ()=>(parcelRequire("gfPHN")),
    tr: ()=>(parcelRequire("gMTmr")),
    uk: ()=>(parcelRequire("6ZJsB")),
    vi: ()=>(parcelRequire("dDMw7")),
    zh_TW: ()=>(parcelRequire("bbzob")),
    zh: ()=>(parcelRequire("c4U6C"))
};


const $86f4c496838d0464$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $9f7a555e7f9dfa42$export$3770c7a7737d463c) ? locale : locale.replace(/-/g, '_') in (0, $9f7a555e7f9dfa42$export$3770c7a7737d463c) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $9f7a555e7f9dfa42$export$3770c7a7737d463c)[languageLocale]?.();
        return localeMessages?.default ?? (0, $141Kq.default);
    } catch (e) {
    // ignore
    }
    return 0, $141Kq.default;
};





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $cO1el = parcelRequire("cO1el");




var $5dK2X = parcelRequire("5dK2X");






const $45a6eb3a76009dad$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    errorStateHeading: {
        id: "navigation.global-invite.error-state-heading",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: "navigation.global-invite.error-state-description",
        defaultMessage: "Try refreshing the page or contact us if the problem persists."
    }
});


const $89f8b391742ea365$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $89f8b391742ea365$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $89f8b391742ea365$var$styles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "xsmall",
                children: formatMessage((0, $45a6eb3a76009dad$export$defe85febe8b728c).errorStateHeading)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $45a6eb3a76009dad$export$defe85febe8b728c).errorStateDescription)
            })
        ]
    });
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















var $6F6hl = parcelRequire("6F6hl");




const $527f6b7f46807211$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    loadingLabel: {
        id: "navigation.global-invite.loading-visually-hidden-label",
        defaultMessage: "Loading"
    }
});


const $1823c8a7ae00001a$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $1823c8a7ae00001a$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering"
        }, index));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1823c8a7ae00001a$var$styles,
        testId: "global-invite--loading-state",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $527f6b7f46807211$export$defe85febe8b728c).loadingLabel)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                space: "space.100",
                testId: "skeleton-group",
                children: items
            })
        ]
    });
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $7TH2w = parcelRequire("7TH2w");





var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $6xdDU = parcelRequire("6xdDU");

const $52241f5d84d6a74c$export$bb76aeb9f599715c = 'global-invite';
const $52241f5d84d6a74c$export$7622d28bacf170d1 = 'modal-dialog';
const $52241f5d84d6a74c$export$1dab7caa4b20a4cc = 'trigger-element';
const $52241f5d84d6a74c$export$85183a312807388d = 'navigation';


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 


parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");

function $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3({ product: product, children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        },
        children: children
    });
}





const $1fe379e53d021c39$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    modalDialogLabel: {
        id: "navigation.global-invite.modal-dialog-label",
        defaultMessage: "Invite people"
    }
});


function $b2599bb59f3b7568$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $52241f5d84d6a74c$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $1cfRh.default)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $42omo.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $42omo.useState)(false);
        const openModalDialog = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $52241f5d84d6a74c$export$85183a312807388d));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $42omo.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $52241f5d84d6a74c$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $52241f5d84d6a74c$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $42omo.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3), {
            product: props.product,
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                "data-testid": testId,
                children: [
                    TriggerElement ? /*#__PURE__*/ (0, $l998X.jsx)(TriggerElement, {
                        onClick: openModalDialog
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        shouldFitContainer: true,
                        onClick: openModalDialog,
                        testId: `${testId}--${(0, $52241f5d84d6a74c$export$1dab7caa4b20a4cc)}`,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                        children: isModalDialogOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                            width: "small",
                            shouldScrollInViewport: true,
                            shouldReturnFocus: true,
                            onClose: onCancel,
                            onOpenComplete: focusDialog,
                            label: formatMessage((0, $1fe379e53d021c39$export$defe85febe8b728c).modalDialogLabel),
                            testId: `${testId}--${(0, $52241f5d84d6a74c$export$7622d28bacf170d1)}`,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)(Content, {
                                    onAdminMenuItemClick: onAdminMenuItemClick,
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                })
                            })
                        }) : null
                    })
                ]
            })
        });
    };
}



const $824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6HUgO")).then((module)=>({
            default: module.ModalDialogContentWithRelayProvider
        })));
function $824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const modalContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $89f8b391742ea365$export$c1ed4f415b9e7023), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $1823c8a7ae00001a$export$62aa48085237e36f), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)($824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider, {
                ...props
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $141Kq.default),
        loaderFn: (0, $86f4c496838d0464$export$e4882a930a0d91f2),
        children: modalContent
    });
}
const $824f685f95a3a006$export$73b6b212789f5472 = (0, $b2599bb59f3b7568$export$2d7d84d397d9a585)($824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider);






var $cFYM0 = parcelRequire("cFYM0");


var $eGUIL = parcelRequire("eGUIL");




const $b524a1c7212bd91f$export$fc95973351613945 = ({ children: children })=>{
    const sideNavRef = (0, $42omo.useRef)(null);
    const handleScrollToTop = (0, $42omo.useCallback)(()=>{
        if (sideNavRef.current) sideNavRef.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        sideNavRef
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            sideNavRef: sideNavRef,
            handleScrollToTop: handleScrollToTop
        }), [
        sideNavRef,
        handleScrollToTop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eGUIL.SideNavigationContext).Provider, {
        value: contextValue
    }, (0, $9wGTI.fg)('navx-global-side-nav-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(children, {
        sideNavContentRef: sideNavRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cFYM0.SideNavBody), {
        testId: "side-navigation-content",
        ref: sideNavRef
    }, children));
};


const $b56ca6efd7e1c0fa$var$i18n = (0, $h82at.defineMessages)({
    dragHandle: {
        id: "page-layout.side-navigation.drag-handle",
        defaultMessage: "Side Navigation Drag Handle"
    },
    sideNavPanelSplitterTooltipContent: {
        id: "page-layout.side-navigation.side-nav-panel-splitter-tooltip-content",
        defaultMessage: "Double click to collapse"
    },
    globalInviteButtonLabel: {
        id: "page-layout.side-navigation.global-invite-button-label",
        defaultMessage: "Invite people"
    }
});
const $b56ca6efd7e1c0fa$var$resize = ()=>{
    window.dispatchEvent(new Event('resize'));
};
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onToggleFromShortcut: onToggleFromShortcut } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const toggleSideNav = (0, $622t3.useToggleSideNav)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    let t2;
    if ($[0] !== onToggleFromShortcut || $[1] !== toggleSideNav) {
        t2 = ()=>{
            if (!(0, $l65Bo.isDialogShown)()) {
                onToggleFromShortcut();
                toggleSideNav();
            }
        };
        $[0] = onToggleFromShortcut;
        $[1] = toggleSideNav;
        $[2] = t2;
    } else t2 = $[2];
    const toggle = t2;
    let t3;
    if ($[3] !== isLiveEditMode || $[4] !== isOnEditRoute || $[5] !== toggle) {
        t3 = isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            listener: toggle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            deprecatedAccelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
            listener: toggle
        });
        $[3] = isLiveEditMode;
        $[4] = isOnEditRoute;
        $[5] = toggle;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
/**
 * Used when full height sidebar (FHS) is enabled.
 * Uses the `Ctrl+[` shortcut that is built into the ADS navigation system, instead of Confluence's
 * own `Ctrl+[` shortcut (UNIVERSAL_SIDE_NAVIGATION_SHORTCUT).
 * But, we keep Confluence's `[` shortcut (SIDE_NAVIGATION_SHORTCUT) on non-edit routes, and display
 * an educational flag pointing to the new shortcut.
 */ const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS = (0, $7aRa9.withFlags)(({ flags: flags, onToggleFromShortcut: onToggleFromShortcut })=>{
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const toggleSideNav = (0, $622t3.useToggleSideNav)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const toggle = (0, $42omo.useCallback)(()=>{
        if (!(0, $l65Bo.isDialogShown)()) {
            onToggleFromShortcut();
            toggleSideNav();
            // Show the educational flag for the `Ctrl+[` shortcut, when the `[` shortcut is used.
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
                accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                deprecatedAccelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT)
            });
        }
    }, [
        flags,
        onToggleFromShortcut,
        toggleSideNav
    ]);
    if (isLiveEditMode || isOnEditRoute) // Edit routes will still have the side nav shortcut that is built into the ADS SideNav component.
    return null;
    // Non-edit routes still have the `[` shortcut, which will eventually be deprecated.
    // An educational flag is shown during the transition process.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
        listener: toggle
    });
});
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutWithFG = (0, $8YePs.componentWithCondition)(()=>(0, $8zs3p.useIsFhsEnabled)(), $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS, $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut);
// When full height sidebar is enabled, the SideNavPanelSplitter component should be used.
// It supports double clicking to collapse the side nav.
const $b56ca6efd7e1c0fa$var$PanelSplitterWithFG = (0, $8YePs.componentWithCondition)(()=>(0, $8zs3p.useIsFhsEnabled)(), (0, $4hWZe.SideNavPanelSplitter), (0, $bssir.PanelSplitter));
const $b56ca6efd7e1c0fa$var$useIsModeGlobal = ()=>{
    const $ = (0, $frIzR.c)(3);
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== match?.query?.mode || $[1] !== spaceKey) {
        t0 = match?.query?.mode === "global" || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[0] = match?.query?.mode;
        $[1] = spaceKey;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
//todo: are all these views still relevant? I'm not certain they are
const $b56ca6efd7e1c0fa$var$getProductSideNavigation = (view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, unhandledError, isLicensed)=>{
    // hide product nav if mode=global unless we're on a settings page
    if (isModeGlobal && !isOnAnySettingsScreen) return null;
    switch(view){
        case 0, $ba0a4d7f1b78ed67$export$4b542de2568592b5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null);
        case 0, $ba0a4d7f1b78ed67$export$c3f826fbea17177:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a5cd25c242b4596$export$a5608b5e4da20698), null);
        case 0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ad4ea954990a797$export$9c64eb3c7e74d13c), null);
        case 0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f92bf53981932d65$export$347b3004b45f815), null);
        case 0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2qRJj.SpaceNavigation), {
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                ...unhandledError && {
                    unhandledError: unhandledError
                },
                isBlogNavigation: (0, $gEtAQ.isBlogPage)()
            });
        default:
            return isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38b2da651c37b412$export$79ffca654f6ab234), null) : null;
    }
};
const $b56ca6efd7e1c0fa$var$PlatformNavigationInner = (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd } = t0;
    let t1;
    if ($[0] !== view) {
        t1 = {
            view: view
        };
        $[0] = view;
        $[1] = t1;
    } else t1 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t1);
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const t2 = spaceKey || "";
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t3);
    let t4;
    if ($[4] !== anonymousAccessQueryError || $[5] !== isLicensed || $[6] !== isModeGlobal || $[7] !== isOnAnySettingsScreen || $[8] !== isSpaceSettingsScreen || $[9] !== view) {
        t4 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[4] = anonymousAccessQueryError;
        $[5] = isLicensed;
        $[6] = isModeGlobal;
        $[7] = isOnAnySettingsScreen;
        $[8] = isSpaceSettingsScreen;
        $[9] = view;
        $[10] = t4;
    } else t4 = $[10];
    const productSideNavigation = t4;
    let t5;
    if ($[11] !== anonymousAccessQueryError || $[12] !== anonymousAccessQueryLoading || $[13] !== isUserViewingSpaceAsAnon) {
        t5 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i8GdI.AnonymousAccessSideNavMessage), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[11] = anonymousAccessQueryError;
        $[12] = anonymousAccessQueryLoading;
        $[13] = isUserViewingSpaceAsAnon;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== productSideNavigation || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, productSideNavigation, t5);
        $[15] = productSideNavigation;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== isOnAnySettingsScreen || $[19] !== onCollapse || $[20] !== onExpand || $[21] !== onPeekEnd || $[22] !== onPeekStart || $[23] !== scrollTree || $[24] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "side-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95859b7288e22ff6$export$446e292f3fdcabd), {
            content: t6,
            hideGSN: isOnAnySettingsScreen,
            scrollTreeToCurrent: scrollTree,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd
        })));
        $[18] = isOnAnySettingsScreen;
        $[19] = onCollapse;
        $[20] = onExpand;
        $[21] = onPeekEnd;
        $[22] = onPeekStart;
        $[23] = scrollTree;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    return t7;
};
const $b56ca6efd7e1c0fa$export$440c2b67033b2fbd = (t0)=>{
    const $ = (0, $frIzR.c)(63);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, setTriggeredByShortcut: setTriggeredByShortcut } = t0;
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const intl = (0, $1cfRh.default)();
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth, shouldForceExpand: shouldForceExpand, needsPostHydrationCollapse: needsPostHydrationCollapse } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jFFx4.useSettingsBackButtonUtils)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const toggleSideNav = (0, $622t3.useToggleSideNav)();
    let t1;
    let t2;
    if ($[0] !== needsPostHydrationCollapse || $[1] !== toggleSideNav) {
        t1 = ()=>{
            if (needsPostHydrationCollapse) toggleSideNav();
        };
        t2 = [
            needsPostHydrationCollapse,
            toggleSideNav
        ];
        $[0] = needsPostHydrationCollapse;
        $[1] = toggleSideNav;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    const pressTracing = (0, $1pSma.default)("side-nav-collapse-reminder-spotlight");
    const t3 = spaceKey || "";
    let t4;
    if ($[4] !== t3) {
        t4 = {
            spaceKey: t3
        };
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t4);
    const [t5] = (0, $6be64d70b45c3bb0$export$7d924aef7db527f0)();
    const { isCollapsed: isCollapsed } = t5;
    let t6;
    if ($[6] !== anonymousAccessQueryError || $[7] !== isLicensed || $[8] !== isModeGlobal || $[9] !== isOnAnySettingsScreen || $[10] !== isSpaceSettingsScreen || $[11] !== view) {
        t6 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[6] = anonymousAccessQueryError;
        $[7] = isLicensed;
        $[8] = isModeGlobal;
        $[9] = isOnAnySettingsScreen;
        $[10] = isSpaceSettingsScreen;
        $[11] = view;
        $[12] = t6;
    } else t6 = $[12];
    const productSideNavigation = t6;
    let t7;
    if ($[13] !== createAnalyticsEvent) {
        t7 = (t8)=>{
            const { initialWidth: initialWidth_0, finalWidth: finalWidth } = t8;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "resized",
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        initialWidth: initialWidth_0,
                        finalWidth: finalWidth
                    }
                }
            }).fire();
        };
        $[13] = createAnalyticsEvent;
        $[14] = t7;
    } else t7 = $[14];
    const fireSidebarResizeEndAnalytics = t7;
    let t8;
    if ($[15] !== setTriggeredByShortcut) {
        t8 = ()=>{
            setTriggeredByShortcut(true);
        };
        $[15] = setTriggeredByShortcut;
        $[16] = t8;
    } else t8 = $[16];
    const handleToggleFromShortcut = t8;
    if (!isPageWithinSpaceSettings && !isPageWithinSiteSettings && !isHubSettingsScreen) saveCurrentRoute();
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $92JEG.useHasDismissedNav4CollapseReminderSpotlight)();
    const canToggleWithShortcut = $b56ca6efd7e1c0fa$var$_temp;
    const t9 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
            errorBoundaryId: "sideNavigation-globalNavigation"
        };
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== isCollapsed || $[19] !== isOnAnySettingsScreen || $[20] !== productSideNavigation) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ccde8579962336f$export$796d3395e4dcf32b), {
            productSideNavigation: productSideNavigation,
            isOnAnySettingsScreen: isOnAnySettingsScreen,
            isCollapsed: isCollapsed
        }));
        $[18] = isCollapsed;
        $[19] = isOnAnySettingsScreen;
        $[20] = productSideNavigation;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== isNav4CollapseReminderSpotlightActive || $[23] !== setIsNav4CollapseReminderSpotlightActive) {
        t12 = isNav4CollapseReminderSpotlightActive && setIsNav4CollapseReminderSpotlightActive && !(0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f542602a6e0f4176$export$4283c4ef2b834aa2), {
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[22] = isNav4CollapseReminderSpotlightActive;
        $[23] = setIsNav4CollapseReminderSpotlightActive;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== handleToggleFromShortcut || $[26] !== shouldForceExpand) {
        t13 = !shouldForceExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutWithFG, {
            onToggleFromShortcut: handleToggleFromShortcut
        });
        $[25] = handleToggleFromShortcut;
        $[26] = shouldForceExpand;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== fireSidebarResizeEndAnalytics || $[29] !== isNav4CollapseReminderSpotlightActive || $[30] !== isNav4CollapseReminderSpotlightDismissed || $[31] !== pressTracing || $[32] !== setIsNav4CollapseReminderSpotlightActive) {
        t14 = (t15)=>{
            const { initialWidth: initialWidth_1, finalWidth: finalWidth_0 } = t15;
            $b56ca6efd7e1c0fa$var$handleResizeEnd({
                finalWidth: finalWidth_0,
                eligibleForCollapseReminderSpotlight: !isNav4CollapseReminderSpotlightActive && !isNav4CollapseReminderSpotlightDismissed,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                pressTracing: pressTracing
            });
            fireSidebarResizeEndAnalytics({
                initialWidth: initialWidth_1,
                finalWidth: finalWidth_0
            });
        };
        $[28] = fireSidebarResizeEndAnalytics;
        $[29] = isNav4CollapseReminderSpotlightActive;
        $[30] = isNav4CollapseReminderSpotlightDismissed;
        $[31] = pressTracing;
        $[32] = setIsNav4CollapseReminderSpotlightActive;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== intl) {
        t15 = intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.dragHandle);
        $[34] = intl;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== intl || $[37] !== isFhsEnabled) {
        t16 = isFhsEnabled ? intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.sideNavPanelSplitterTooltipContent) : undefined;
        $[36] = intl;
        $[37] = isFhsEnabled;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== t14 || $[40] !== t15 || $[41] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$PanelSplitterWithFG, {
            onResizeEnd: t14,
            onResizeStart: $b56ca6efd7e1c0fa$var$onResizeStart,
            label: t15,
            testId: "side-navigation-panel-splitter",
            tooltipContent: t16
        });
        $[39] = t14;
        $[40] = t15;
        $[41] = t16;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== t11 || $[44] !== t12 || $[45] !== t13 || $[46] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, t11, t12, t13, t17);
        $[43] = t11;
        $[44] = t12;
        $[45] = t13;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    let t19;
    if ($[48] !== anonymousAccessQueryError || $[49] !== anonymousAccessQueryLoading || $[50] !== isUserViewingSpaceAsAnon) {
        t19 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i8GdI.AnonymousAccessSideNavMessage), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[48] = anonymousAccessQueryError;
        $[49] = anonymousAccessQueryLoading;
        $[50] = isUserViewingSpaceAsAnon;
        $[51] = t19;
    } else t19 = $[51];
    let t20;
    if ($[52] !== t18 || $[53] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "side-nav"
        }, t18, t19);
        $[52] = t18;
        $[53] = t19;
        $[54] = t20;
    } else t20 = $[54];
    let t21;
    if ($[55] !== initialWidth || $[56] !== onCollapse || $[57] !== onExpand || $[58] !== onPeekEnd || $[59] !== onPeekStart || $[60] !== t20 || $[61] !== t9) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1fdQV.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t9,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: "side-navigation",
            canToggleWithShortcut: canToggleWithShortcut
        }, t20);
        $[55] = initialWidth;
        $[56] = onCollapse;
        $[57] = onExpand;
        $[58] = onPeekEnd;
        $[59] = onPeekStart;
        $[60] = t20;
        $[61] = t9;
        $[62] = t21;
    } else t21 = $[62];
    return t21;
};
const $b56ca6efd7e1c0fa$var$SideNavigationSkeleton = ()=>{
    const $ = (0, $frIzR.c)(5);
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $6mKj3.expVal)("confluence_frontend_side_nav_ufohold", "isEnabled", false);
        $[0] = t0;
    } else t0 = $[0];
    const t1 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "side-nav-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null)));
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== initialWidth || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            hold: t0,
            name: "side-navigation-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1fdQV.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t1,
            id: "side-navigation-skeleton"
        }, t2));
        $[2] = initialWidth;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
const $b56ca6efd7e1c0fa$export$cc4f63927c41742f = (props)=>{
    const $ = (0, $frIzR.c)(27);
    const { setIsCollapsed: setIsCollapsed } = (0, $6be64d70b45c3bb0$export$ee6f665bc19ef05d)();
    const [triggeredByShortcut, setTriggeredByShortcut] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] !== props.view) {
        t0 = {
            view: props.view
        };
        $[0] = props.view;
        $[1] = t0;
    } else t0 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t0);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOnEditRoute) {
        t1 = (action, triggeredBy)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        isOnEditRoute: isOnEditRoute,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = isOnEditRoute;
        $[4] = t1;
    } else t1 = $[4];
    const fireSidebarToggleAnalytics = t1;
    let t2;
    if ($[5] !== fireSidebarToggleAnalytics || $[6] !== setIsCollapsed || $[7] !== triggeredByShortcut) {
        t2 = ()=>{
            if (!(0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                setIsCollapsed(true);
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "collapsed");
            }
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("collapsed", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[5] = fireSidebarToggleAnalytics;
        $[6] = setIsCollapsed;
        $[7] = triggeredByShortcut;
        $[8] = t2;
    } else t2 = $[8];
    const onCollapse = t2;
    let t3;
    if ($[9] !== fireSidebarToggleAnalytics || $[10] !== scrollTree || $[11] !== setIsCollapsed || $[12] !== triggeredByShortcut) {
        t3 = ()=>{
            if (!(0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                setIsCollapsed(false);
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "expanded");
            }
            scrollTree();
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("expanded", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[9] = fireSidebarToggleAnalytics;
        $[10] = scrollTree;
        $[11] = setIsCollapsed;
        $[12] = triggeredByShortcut;
        $[13] = t3;
    } else t3 = $[13];
    const onExpand = t3;
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    let t4;
    if ($[14] !== requestHideOmniBar) {
        t4 = ()=>{
            if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) requestHideOmniBar();
        };
        $[14] = requestHideOmniBar;
        $[15] = t4;
    } else t4 = $[15];
    const onPeekStart = t4;
    let t5;
    if ($[16] !== releaseHideOmniBar) {
        t5 = ()=>{
            if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) releaseHideOmniBar();
        };
        $[16] = releaseHideOmniBar;
        $[17] = t5;
    } else t5 = $[17];
    const onPeekEnd = t5;
    let t6;
    let t7;
    if ($[18] !== releaseHideOmniBar) {
        t6 = ()=>()=>{
                if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) releaseHideOmniBar();
            };
        t7 = [
            releaseHideOmniBar
        ];
        $[18] = releaseHideOmniBar;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[21] !== onCollapse || $[22] !== onExpand || $[23] !== onPeekEnd || $[24] !== onPeekStart || $[25] !== props) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "platform-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$PlatformNavigationInner, {
            view: props.view,
            isSpaceSettingsScreen: props.isSpaceSettingsScreen,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "side-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$export$440c2b67033b2fbd, {
            ...props,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            setTriggeredByShortcut: setTriggeredByShortcut
        })));
        $[21] = onCollapse;
        $[22] = onExpand;
        $[23] = onPeekEnd;
        $[24] = onPeekStart;
        $[25] = props;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
};
const $b56ca6efd7e1c0fa$var$getSideNavContent = ()=>{
    if (!(0, $9wGTI.fg)('post-office-connie-side-nav-killswitch')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sim2.PostOfficeConfluenceSideNavPlacement), null);
};
const $b56ca6efd7e1c0fa$var$SideNavFooterWrapped = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, $b56ca6efd7e1c0fa$var$getSideNavContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b56ca6efd7e1c0fa$var$globalInviteButtonStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $1cfRh.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b56ca6efd7e1c0fa$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $824f685f95a3a006$export$73b6b212789f5472), {
        product: "confluence",
        showFlag: flags.showFlag
    }, intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.globalInviteButtonLabel))));
});
const $b56ca6efd7e1c0fa$var$SideNavFooterContent = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { error: error, loading: loading, isEligible: isEligible } = (0, $j2aYM.usePersistentInviteButtonEligible)();
    if (loading) return null;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else {
            let t0;
            if ($[0] !== error) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                $[0] = error;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        }
    }
    let t0;
    if ($[2] !== isEligible) {
        t0 = isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxWrw.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent, null)));
        $[2] = isEligible;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
// CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
// Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
const $b56ca6efd7e1c0fa$var$onResizeStart = ()=>{
    document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.setProperty('pointer-events', 'none');
};
const $b56ca6efd7e1c0fa$var$handleResizeEnd = ({ finalWidth: finalWidth, eligibleForCollapseReminderSpotlight: eligibleForCollapseReminderSpotlight, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, pressTracing: pressTracing })=>{
    // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
    // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
    document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.removeProperty('pointer-events');
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH, finalWidth);
    if (eligibleForCollapseReminderSpotlight) {
        if ((0, $6mKj3.expVal)('confluence_frontend_nav_spotlight_press_tracing', 'isEnabled', false)) pressTracing();
        setIsNav4CollapseReminderSpotlightActive?.(true);
    }
};
function $b56ca6efd7e1c0fa$var$_temp() {
    return !(0, $l65Bo.isDialogShown)();
}




var $lpfM9 = parcelRequire("lpfM9");




const $5fff77e1c664da88$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    TopNav: {
        id: "page-layout.top.nav",
        defaultMessage: "Confluence navigation"
    },
    Banner: {
        id: "page-layout.banner",
        defaultMessage: "Banner"
    },
    SideNav: {
        id: "page-layout.side.nav",
        defaultMessage: "Side navigation"
    },
    Main: {
        id: "page-layout.main",
        defaultMessage: "Page"
    },
    SkipLinks: {
        id: "page-layout.skip.links",
        defaultMessage: "Jump to"
    }
});











var $7sObp = parcelRequire("7sObp");

// dimension vars
const $dac9c5585e9f3574$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $dac9c5585e9f3574$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $dac9c5585e9f3574$export$c103b605cd368aed = 'rightSidebarWidth';
const $dac9c5585e9f3574$export$fa34f417972d6341 = 'rightPanelWidth';
const $dac9c5585e9f3574$export$3a6a779d9181047c = 'topNavigationHeight';
const $dac9c5585e9f3574$export$bcd94a6a792e7f96 = 'bannerHeight';
const $dac9c5585e9f3574$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $dac9c5585e9f3574$export$344062f7cfc9528e = 'left-panel';
const $dac9c5585e9f3574$export$c7139cc2d6110b5f = 'right-panel';
const $dac9c5585e9f3574$export$238d30785c4bca84 = 'banner';
const $dac9c5585e9f3574$export$bec6dca2e63de4ae = 'top-navigation';
const $dac9c5585e9f3574$export$d1213e82613ff4df = 'content';
const $dac9c5585e9f3574$export$be83e7118304b28e = 56;
const $dac9c5585e9f3574$export$4a98ee0bd1ae362 = 56;
const $dac9c5585e9f3574$export$539e68c09584883a = 240;
const $dac9c5585e9f3574$export$b92df8810d2fcd01 = 280;
const $dac9c5585e9f3574$export$c3e41153b9288bcf = 368;
const $dac9c5585e9f3574$export$c4d6152f86ea28f6 = 368;
const $dac9c5585e9f3574$export$46acf8758e9e2636 = 20;
const $dac9c5585e9f3574$export$70740f5ad8360a78 = 16;
const $dac9c5585e9f3574$export$991d5285ad765a3d = 240;
const $dac9c5585e9f3574$export$6949d4f32b161684 = 200;
const $dac9c5585e9f3574$export$d6e7e8af042815bb = 350;
const $dac9c5585e9f3574$export$3749e1104328fde4 = 300;
const $dac9c5585e9f3574$export$1074d925b0b82be5 = 200;
const $dac9c5585e9f3574$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $dac9c5585e9f3574$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $dac9c5585e9f3574$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $dac9c5585e9f3574$export$70c702a8c5895f03 = 'data-grab-area-line';
const $dac9c5585e9f3574$export$48a43f91e4becf4e = 'data-grab-area';
const $dac9c5585e9f3574$export$dac2fb31a9f6844d = 'data-resize-button';
const $dac9c5585e9f3574$export$9ecd22db14e6c70e = 'data-resize-control';
const $dac9c5585e9f3574$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $dac9c5585e9f3574$export$206a08f7f8beb554 = 'Skip to:';
const $dac9c5585e9f3574$export$659ee746b31b360d = 'data-layout-container';
const $dac9c5585e9f3574$export$f963aecf2d4465bd = `var(--${$dac9c5585e9f3574$export$cbfb0f5b2869b17b}, 0px)`;
const $dac9c5585e9f3574$export$750459958906793 = `var(--${$dac9c5585e9f3574$export$fa34f417972d6341}, 0px)`;
const $dac9c5585e9f3574$export$f897e1ed9f8ed251 = `var(--${$dac9c5585e9f3574$export$a30f2e00489a8957}, 0px)`;
const $dac9c5585e9f3574$export$b44ab66843c05a69 = `var(--${$dac9c5585e9f3574$export$c103b605cd368aed}, 0px)`;
const $dac9c5585e9f3574$export$aeff86a16f13529 = `var(--${$dac9c5585e9f3574$export$3a6a779d9181047c}, 0px)`;
const $dac9c5585e9f3574$export$ed7cc0d417ee89e = `var(--${$dac9c5585e9f3574$export$bcd94a6a792e7f96}, 0px)`;
const $dac9c5585e9f3574$export$d2fa14f05b61e66 = `var(--${$dac9c5585e9f3574$export$b6744d31294864fd}, ${$dac9c5585e9f3574$export$991d5285ad765a3d}px)`;





const $234a7212b3053f5f$export$f6b09748eb1e2d30 = 'data-main-content';
const $234a7212b3053f5f$export$2306961d40008e49 = 'data-flex-container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
const $234a7212b3053f5f$export$712225703044cda = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showBreadcrumbNavHeader: showBreadcrumbNavHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1bgi _c3a01fl4 _1u5916n6 _2iuc1fl4 _ylxn1v5u _moiv16n6",
            __cmplp.showBreadcrumbNavHeader ? "_17gl1wqb" : "_17glidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $234a7212b3053f5f$export$6bdda512681a5774 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { zIndex: zIndex, showQuickStart: showQuickStart, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, $7sObp.default)(__cmplp.zIndex)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1pby1fcb _e1qhidpf",
                __cmplp.showQuickStart ? "_1e0c1ule" : "_1e0cglyw",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // This uses CCS variables from atlaskit/page-layout to make sure
const $234a7212b3053f5f$export$d1bb8697b964b9c = `
#ui-global-sidebar-section {
	z-index: auto !important;
	width: 100%;
}

[${$234a7212b3053f5f$export$f6b09748eb1e2d30}], [${$234a7212b3053f5f$export$2306961d40008e49}] {
	width: calc(
		100% - ${(0, $dac9c5585e9f3574$export$f963aecf2d4465bd)} - ${(0, $dac9c5585e9f3574$export$f897e1ed9f8ed251)} - ${(0, $dac9c5585e9f3574$export$750459958906793)} -
			${(0, $dac9c5585e9f3574$export$b44ab66843c05a69)}
	) !important;
	position: absolute;
	left: calc(${(0, $dac9c5585e9f3574$export$f963aecf2d4465bd)} + ${(0, $dac9c5585e9f3574$export$f897e1ed9f8ed251)});
	z-index: auto;
	box-sizing: border-box;
	bottom: 0px;
	overflow: auto;

	&#admin-content {
		/* admin nav -> manage apps */
		.upm-manage {
			#upm-manage-type, /* app type dropdown filter */
		.upm-details .upm-plugin-info .upm-column {
				/* expand accordion to show app detail -> 3 column info table */
				z-index: 1;
			}
		}
	}
}
[${$234a7212b3053f5f$export$2306961d40008e49}] > [${$234a7212b3053f5f$export$f6b09748eb1e2d30}] {
	display: none;
}

/* add overflow scrolling to ssred pages with heights longer than side navigation */
[${$234a7212b3053f5f$export$2306961d40008e49}] > main#main.aui-page-panel {
	overflow: hidden;
	overflow-y: auto;
	height: calc(100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px);
	min-height: calc(
		100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px
	); /* for responsiveness in small height windows */
}
`;
const $234a7212b3053f5f$export$1f9daac55b336da8 = `
#ui-global-sidebar-section {
	z-index: auto !important;
	width: 100%;
}

[${$234a7212b3053f5f$export$f6b09748eb1e2d30}], [${$234a7212b3053f5f$export$2306961d40008e49}] {
	width: calc(
		100% - ${(0, $dac9c5585e9f3574$export$f963aecf2d4465bd)} - ${(0, $dac9c5585e9f3574$export$f897e1ed9f8ed251)} - ${(0, $dac9c5585e9f3574$export$750459958906793)} -
			${(0, $dac9c5585e9f3574$export$b44ab66843c05a69)}
	) !important;
	position: absolute;
	left: calc(${(0, $dac9c5585e9f3574$export$f963aecf2d4465bd)} + ${(0, $dac9c5585e9f3574$export$f897e1ed9f8ed251)});
	z-index: auto;
	box-sizing: border-box;
	bottom: 0px;
	overflow: auto;
	top: ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)};

	&#admin-content {
		/* admin nav -> manage apps */
		.upm-manage {
			#upm-manage-type, /* app type dropdown filter */
		.upm-details .upm-plugin-info .upm-column {
				/* expand accordion to show app detail -> 3 column info table */
				z-index: 1;
			}
		}
	}
}
[${$234a7212b3053f5f$export$2306961d40008e49}] > [${$234a7212b3053f5f$export$f6b09748eb1e2d30}] {
	display: none;
}

/* add overflow scrolling to ssred pages with heights longer than side navigation */
[${$234a7212b3053f5f$export$2306961d40008e49}] > main#main.aui-page-panel {
	overflow: hidden;
	overflow-y: auto;
	height: calc(100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px);
	min-height: calc(
		100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px
	); /* for responsiveness in small height windows */
}
`;
const $234a7212b3053f5f$export$191b652ca0b16b3f = `
	/* CSS hack for code block */
	.code-block.right-shadow {
		z-index: 2;
	}
	/* CSS hack for noPrint */
	[data-ds--page-layout--slot='top-navigation'],
	[data-ds--page-layout--slot='left-sidebar'] {
		@media print {
			display: none !important;
		}
	}
	/* To make sure we are using the same font family set by atlassian-frontend theme. */
	.PageContent {
		font-family: ${"var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
	/* To remove cls from more action dropdown */
	[data-testid='content-tools-dropdown-menu--content'] {
		width: 220px;
	}

	/* CSS hack to override batch CSS h3 styling for account menu */
	[data-testid='confluence-account-menu--content--details--name'] {
		font: ${"var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
`;
const $234a7212b3053f5f$export$fd1a59daeb9a7e85 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3i1osq _1bsb1osq _10pb1osq _9m3z1osq _16tepfqs",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});




var $JEZ6P = parcelRequire("JEZ6P");








var $8Hyz1 = parcelRequire("8Hyz1");


var $jln20 = parcelRequire("jln20");


var $cLgYq = parcelRequire("cLgYq");





var $jNGt9 = parcelRequire("jNGt9");











var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");








var $2Qxf3 = parcelRequire("2Qxf3");




const $37d6b5f846525abd$export$f43ff4d4aa562c2f = ()=>{
    const { fireOperationalAnalytic: fireOperationalAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    (0, $42omo.useEffect)(()=>{
        (0, $2Qxf3.setOnFetchComplete)((metrics)=>{
            fireOperationalAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).SNIPPETS,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FETCHED,
                attributes: metrics
            });
        });
        return ()=>(0, $2Qxf3.setOnFetchComplete)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



var $cYuYM = parcelRequire("cYuYM");


var $5vi32 = parcelRequire("5vi32");


var $dZUkS = parcelRequire("dZUkS");

const $326f6c6e797b3c09$export$607850563f346b34 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    (0, $37d6b5f846525abd$export$f43ff4d4aa562c2f)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isSnippetCreateEnabled = (0, $cYuYM.useIsSnippetCreateEnabled)();
    let t1;
    let t2;
    if ($[0] !== fireFailedAnalytic || $[1] !== isEmbeddedConfluence || $[2] !== isSnippetCreateEnabled || $[3] !== snippetsActions) {
        t1 = ()=>{
            if (!(0, $6mKj3.expVal)("cc_snippets", "isEnabled", false)) return;
            if (isEmbeddedConfluence && !isSnippetCreateEnabled) return;
            snippetsActions.fetchSnippets().catch(()=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH, {});
            });
        };
        t2 = [
            snippetsActions,
            fireFailedAnalytic,
            isEmbeddedConfluence,
            isSnippetCreateEnabled
        ];
        $[0] = fireFailedAnalytic;
        $[1] = isEmbeddedConfluence;
        $[2] = isSnippetCreateEnabled;
        $[3] = snippetsActions;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[6] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[6] = children;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};



var $laFNM = parcelRequire("laFNM");

const $e33908ef21162ab8$export$968a8c4aa27e5f45 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cLgYq.InProductHelpProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $326f6c6e797b3c09$export$607850563f346b34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $laFNM.ApprovalsProvider), null, children)));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("cc-engagement-getting-started-nth-user-gate") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jNGt9.NthUserOnboardingFlag), null);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Hyz1.PostOfficeSideNavMessageProvider), null, t1, t2));
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};


const $ba2ff1d1fd865be7$var$TOP_NAV_HEIGHT = 48;
const $ba2ff1d1fd865be7$var$isRoute = (pathname, route)=>Boolean(route.match(pathname || ''));
const $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav = [
    (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST),
    (0, $1NBp8.SPACE_PAGES),
    (0, $1NBp8.SPACE_CALENDARS),
    (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW),
    (0, $1NBp8.SPACE_QUESTIONS)
];
const $ba2ff1d1fd865be7$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader } = t0;
    let t1;
    if ($[0] !== children || $[1] !== editorPreloader || $[2] !== isSpaceSettingsScreen || $[3] !== standalone || $[4] !== view) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba2ff1d1fd865be7$export$f94607b1528a8807, {
            children: children,
            view: view,
            standalone: standalone,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            editorPreloader: editorPreloader
        }));
        $[0] = children;
        $[1] = editorPreloader;
        $[2] = isSpaceSettingsScreen;
        $[3] = standalone;
        $[4] = view;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
});
const $ba2ff1d1fd865be7$export$f94607b1528a8807 = (t0)=>{
    const $ = (0, $frIzR.c)(41);
    const { children: children, view: view, standalone: standalone, isSpaceSettingsScreen: t1, editorPreloader: t2 } = t0;
    const isSpaceSettingsScreen = t1 === undefined ? false : t1;
    const editorPreloader = t2 === undefined ? $ba2ff1d1fd865be7$var$noopEditorPreloader : t2;
    let t3;
    if ($[0] !== view) {
        t3 = {
            view: view
        };
        $[0] = view;
        $[1] = t3;
    } else t3 = $[1];
    const { pageTreeUpdater: pageTreeUpdater } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t3);
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $1cfRh.default)();
    const { location: location, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t4;
    if ($[2] !== location?.pathname) {
        t4 = $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav.some((route)=>$ba2ff1d1fd865be7$var$isRoute(location?.pathname, route));
        $[2] = location?.pathname;
        $[3] = t4;
    } else t4 = $[3];
    const showBreadcrumbNavHeader = t4;
    let t5;
    if ($[4] !== intl) {
        t5 = intl.formatMessage((0, $5fff77e1c664da88$export$a7357cdd1f0b0168).SideNav);
        $[4] = intl;
        $[5] = t5;
    } else t5 = $[5];
    const SideNavSkiplinkText = t5;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    let t6;
    if ($[6] !== standalone) {
        t6 = (bannerHeight)=>standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $9wGTI.fg)("platform_dst_nav4_top_nav_increase_height") ? (0, $234a7212b3053f5f$export$1f9daac55b336da8) : (0, $234a7212b3053f5f$export$d1bb8697b964b9c)
                },
                "data-testid": "global-styles-SSR"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$191b652ca0b16b3f)
                }
            }), (0, $9wGTI.fg)("platform_dst_nav4_top_nav_increase_height") ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
                type: "text/css"
            }, `[${(0, $234a7212b3053f5f$export$f6b09748eb1e2d30)}], [${(0, $234a7212b3053f5f$export$2306961d40008e49)}] {
						top: ${bannerHeight + $ba2ff1d1fd865be7$var$TOP_NAV_HEIGHT}px !important;
					}`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
                "data-testid": "global-styles",
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$191b652ca0b16b3f)
                }
            });
        $[6] = standalone;
        $[7] = t6;
    } else t6 = $[7];
    const standaloneGlobalStylesCompiled = t6;
    const [isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive] = (0, $42omo.useState)(false);
    const { initialCollapsedState: initialCollapsedState } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const isContentRoute = Boolean(match?.params?.contentId);
    let t7;
    if ($[8] !== hideObjectSidebar || $[9] !== isContentRoute || $[10] !== isObjectSidebarShown || $[11] !== panel?.id) {
        t7 = ()=>{
            if (isObjectSidebarShown && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && !isContentRoute && (0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar")) hideObjectSidebar();
        };
        $[8] = hideObjectSidebar;
        $[9] = isContentRoute;
        $[10] = isObjectSidebarShown;
        $[11] = panel?.id;
        $[12] = t7;
    } else t7 = $[12];
    const t8 = panel?.id;
    let t9;
    if ($[13] !== hideObjectSidebar || $[14] !== isContentRoute || $[15] !== isObjectSidebarShown || $[16] !== t8) {
        t9 = [
            hideObjectSidebar,
            isContentRoute,
            isObjectSidebarShown,
            t8
        ];
        $[13] = hideObjectSidebar;
        $[14] = isContentRoute;
        $[15] = isObjectSidebarShown;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    (0, $42omo.useEffect)(t7, t9);
    let t10;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: "NavigationLoading"
        });
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== SideNavSkiplinkText || $[20] !== areKeyboardShortcutsEnabled || $[21] !== children || $[22] !== initialCollapsedState || $[23] !== isContentRoute || $[24] !== isNav4CollapseReminderSpotlightActive || $[25] !== isObjectSidebarShown || $[26] !== isSpaceSettingsScreen || $[27] !== location?.pathname || $[28] !== pageTreeUpdater || $[29] !== panel?.id || $[30] !== showBreadcrumbNavHeader || $[31] !== standalone || $[32] !== standaloneGlobalStylesCompiled || $[33] !== view) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: $ba2ff1d1fd865be7$var$bannerStateContainerArray
        }, (bannerState)=>{
            const bannerHeight_0 = bannerState.getTotalHeight(false);
            const SpotlightWrapper = (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? $ba2ff1d1fd865be7$var$_temp : $ba2ff1d1fd865be7$var$_temp2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpotlightWrapper, null, standaloneGlobalStylesCompiled(bannerHeight_0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e33908ef21162ab8$export$968a8c4aa27e5f45), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1274ccb8dddd72cd$export$797f6437373337da), {
                value: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82dFP.Root), {
                UNSAFE_dangerouslyHoistSlotSizes: true,
                testId: "page-layout-root",
                defaultSideNavCollapsed: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false) ? initialCollapsedState === "collapsed" : undefined,
                isSideNavShortcutEnabled: areKeyboardShortcutsEnabled && (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0df34b67538a54c$export$3b4e64e77073e307), {
                height: bannerHeight_0,
                id: "AkBanner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e36ff8521eaa3fdf$export$f316edcbf748c37b), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
                dataFetcherName: "top-nav"
            }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JEZ6P.TopNav), {
                defaultCollapsed: initialCollapsedState === "collapsed",
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
            }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.end`)), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b56ca6efd7e1c0fa$export$cc4f63927c41742f), {
                view: view,
                skiplinkText: SideNavSkiplinkText,
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                setTriggeredByShortcut: $ba2ff1d1fd865be7$var$_temp3
            }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.end`), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1imNS.Main), {
                testId: "grid-main-container",
                id: "AkMainContent"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $234a7212b3053f5f$export$712225703044cda), {
                id: "layout-main-wrapper",
                showBreadcrumbNavHeader: showBreadcrumbNavHeader
            }, showBreadcrumbNavHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.FixedBreadcrumbsNavForPageLayoutLoader), null), children && !standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, showBreadcrumbNavHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles
            }, children) : children) : null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.end`))), isObjectSidebarShown && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && isContentRoute && !$ba2ff1d1fd865be7$var$isRoute(location?.pathname, (0, $1NBp8.WHITEBOARD_BOARD)) && !$ba2ff1d1fd865be7$var$isRoute(location?.pathname, (0, $1NBp8.DATABASE_VIEW)) && (0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eK5zz.Panel), {
                defaultWidth: 400,
                label: "Object Sidebar"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lpfM9.PanelLoader), {
                toggleInProductHelp: $ba2ff1d1fd865be7$var$_temp4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $7xVCs.PageTreeStateUpdater)
                ]
            }, (pageTreeStateUpdatesContainer)=>{
                pageTreeUpdater.current = pageTreeStateUpdatesContainer;
                return null;
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c25ef82052c394f$export$f143b4bd86d1e004), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9ec1f4c06aad517$export$23822a00be419508), null))));
        });
        $[19] = SideNavSkiplinkText;
        $[20] = areKeyboardShortcutsEnabled;
        $[21] = children;
        $[22] = initialCollapsedState;
        $[23] = isContentRoute;
        $[24] = isNav4CollapseReminderSpotlightActive;
        $[25] = isObjectSidebarShown;
        $[26] = isSpaceSettingsScreen;
        $[27] = location?.pathname;
        $[28] = pageTreeUpdater;
        $[29] = panel?.id;
        $[30] = showBreadcrumbNavHeader;
        $[31] = standalone;
        $[32] = standaloneGlobalStylesCompiled;
        $[33] = view;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== editorPreloader || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
            value: editorPreloader
        }, t11);
        $[35] = editorPreloader;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== t12 || $[39] !== view) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd996ec529999f47$export$ac3e7903e24ee02d), {
            view: view,
            navVersion: "4"
        }, t10, t12));
        $[38] = t12;
        $[39] = view;
        $[40] = t13;
    } else t13 = $[40];
    return t13;
};
const $ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay = ()=>{
    const $ = (0, $frIzR.c)(2);
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    let t0;
    if ($[0] !== isMultiSelectActive) {
        t0 = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
            isTinted: true,
            testId: "content-tree-multi-select-blanket"
        }) : null;
        $[0] = isMultiSelectActive;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles = (0, $ecnYn.xcss)({
    // @ts-ignore This specific value is necessary to ensure the breadcrumbs are offset correctly
    marginTop: '60px'
});
const $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayout-outer'
};
const $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayoutInner'
};
const $ba2ff1d1fd865be7$var$bannerStateContainerArray = [
    (0, $hrAmX.BannerStateContainer)
];
const $ba2ff1d1fd865be7$var$noopEditorPreloader = ()=>null;
function $ba2ff1d1fd865be7$var$_temp(t0) {
    const { children: childrenProp } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, childrenProp);
}
function $ba2ff1d1fd865be7$var$_temp2(t0) {
    const { children: childrenProp_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), {
        blanketIsTinted: true
    }, childrenProp_0);
}
function $ba2ff1d1fd865be7$var$_temp3() {}
function $ba2ff1d1fd865be7$var$_temp4() {}
module.exports["PageLayout"] = $ba2ff1d1fd865be7$export$6d1402fb58384e4f;
module.exports["PageLayoutInner"] = $ba2ff1d1fd865be7$export$f94607b1528a8807;

});

parcelRegister("9gVcn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $2af2b85cff10a1fc$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $42omo.createContext)(()=>(0, $dh538.fg)('navx-full-height-sidebar'));
module.exports["IsFhsEnabledContext"] = $2af2b85cff10a1fc$export$1e91b29ada71c32a;

});

parcelRegister("eK5zz", function(module, exports) {
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bWLcG = parcelRequire("bWLcG");


var $dEIJ1 = parcelRequire("dEIJ1");


var $K0HEo = parcelRequire("K0HEo");


var $8jREP = parcelRequire("8jREP");


var $dGAIk = parcelRequire("dGAIk");


var $bgZhH = parcelRequire("bgZhH");


var $c9vFp = parcelRequire("c9vFp");


var $dh62b = parcelRequire("dh62b");


var $38bxn = parcelRequire("38bxn");


var $5KskV = parcelRequire("5KskV");

const $57f246d928e48214$var$panelSplitterResizingVar = '--n_pnlRsz';
const $57f246d928e48214$var$fallbackDefaultWidth = 365; /**
                                   * We typically use the `defaultWidth` as the minimum resizing width,
                                   * but for large default widths we fallback to a standard value.
                                   *
                                   * This standard value of `400px` is to align with the Global Preview Panels.
                                   */ 
const $57f246d928e48214$var$fallbackResizeMinWidth = 400;
const $57f246d928e48214$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _1bsb1dxx _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs130s _1w6eia51 _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
}; /**
    * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
    *
    * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
    *
    * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
    */ 
function $57f246d928e48214$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidthProp = $57f246d928e48214$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true }) {
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    const defaultWidth = (0, $5KskV.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $57f246d928e48214$var$fallbackDefaultWidth,
        slotName: 'Panel'
    }); /**
       * Don't show the skip link if the slot has 0 width.
       *
       * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
       */ 
    (0, $dEIJ1.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $42omo.useRef)(null);
    const [width, setWidth] = (0, $42omo.useState)(defaultWidth); // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $42omo.useRef)(defaultWidth); /**
                                                 * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
                                                 * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
                                                 * https://jplat.atlassian.net/browse/BLU-3951
                                                 */ 
    (0, $42omo.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $dh62b.useSideNavRef)(); /**
                                       * The minimum width that the panel can be resized to by the user.
                                       *
                                       * We only use the `defaultWidth` up to a point to avoid huge panels.
                                       */ 
    const minWidth = Math.min(defaultWidth, $57f246d928e48214$var$fallbackResizeMinWidth); /**
                                                                    * Returns the bounds for resizing, evaluated lazily when needed.
                                                                    *
                                                                    * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
                                                                    * and the panel's slot bounds use a complex CSS expression.
                                                                    */ 
    const getResizeBounds = (0, $42omo.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0; /**
                                                                * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
                                                                *
                                                                * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
                                                                */ 
        const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${(0, $K0HEo.sideNavLiveWidthVar)}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $38bxn.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $57f246d928e48214$var$panelSplitterResizingVar,
        panelId: (0, $K0HEo.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            $57f246d928e48214$var$styles.root,
            defaultWidth === 0 && $57f246d928e48214$var$styles.hidden,
            hasBorder && $57f246d928e48214$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $K0HEo.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $bWLcG.media).above.lg,
                responsiveValue: `var(${$57f246d928e48214$var$panelSplitterResizingVar}, ${panelVariableWidth})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c9vFp.PanelSplitterProvider), {
                panelId: (0, $K0HEo.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: getResizeBounds,
                resizingCssVar: $57f246d928e48214$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $57f246d928e48214$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
module.exports["Panel"] = $57f246d928e48214$export$2ddb90ad54e5f587;

});

parcelRegister("8zs3p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9gVcn = parcelRequire("9gVcn");

const $a2cec1783d8c9bc6$export$8b40a725a91166de = ()=>{
    const isFhsEnabled = (0, $42omo.useContext)((0, $9gVcn.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};
module.exports["useIsFhsEnabled"] = $a2cec1783d8c9bc6$export$8b40a725a91166de;

});

parcelRegister("1imNS", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dEIJ1 = parcelRequire("dEIJ1");


var $bgZhH = parcelRequire("bgZhH");

const $d409264451843df7$var$mainElementStyles = {
    root: "_nd5l1gzg _1reo1wug _18m91wug _19121cl4 _152timx3 _qwfh1wug _165teqxy _13wn1if8"
}; /**
    * Use the Main area for the main page content. It has a fluid width and will expand to fill available space.
    */ 
function $d409264451843df7$export$861edd1ccea2f746({ children: children, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    (0, $dEIJ1.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $gMc0m.default)([
                $d409264451843df7$var$mainElementStyles.root,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: children
        })
    });
}
module.exports["Main"] = $d409264451843df7$export$861edd1ccea2f746;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("6CEg5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $42omo.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("3Rwpv", function(module, exports) {

let $2cff76582f58a1ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2cff76582f58a1ae$var$load("7ETma"),
    $2cff76582f58a1ae$var$load("avZlC")
]).then(()=>parcelRequire('9ZNsj'));

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        if (// The increased height change is only applied when FHS is enabled (even if the gate is enabled)
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) && (0, $9wGTI.fg)('platform_dst_nav4_top_nav_increase_height')) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("1I5mg", function(module, exports) {

let $13ee0e7d7229ea70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $13ee0e7d7229ea70$var$load("6wr18"),
    $13ee0e7d7229ea70$var$load("DerzA"),
    $13ee0e7d7229ea70$var$load("4dNRa"),
    $13ee0e7d7229ea70$var$load("e7wVW"),
    $13ee0e7d7229ea70$var$load("ffEVr"),
    $13ee0e7d7229ea70$var$load("7EorR"),
    $13ee0e7d7229ea70$var$load("dTsOE"),
    $13ee0e7d7229ea70$var$load("jryQt")
]).then(()=>parcelRequire('73TCo'));

});

parcelRegister("6tLpM", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $f88282d674f1f8d0$export$5351114e92b31bc6 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $f88282d674f1f8d0$export$5351114e92b31bc6;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = ()=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        ...initialPanel && (0, $dh538.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("ireve", function(module, exports) {

let $d6c5ff8f4de3f3c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6c5ff8f4de3f3c5$var$load("geNwN"),
    $d6c5ff8f4de3f3c5$var$load("3alGb")
]).then(()=>parcelRequire('23xdA'));

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("1fdQV", function(module, exports) {
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $inPa6 = parcelRequire("inPa6");


var $3654r = parcelRequire("3654r");


var $g6aM3 = parcelRequire("g6aM3");


var $fQcKS = parcelRequire("fQcKS");

var $6UUmP = parcelRequire("6UUmP");


var $dh538 = parcelRequire("dh538");


var $4T4vf = parcelRequire("4T4vf");


var $bWLcG = parcelRequire("bWLcG");


var $dEIJ1 = parcelRequire("dEIJ1");


var $7plVH = parcelRequire("7plVH");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");


var $8jREP = parcelRequire("8jREP");


var $dGAIk = parcelRequire("dGAIk");


var $bgZhH = parcelRequire("bgZhH");


var $c9vFp = parcelRequire("c9vFp");


var $38bxn = parcelRequire("38bxn");


var $5KskV = parcelRequire("5KskV");


var $dh62b = parcelRequire("dh62b");


var $5IbFD = parcelRequire("5IbFD");


var $9OYu5 = parcelRequire("9OYu5");


var $huiud = parcelRequire("huiud");


var $5fMbj = parcelRequire("5fMbj");


var $1cuAd = parcelRequire("1cuAd");


var $cj9Az = parcelRequire("cj9Az");


var $7R2w7 = parcelRequire("7R2w7");


var $8qoQE = parcelRequire("8qoQE");


var $622t3 = parcelRequire("622t3");


var $cvtof = parcelRequire("cvtof");

const $897ab7f8a2e9a596$var$panelSplitterResizingVar = '--n_snvRsz'; // Used to share the side nav width with the panel splitter, which is rendered outside the side nav element
// but positioned to stay at its right edge.
const $897ab7f8a2e9a596$var$sideNavClampedWidthVar = '--n_snvW';
const $897ab7f8a2e9a596$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $897ab7f8a2e9a596$var$getResizeBounds() {
    return $897ab7f8a2e9a596$var$widthResizeBounds;
} /**
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ 
const $897ab7f8a2e9a596$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $897ab7f8a2e9a596$var$panelSplitterPortalTargetStyles = {
    root: "_kqsw1n9t _1pbyegat _u7coidpf _t9ectl5p _4t3ieqxy _165t56xv _p0az1elq"
};
const $897ab7f8a2e9a596$var$styles = {
    root: "_nd5l1b6c _191wglyw _t51zglyw _bfhk1bhr _16qs130s _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _p5clia51 _4ap3vuon _scbpglyw",
    flyoutOpen: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    animationRTLSupport: "_15yekb7n _65m41mrw",
    flyoutBaseStylesFullHeightSidebar: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _17ly8iot _177m1a5r",
    flyoutOpenFullHeightSidebar: "_hjoifnf5 _vgub1ku9 _s2eg1p9u",
    flyoutAnimateClosedFullHeightSidebar: "_dm25glyw _hjoifnf5 _vgub1mm8 _hh1u1p9u",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw",
    animationBaseStyles: "_10t88iot _1vrh1a5r _xrrpfnf5",
    expandAnimationMobile: "_1xq51ku9 _1nu51p9u",
    collapseAnimationMobile: "_1lh81gzg _1xq51mm8 _aadi1p9u",
    expandAnimationDesktop: "_1sg8k0mc _vgub1ku9 _s2eg1p9u",
    collapseAnimationDesktop: "_1sg81gzg _vgub1mm8 _hh1u1p9u"
};
const $897ab7f8a2e9a596$var$fallbackDefaultWidth = 320;
const $897ab7f8a2e9a596$export$c735dc1c21910e21 = 500; /**
                                        * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
                                        * context value.
                                        */ 
function $897ab7f8a2e9a596$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $897ab7f8a2e9a596$var$fallbackDefaultWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $1cuAd.useExpandSideNav)({
        trigger: 'skip-link'
    }); /**
       * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
       *
       * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
       */ 
    const synchronouslyExpandSideNav = (0, $42omo.useCallback)(()=>{
        (0, $jTxSS.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $dEIJ1.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $42omo.useContext)((0, $cvtof.SideNavVisibilityState));
    const setSideNavState = (0, $42omo.useContext)((0, $cvtof.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }); // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $42omo.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $42omo.useState)(isExpandedOnDesktop); /**
                                                                       * Captures the initial collapsed/expanded state of the side nav.
                                                                       *
                                                                       * Only firing on desktop because the nav is never open by default on mobile.
                                                                       */ 
    (0, $42omo.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $5KskV.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $897ab7f8a2e9a596$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [width, setWidth] = (0, $42omo.useState)(defaultWidth);
    const clampedWidth = `clamp(${$897ab7f8a2e9a596$var$widthResizeBounds.min}, ${width}px, ${$897ab7f8a2e9a596$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const navRef = (0, $42omo.useRef)(null);
    const panelSplitterPortalTargetRef = (0, $42omo.useRef)(null); /**
                                                                             * Used to share the side nav element with the `Panel`,
                                                                             * which observes the side nav to determine its maximum width.
                                                                             */ 
    const sharedRef = (0, $dh62b.useSideNavRef)();
    const mergedRef = (0, $3654r.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $42omo.useContext)((0, $5fMbj.SideNavToggleButtonElement));
    const topNavStartElement = (0, $42omo.useContext)((0, $7plVH.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const flyoutStateRef = (0, $42omo.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const isExpandedOnDesktopRef = (0, $g6aM3.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $42omo.useRef)(false);
    const onPeekStartRef = (0, $g6aM3.default)(onPeekStart);
    const onPeekEndRef = (0, $g6aM3.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $42omo.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            // Prevent the flyout from being opened if there are any open layers in the top nav start
            if (openLayerObserver && openLayerObserver.getCount({
                namespace: (0, $K0HEo.openLayerObserverTopNavStartNamespace),
                type: 'popup'
            }) > 0 && (0, $dh538.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return;
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            }); // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $897ab7f8a2e9a596$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    ...currentState,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            }); // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            } // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                 // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $5IbFD.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $K0HEo.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $622t3.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $622t3.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    }); // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $42omo.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
         // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed',
            lastTrigger: null
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $42omo.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation'); // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $42omo.useCallback)(({ screen: screen, trigger: trigger })=>{
        onCollapse?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation'); // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $8qoQE.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $42omo.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]); /**
                                                                                  * Close the mobile side nav if there is a click outside.
                                                                                  *
                                                                                  * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
                                                                                  * If we listened to window size changes we'd need nested `bind()` calls.
                                                                                  */ 
    (0, $42omo.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
         /**
       * The expected URL fragment used by the side nav skip link.
       */ 
        const skipLinkUrlFragment = `#${id}`;
        return (0, $fFa3V.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $fFa3V.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                 // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $fFa3V.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $fFa3V.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                 // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $fFa3V.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
         // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished'); // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $fFa3V.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                 // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $fFa3V.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                 // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $K0HEo.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $cj9Az.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    }); // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $9OYu5.useIsSideNavShortcutEnabled)();
    (0, $38bxn.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $897ab7f8a2e9a596$var$panelSplitterResizingVar,
        panelId: (0, $K0HEo.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop; /**
                                                                                                                         * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
                                                                                                                         *
                                                                                                                         * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
                                                                                                                         */ 
    const hasExpandedStateChangedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]); /**
                                              * If the expanded state of the side nav has ever changed since mount.
                                              *
                                              * Used to prevent sidebar expand animations from running on the initial load.
                                              * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
                                              */ 
    const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current; // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = isFhsEnabled && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$897ab7f8a2e9a596$var$isFirefox;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("nav", {
                id: id,
                ...devTimeOnlyAttributes,
                "data-layout-slot": true,
                "aria-label": label,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
                    [(0, $K0HEo.sideNavVar)]: clampedWidth
                },
                ref: mergedRef,
                "data-testid": testId,
                className: (0, $gMc0m.default)([
                    $897ab7f8a2e9a596$var$styles.root,
                    isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileOnly,
                    !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenDesktopOnly,
                    !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileAndDesktop,
                    isFhsEnabled && $897ab7f8a2e9a596$var$styles.animationRTLSupport,
                    shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.animationBaseStyles,
                    isExpandedOnMobile && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.expandAnimationMobile,
                    !isExpandedOnMobile && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.collapseAnimationMobile,
                    isExpandedOnDesktop && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.expandAnimationDesktop,
                    !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && $897ab7f8a2e9a596$var$styles.collapseAnimationDesktop,
                    sideNavState?.flyout === 'open' && !isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutOpen,
                    sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutAnimateClosed,
                    (sideNavState?.flyout === 'open' || sideNavState?.flyout === 'triggered-animate-close') && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutBaseStylesFullHeightSidebar,
                    sideNavState?.flyout === 'triggered-animate-close' && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutAnimateClosedFullHeightSidebar,
                    sideNavState?.flyout === 'open' && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutOpenFullHeightSidebar,
                    sideNavState?.flyout === 'triggered-animate-close' && !$897ab7f8a2e9a596$var$isFirefox && isFhsEnabled && $897ab7f8a2e9a596$var$styles.flyoutAnimateClosedFullHeightSidebar
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $K0HEo.sideNavLiveWidthVar),
                        value: "0px",
                        mediaQuery: (0, $bWLcG.media).above.md,
                        responsiveValue: isExpandedOnDesktop ? `var(${$897ab7f8a2e9a596$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
                    }),
                    dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                    // When they aren't needed anymore we can delete them wholesale.
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $K0HEo.UNSAFE_sideNavLayoutVar),
                        value: `var(${(0, $K0HEo.sideNavLiveWidthVar)})`
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $c9vFp.PanelSplitterProvider), {
                        panelId: (0, $K0HEo.sideNavPanelSplitterId),
                        panelRef: navRef,
                        portalRef: isFhsEnabled ? panelSplitterPortalTargetRef : undefined,
                        panelWidth: width,
                        onCompleteResize: setWidth,
                        getResizeBounds: $897ab7f8a2e9a596$var$getResizeBounds,
                        resizingCssVar: $897ab7f8a2e9a596$var$panelSplitterResizingVar,
                        isEnabled: !isFlyoutVisible,
                        shortcut: isShortcutEnabled ? (0, $huiud.sideNavToggleTooltipKeyboardShortcut) : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $897ab7f8a2e9a596$var$styles.flexContainer
                            ]),
                            children: children
                        })
                    })
                ]
            }),
            isFhsEnabled && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: panelSplitterPortalTargetRef,
                "data-layout-slot": true,
                style: {
                    // We need to use an inline style here to share the side nav width to position the panel splitter.
                    // We can't use the existing --n_sNvlw variable (sideNavLiveWidthVar) because it is set to 0 when the side nav is collapsed on desktop,
                    // however the panel splitter is still visible and usable on small viewports until 48rem.
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    [$897ab7f8a2e9a596$var$sideNavClampedWidthVar]: clampedWidth
                },
                className: (0, $gMc0m.default)([
                    $897ab7f8a2e9a596$var$panelSplitterPortalTargetStyles.root,
                    isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileOnly,
                    !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenDesktopOnly,
                    !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileAndDesktop
                ])
            })
        ]
    });
}
function $897ab7f8a2e9a596$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fQcKS.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $K0HEo.openLayerObserverSideNavNamespace),
        children: /*#__PURE__*/ (0, $l998X.jsx)($897ab7f8a2e9a596$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: id,
            canToggleWithShortcut: canToggleWithShortcut,
            children: children
        })
    });
}
module.exports["SideNav"] = $897ab7f8a2e9a596$export$1a35787d6353cf6a;

});

parcelRegister("5IbFD", function(module, exports) {
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $b9b280e8233788f4$export$a7801e29f563faad = 400;
module.exports["sideNavFlyoutCloseDelayMs"] = $b9b280e8233788f4$export$a7801e29f563faad;

});

parcelRegister("1cuAd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cvtof = parcelRequire("cvtof");

function $63281e74cccc9d52$export$e44b4744d8ff971a({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $42omo.useContext)((0, $cvtof.SetSideNavVisibilityState));
    const expandSideNav = (0, $42omo.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        setSideNavState,
        trigger
    ]);
    return expandSideNav;
}
module.exports["useExpandSideNav"] = $63281e74cccc9d52$export$e44b4744d8ff971a;

});

parcelRegister("cvtof", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $6e62a89b3ae4c955$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6e62a89b3ae4c955$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["SideNavVisibilityState"] = $6e62a89b3ae4c955$export$eb04201bb6dd1e4e;
module.exports["SetSideNavVisibilityState"] = $6e62a89b3ae4c955$export$f6b496b07d1ea493;

});

parcelRegister("cj9Az", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $g6aM3 = parcelRequire("g6aM3");


var $6UUmP = parcelRequire("6UUmP");


var $8zs3p = parcelRequire("8zs3p");


var $9OYu5 = parcelRequire("9OYu5");


var $622t3 = parcelRequire("622t3");

function $51a0d9035b4b4171$export$f762e7ac9d86adb0({ canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $622t3.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $g6aM3.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $9OYu5.useIsSideNavShortcutEnabled)();
    (0, $42omo.useEffect)(()=>{
        if (!isFhsEnabled) return;
        if (!isSideNavShortcutEnabled) return;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isFhsEnabled,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
}
module.exports["useSideNavToggleKeyboardShortcut"] = $51a0d9035b4b4171$export$f762e7ac9d86adb0;

});

parcelRegister("622t3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cvtof = parcelRequire("cvtof");

function $24bc66d44c50665e$export$477ee35601a0a8ce({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $42omo.useContext)((0, $cvtof.SetSideNavVisibilityState));
    const toggleSideNav = (0, $42omo.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
}
module.exports["useToggleSideNav"] = $24bc66d44c50665e$export$477ee35601a0a8ce;

});

parcelRegister("8qoQE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bzNqF = parcelRequire("bzNqF");

function $f521bee41562bd5b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $42omo.useRef)(onExpand);
    const onCollapseRef = (0, $42omo.useRef)(onCollapse);
    (0, $42omo.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $bzNqF.default)(isExpandedOnDesktop);
    (0, $42omo.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $bzNqF.default)(isExpandedOnMobile);
    (0, $42omo.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
}
module.exports["useSideNavVisibilityCallbacks"] = $f521bee41562bd5b$export$1904b8f2577aba9a;

});

parcelRegister("lxWrw", function(module, exports) {
/* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7f0c92f6dc95d81f$var$styles = {
    root: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp _7myae4h9 _1sw7nqa1 _qgnu1l7x"
}; /**
    * The bottom part of the side nav.
    */ 
const $7f0c92f6dc95d81f$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $7f0c92f6dc95d81f$var$styles.root,
            xcss
        ]),
        children: children
    });
};
module.exports["SideNavFooter"] = $7f0c92f6dc95d81f$export$b773c4c9cf740fbe;

});

parcelRegister("4hWZe", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6UUmP = parcelRequire("6UUmP");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");


var $622t3 = parcelRequire("622t3");


var $83Hmc = parcelRequire("83Hmc");


var $bssir = parcelRequire("bssir");

/**
 * Namespaces to check for open layers that would interfere with the panel splitter.
 *
 * Placed outside the component for stability, as the list is used as an effect dependency.
 */ const $e0197539f2395191$var$openLayerNamespacesToCheck = [
    // The side nav panel splitter is layered above the side nav, so needs to be disabled when there are open popups in the side nav.
    (0, $K0HEo.openLayerObserverSideNavNamespace),
    // The side nav panel splitter is layered above the top nav, so needs to be disabled when there are open popups in the top nav.
    (0, $K0HEo.openLayerObserverTopNavStartNamespace),
    (0, $K0HEo.openLayerObserverTopNavMiddleNamespace),
    (0, $K0HEo.openLayerObserverTopNavEndNamespace)
];
/**
 * Returns whether there are any open popups in the side nav or top nav
 */ function $e0197539f2395191$var$useHasOpenPopupsInSideNavOrTopNav() {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    // Setting the initial state to false, as it is unlikely that there would be any open popups when the app starts.
    const [hasOpenPopups, setHasOpenPopups] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!openLayerObserver || !isFhsEnabled) return;
        function updateState() {
            if (!openLayerObserver) return;
            const hasAnyOpenLayers = $e0197539f2395191$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                    namespace: namespace,
                    type: 'popup'
                }) > 0);
            setHasOpenPopups(hasAnyOpenLayers);
        }
        // Initial check. We do this _in case_ a popup is already open when the component mounts.
        updateState();
        // Subscribe to each namespace
        const cleanups = $e0197539f2395191$var$openLayerNamespacesToCheck.map((namespace)=>openLayerObserver.onChange(updateState, {
                namespace: namespace
            }));
        return function cleanupHook() {
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        isFhsEnabled,
        openLayerObserver
    ]);
    return hasOpenPopups;
}
const $e0197539f2395191$export$5f595addf4e50d58 = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $42omo.useContext)((0, $83Hmc.PanelSplitterContext));
    (0, $dRnqM.default)(context?.panelId === (0, $K0HEo.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $622t3.useToggleSideNav)({
        trigger: 'double-click'
    });
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    // The logic and state for disabling the panel splitter when there are open popups
    // in the side nav or top nav is being placed here, instead of in `SideNav`, to prevent
    // re-rendering the side nav anytime the number of open popups changes.
    const hasOpenLayersInSideNavOrTopNav = $e0197539f2395191$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $83Hmc.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bssir.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
            // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
            shouldCollapseOnDoubleClick ? tooltipContent : undefined
        })
    });
};
module.exports["SideNavPanelSplitter"] = $e0197539f2395191$export$5f595addf4e50d58;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("jFFx4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dPJCf = parcelRequire("dPJCf");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3194c63c7e99e1cb$export$2537d74141d57f9e = ()=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const saveCurrentRoute = (0, $42omo.useCallback)(()=>{
        const currentRoute = routeDataRef.current?.href;
        if (currentRoute) (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL, currentRoute);
    }, [
        routeDataRef
    ]);
    const getRoute = (0, $42omo.useCallback)((defaultPath)=>{
        const previousPath = (0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL);
        return previousPath ?? defaultPath;
    }, []);
    return {
        saveCurrentRoute: saveCurrentRoute,
        getRoute: getRoute
    };
};
module.exports["useSettingsBackButtonUtils"] = $3194c63c7e99e1cb$export$2537d74141d57f9e;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("5DPHR", function(module, exports) {

let $41b8b41ca0e30a5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41b8b41ca0e30a5b$var$load("6wr18"),
    $41b8b41ca0e30a5b$var$load("gRwQ3"),
    $41b8b41ca0e30a5b$var$load("4rKYa"),
    $41b8b41ca0e30a5b$var$load("8UKe0"),
    $41b8b41ca0e30a5b$var$load("5uN9h"),
    $41b8b41ca0e30a5b$var$load("Wowvf"),
    $41b8b41ca0e30a5b$var$load("lRtGG"),
    $41b8b41ca0e30a5b$var$load("ffEVr"),
    $41b8b41ca0e30a5b$var$load("geh8r")
]).then(()=>parcelRequire('8oHcg'));

});

parcelRegister("7p8VW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $jvL0g = parcelRequire("jvL0g");


var $1AdRC = parcelRequire("1AdRC");

const $945be865edc65072$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $c0qxy.useId)();
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $1AdRC.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};
module.exports["MenuSection"] = $945be865edc65072$export$4b1545b4f2016d26;

});

parcelRegister("1AdRC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");

const $f76872a14a62f5bc$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $f76872a14a62f5bc$export$8100cda602411810 = ()=>{
    const context = (0, $42omo.useContext)($f76872a14a62f5bc$export$728ac99b9c7eea8a);
    (0, $dRnqM.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};
module.exports["MenuSectionContext"] = $f76872a14a62f5bc$export$728ac99b9c7eea8a;
module.exports["useMenuSectionContext"] = $f76872a14a62f5bc$export$8100cda602411810;

});

parcelRegister("c8gOp", function(module, exports) {
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1AdRC = parcelRequire("1AdRC");

const $5e57245bca8ff137$var$styles = {
    root: "_11c8i4vh _1rjcu2gc _syaz1rpy _bozg12x7"
}; /**
    * __MenuSectionHeading__
    *
    * The label for the menu section group.
    */ 
const $5e57245bca8ff137$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $1AdRC.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)("p", {
        id: `${id}-heading`,
        className: (0, $gMc0m.default)([
            $5e57245bca8ff137$var$styles.root
        ]),
        children: children
    });
};
module.exports["MenuSectionHeading"] = $5e57245bca8ff137$export$5d3acdbf9237a364;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("dVkip", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $j3b2C = parcelRequire("j3b2C");


var $5t9S7 = parcelRequire("5t9S7");


var $4eIcx = parcelRequire("4eIcx");


var $4H4Pj = parcelRequire("4H4Pj");


var $gW6rh = parcelRequire("gW6rh");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");


var $ep3mz = parcelRequire("ep3mz");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");

const $568e72a32d90ae8c$export$927df7988fec803 = (0, $gW6rh.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery = (0, $4H4Pj.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery = (0, $4eIcx.default);
const $568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery = (0, $5t9S7.default);
const $568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery = (0, $j3b2C.default);
const $568e72a32d90ae8c$var$hasCurrentSpace = (data)=>'space' in data;
const $568e72a32d90ae8c$var$isCurrentSpaceNotFoundError = (gqlError)=>gqlError.path?.[0] === 'space' && gqlError.extensions?.['statusCode'] === 404;
const $568e72a32d90ae8c$var$processStarredError = (error)=>{
    if (!error) return undefined;
    if ((0, $1uFM6.isUnauthorizedError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$var$processRecentError = (error)=>{
    if (!error) return undefined;
    /**
   * space
   *    403: Expected to occur when the user is on a restricted space
   *    404: Expected to occur when the user is on an invalid space
   * recentSpaces
   *    403: Harmless error temporarily being ignored to mitigate CONFDEV-71458.
   *         Removing in CONFDEV-71656.
   */ if ((0, $1uFM6.isUnauthorizedError)(error) || !error.networkError && error.graphQLErrors.every($568e72a32d90ae8c$var$isCurrentSpaceNotFoundError)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$export$e3e9588fd2c1abdd = (isLicensed)=>{
    const { data: starredSpacesData, loading: starredSpacesLoading, error: starredSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$export$927df7988fec803, {
        skip: !isLicensed
    });
    const { data: anonymousSpacesData, loading: anonymousSpacesLoading, error: anonymousSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery, {
        skip: isLicensed
    });
    const data = isLicensed ? starredSpacesData : anonymousSpacesData;
    const loading = isLicensed ? starredSpacesLoading : anonymousSpacesLoading;
    const error = isLicensed ? starredSpacesError : anonymousSpacesError;
    const starredSpaces = (data?.spaces?.nodes || []).filter((space)=>space != null).map((space_0)=>({
            ...space_0,
            currentUser: {
                isFavourited: isLicensed
            }
        }));
    const unexpectedError = $568e72a32d90ae8c$var$processStarredError(error);
    return {
        starredSpaces: starredSpaces,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$var$useRecentData = (isLicensed)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: myVisitedSpacesWithCurrentSpaceData, loading: myVisitedSpacesWithCurrentSpaceLoading, error: myVisitedSpacesWithCurrentSpaceError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery, {
        skip: !isLicensed || !spaceKey,
        variables: {
            selectedSpaceKey: spaceKey
        },
        errorPolicy: 'all'
    });
    const { data: myVisitedSpacesData, loading: myVisitedSpacesLoading, error: myVisitedSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery, {
        skip: !isLicensed || !!spaceKey,
        errorPolicy: 'all'
    });
    const data = spaceKey ? myVisitedSpacesWithCurrentSpaceData : myVisitedSpacesData;
    const loading = spaceKey ? myVisitedSpacesWithCurrentSpaceLoading : myVisitedSpacesLoading;
    const error = spaceKey ? myVisitedSpacesWithCurrentSpaceError : myVisitedSpacesError;
    const currentSpace = data && $568e72a32d90ae8c$var$hasCurrentSpace(data) && data.space || undefined;
    const recentData = data?.myVisitedSpaces?.nodes?.spaces;
    const recentSpaces = (recentData || []).filter((space)=>space != null && (!currentSpace || currentSpace.id !== space.id));
    const unexpectedError = $568e72a32d90ae8c$var$processRecentError(error);
    return {
        recentSpaces: recentSpaces,
        currentSpace: currentSpace,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$export$680b01e9499af50d = ()=>{
    const $ = (0, $frIzR.c)(16);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { starredSpaces: starredSpaces, loading: starredLoading, error: starredError } = $568e72a32d90ae8c$export$e3e9588fd2c1abdd(isLicensed);
    const { recentSpaces: unfilteredRecents, currentSpace: currentSpace, loading: recentLoading, error: recentError } = $568e72a32d90ae8c$var$useRecentData(isLicensed);
    let t0;
    if ($[0] !== starredSpaces) {
        t0 = new Set(starredSpaces.map($568e72a32d90ae8c$var$_temp));
        $[0] = starredSpaces;
        $[1] = t0;
    } else t0 = $[1];
    const starredIds = t0;
    let t1;
    if ($[2] !== starredIds || $[3] !== unfilteredRecents) {
        let t2;
        if ($[5] !== starredIds) {
            t2 = (recent)=>!starredIds.has(recent.id);
            $[5] = starredIds;
            $[6] = t2;
        } else t2 = $[6];
        t1 = unfilteredRecents.filter(t2).slice(0, 5);
        $[2] = starredIds;
        $[3] = unfilteredRecents;
        $[4] = t1;
    } else t1 = $[4];
    const recentSpaces = t1;
    let errors;
    if ($[7] !== recentError || $[8] !== starredError) {
        errors = [];
        if (starredError) errors.push(starredError);
        if (recentError) errors.push(recentError);
        $[7] = recentError;
        $[8] = starredError;
        $[9] = errors;
    } else errors = $[9];
    const t2 = starredLoading || recentLoading;
    let t3;
    if ($[10] !== currentSpace || $[11] !== errors || $[12] !== recentSpaces || $[13] !== starredSpaces || $[14] !== t2) {
        t3 = {
            errors: errors,
            loading: t2,
            starredSpaces: starredSpaces,
            recentSpaces: recentSpaces,
            currentSpace: currentSpace
        };
        $[10] = currentSpace;
        $[11] = errors;
        $[12] = recentSpaces;
        $[13] = starredSpaces;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
};
const $568e72a32d90ae8c$export$ecaaf759b72f2f3d = ()=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const [executeSearch, { data: data, loading: loading, error: error }] = (0, $lvOsp.useLazyQueryInterop)($568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery);
    const spaceSearchResults = (data?.spaces?.nodes || []).filter((space)=>space != null);
    const searchSpaces = (0, $42omo.useCallback)((pattern)=>{
        if (pattern) executeSearch({
            variables: {
                spaceNamePattern: pattern,
                isLicensed: isLicensed
            }
        });
    }, [
        executeSearch,
        isLicensed
    ]);
    return {
        spaceSearchResults: spaceSearchResults,
        loading: loading,
        error: error,
        searchSpaces: searchSpaces
    };
};
function $568e72a32d90ae8c$var$_temp(starred) {
    return starred.id;
}
module.exports["useStarredData"] = $568e72a32d90ae8c$export$e3e9588fd2c1abdd;
module.exports["useSpacesData"] = $568e72a32d90ae8c$export$680b01e9499af50d;
module.exports["useSpaceSearchData"] = $568e72a32d90ae8c$export$ecaaf759b72f2f3d;

});

parcelRegister("j3b2C", function(module, exports) {
/**
 * @generated SignedSource<<fc0fb637fa912ef8455d8f4f2263815a>>
 * @relayHash 807f0e620b159313dc25553268599830
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee
const $abc61d7dc008195d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceNamePattern"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Variable",
                    "name": "spaceNamePattern",
                    "variableName": "spaceNamePattern"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourited"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "807f0e620b159313dc25553268599830",
            "id": "70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee",
            "metadata": {},
            "name": "useSpacesDataSearchSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataSearchSpacesQuery($spaceNamePattern:String!,$isLicensed:Boolean!){spaces(first:30,status:\"current\",spaceNamePattern:$spaceNamePattern){nodes{alias,id,name,key,status,icon{path},currentUser@include(if:$isLicensed){isFavourited}}}}"
        }
    };
}();
$abc61d7dc008195d$var$node.hash = "414c959dafecb5d27ba9ddb5658cc68d";
var $abc61d7dc008195d$export$2e2bcd8739ae039 = $abc61d7dc008195d$var$node;
module.exports["default"] = $abc61d7dc008195d$export$2e2bcd8739ae039;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $278c8d04dad7bc1d$export$363a8d7f501f3769 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInterop(query, options) {
    const $ = (0, $frIzR.c)(2);
    {
        let t0;
        if ($[0] !== query) {
            t0 = (0, $86okN.toDocumentNode)(query);
            $[0] = query;
            $[1] = t0;
        } else t0 = $[1];
        return (0, $jxs8y.useLazyQuery)(t0, options);
    }
} : function useLazyQueryInterop(query, options) {
    return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), options);
};
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $gMc0m.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("lrHai", function(module, exports) {

let $f9cd9a43df39318c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f9cd9a43df39318c$var$load("6wr18"),
    $f9cd9a43df39318c$var$load("ffEVr"),
    $f9cd9a43df39318c$var$load("lRtGG"),
    $f9cd9a43df39318c$var$load("830Zv")
]).then(()=>parcelRequire('lC5h8'));

});

parcelRegister("jZM59", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $42omo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
const $e6220385bdb59eee$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    return context;
};
const $e6220385bdb59eee$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    (0, $42omo.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};
module.exports["usePageLayoutResize"] = $e6220385bdb59eee$export$10c7104037a7af62;
module.exports["useLeftSidebarFlyoutLock"] = $e6220385bdb59eee$export$94561f6055639ef7;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("io723", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1AtJA = parcelRequire("1AtJA");


var $dZzho = parcelRequire("dZzho");

const $cd95c7f874921f86$export$f11db193fdaffcc9 = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dZzho.UFOSegmentLoadStart), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1AtJA.Bm3PageSegmentLoadStart), props);
};
module.exports["PageSegmentLoadStart"] = $cd95c7f874921f86$export$f11db193fdaffcc9;

});

parcelRegister("1AtJA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $2994f14f1333f67a$var$noop = ()=>{};
const $2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $2994f14f1333f67a$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $2994f14f1333f67a$export$d807afe46329fe8a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent);
module.exports["Bm3PageSegmentLoadStart"] = $2994f14f1333f67a$export$d807afe46329fe8a;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("dZzho", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $762a25b728d4d734$var$noop = ()=>{};
const $762a25b728d4d734$var$UFOSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $762a25b728d4d734$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY })=>{
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            onComplete();
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $762a25b728d4d734$export$30c533f25ae06bb = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($762a25b728d4d734$var$UFOSegmentLoadStartComponent);
module.exports["UFOSegmentLoadStart"] = $762a25b728d4d734$export$30c533f25ae06bb;

});

parcelRegister("1uFsv", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $ee0fdcfc2b35384d$export$b79a5979472006ce = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.GLOBAL_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["GLOBAL_NAVIGATION_METRIC"] = $ee0fdcfc2b35384d$export$b79a5979472006ce;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("kcly4", function(module, exports) {

let $eb45a4b5b880e204$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb45a4b5b880e204$var$load("l8YLV"),
    $eb45a4b5b880e204$var$load("3WB19"),
    $eb45a4b5b880e204$var$load("kHOMt"),
    $eb45a4b5b880e204$var$load("74vOE"),
    $eb45a4b5b880e204$var$load("6wr18"),
    $eb45a4b5b880e204$var$load("bs8S7"),
    $eb45a4b5b880e204$var$load("axHci"),
    $eb45a4b5b880e204$var$load("81eQE"),
    $eb45a4b5b880e204$var$load("6S3Gy"),
    $eb45a4b5b880e204$var$load("21Qlg"),
    $eb45a4b5b880e204$var$load("l1nJ9"),
    $eb45a4b5b880e204$var$load("a9w2G"),
    $eb45a4b5b880e204$var$load("8UKe0"),
    $eb45a4b5b880e204$var$load("9a2oY"),
    $eb45a4b5b880e204$var$load("hhss7"),
    $eb45a4b5b880e204$var$load("ffEVr"),
    $eb45a4b5b880e204$var$load("7EorR"),
    $eb45a4b5b880e204$var$load("dTsOE"),
    $eb45a4b5b880e204$var$load("6Ie1c"),
    $eb45a4b5b880e204$var$load("bIPPg"),
    $eb45a4b5b880e204$var$load("4izLy"),
    $eb45a4b5b880e204$var$load("cD5e0")
]).then(()=>parcelRequire('C9t7g'));

});

parcelRegister("2qRJj", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $io723 = parcelRequire("io723");


var $gz8ZY = parcelRequire("gz8ZY");


var $ENihE = parcelRequire("ENihE");


var $aWrnw = parcelRequire("aWrnw");

const $662218afe73e5a2d$var$separatorStyles = null;
const $662218afe73e5a2d$var$separatorStylesFallback = null;

const $662218afe73e5a2d$export$d97a74b7c2565df0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcP7O",
    name: "SpaceNavigationLoader",
    loader: async ()=>(await (parcelRequire("dHOKn"))).SpaceNavigation,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        })
});
const $662218afe73e5a2d$export$a91923d0186f609a = (props)=>{
    const $ = (0, $frIzR.c)(7);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itze3t _1mouze3t _195gxmi2 _n7zlia51"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itidpf _1mouze3t _195gxmi2 _n7zlia51"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    const separatorHr = t0;
    const t1 = isNav4Enabled && separatorHr;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_NAVIGATION_METRIC)
        });
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($662218afe73e5a2d$export$d97a74b7c2565df0, props);
        $[2] = props;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2, t3);
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};
const $662218afe73e5a2d$export$d4aec89b198b6129 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["SpaceNavigationLoader"] = $662218afe73e5a2d$export$d97a74b7c2565df0;
module.exports["SpaceNavigation"] = $662218afe73e5a2d$export$a91923d0186f609a;
module.exports["SpaceNavigationLoadingSkeleton"] = $662218afe73e5a2d$export$d4aec89b198b6129;

});

parcelRegister("ENihE", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $a0Wth = parcelRequire("a0Wth");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a59a0b51f845364$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _bfhkvuon _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_vchhusvi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isloadingState: isloadingState, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx286ug _4t3i1ylp _u5f3u2gc",
            __cmplp.isloadingState ? "_19bvf6fq" : "_19bv19bv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkvkf5 _1o9zidpf _4t3i1tcg _2hwxpxbi _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Line = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _4t3i7vkz _1bsb68cl _bfhkvkf5",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$export$73d04a98c9062109 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { header: t1, loader: loader } = t0;
    const header = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== header || $[1] !== loader) {
        t2 = loader && header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0Wth.SpaceHeaderSkeleton), null) : null;
        $[0] = header;
        $[1] = loader;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] !== loader) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t3, t4);
        $[5] = loader;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[7] = t6;
        $[8] = t7;
    } else {
        t6 = $[7];
        t7 = $[8];
    }
    let t8;
    if ($[9] !== loader) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t6, t7);
        $[9] = loader;
        $[10] = t8;
    } else t8 = $[10];
    let t10;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    let t11;
    if ($[13] !== loader) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t9, t10);
        $[13] = loader;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[15] = t12;
        $[16] = t13;
    } else {
        t12 = $[15];
        t13 = $[16];
    }
    let t14;
    if ($[17] !== loader) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t12, t13);
        $[17] = loader;
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    let t16;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[19] = t15;
        $[20] = t16;
    } else {
        t15 = $[19];
        t16 = $[20];
    }
    let t17;
    if ($[21] !== loader) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t15, t16);
        $[21] = loader;
        $[22] = t17;
    } else t17 = $[22];
    let t18;
    if ($[23] !== t11 || $[24] !== t14 || $[25] !== t17 || $[26] !== t2 || $[27] !== t5 || $[28] !== t8) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonContainer, {
            "data-testid": "sidebar-skeleton"
        }, t2, t5, t8, t11, t14, t17));
        $[23] = t11;
        $[24] = t14;
        $[25] = t17;
        $[26] = t2;
        $[27] = t5;
        $[28] = t8;
        $[29] = t18;
    } else t18 = $[29];
    return t18;
});
module.exports["ContainerSkeleton"] = $2a59a0b51f845364$export$73d04a98c9062109;

});

parcelRegister("a0Wth", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fd8870c1509e72c$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4183j _4cvr1h6o _vchhusvi _1e0c1txw _1bsb1ijo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceIconSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1qi0 _1bsb1tcg _4t3i1tcg _bfhkvkf5 _2hwxf6fq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceTitleSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _1bsb1w81 _4t3i7vkz _bfhkvkf5",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $4fd8870c1509e72c$export$76f5179c9c39352c() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fd8870c1509e72c$var$SkeletonContainer, {
            "data-testid": "space-header-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fd8870c1509e72c$var$SpaceIconSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fd8870c1509e72c$var$SpaceTitleSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
module.exports["SpaceHeaderSkeleton"] = $4fd8870c1509e72c$export$76f5179c9c39352c;

});

parcelRegister("aWrnw", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("dHOKn", function(module, exports) {

let $9fa6a7cace30b456$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9fa6a7cace30b456$var$load("5dBst"),
    $9fa6a7cace30b456$var$load("e4XZ1"),
    $9fa6a7cace30b456$var$load("bIPPg"),
    $9fa6a7cace30b456$var$load("jd7Mc"),
    $9fa6a7cace30b456$var$load("7EorR"),
    $9fa6a7cace30b456$var$load("aYgZt")
]).then(()=>parcelRequire('absYu'));

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("6zQnn"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("6zQnn", function(module, exports) {

let $4c9ea3c238bc5356$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c9ea3c238bc5356$var$load("5dBst"),
    $4c9ea3c238bc5356$var$load("hhss7"),
    $4c9ea3c238bc5356$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<fdcd3907b02c89850ff93dfb052e723b>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "7c791401f0e963cfa78bdcff70a3c87c";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("j2aYM", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $42omo = parcelRequire("42omo");


var $1o4fX = parcelRequire("1o4fX");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $dPJCf = parcelRequire("dPJCf");

function $463b48fb68db8bff$export$b3cda0b328199f72() {
    const { edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const skipLicenseQuery = isFreeEdition || !isLoggedIn || !isLicensed;
    const { refetch: refetch, data: licenseDetailsData, loading: licenseDetailsLoading, error: licenseDetailsDataError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePersistentInviteButtonEligibleLicenseDetailsQuery{license{licenseConsumingUserCount trialEndDate}}`, {
        skip: skipLicenseQuery
    });
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(licenseDetailsData?.license?.trialEndDate);
    const isInTrial = trialDaysLeft ? trialDaysLeft > 0 : false;
    // Sometimes, the trial end date is not set on the initial load for a new tenant, even though they have been put into a trial.
    // This can lead to the invite button not appearing. To mitigate this, we refetch the license details on page transition if we
    // suspect the user is in a trial, but the trial end date is null.
    const transitionId = (0, $dPJCf.useTransitionId)();
    const hasRefetched = (0, $42omo.useRef)(false);
    const initialTransitionId = (0, $42omo.useRef)(transitionId);
    (0, $42omo.useEffect)(()=>{
        if (isInTrial || skipLicenseQuery || licenseDetailsLoading || licenseDetailsDataError) return;
        const trialSuspected = Boolean(licenseDetailsData?.license?.trialEndDate === null && licenseDetailsData?.license?.licenseConsumingUserCount === 1 && !isFreeEdition);
        if (!hasRefetched.current && trialSuspected && transitionId > initialTransitionId.current) {
            refetch();
            hasRefetched.current = true;
        }
    }, [
        edition,
        isFreeEdition,
        isInTrial,
        isLicensed,
        isLoggedIn,
        licenseDetailsData,
        licenseDetailsDataError,
        licenseDetailsLoading,
        refetch,
        skipLicenseQuery,
        transitionId
    ]);
    return {
        loading: licenseDetailsLoading,
        error: licenseDetailsDataError,
        isEligible: isInTrial || isFreeEdition
    };
}
module.exports["usePersistentInviteButtonEligible"] = $463b48fb68db8bff$export$b3cda0b328199f72;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("4T2bk", function(module, exports) {

let $38edfdbc3dc1e53b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38edfdbc3dc1e53b$var$load("fSc0b").then(()=>parcelRequire('vavBY'));

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("b0EGa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9wGTI = parcelRequire("9wGTI");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0,
    hasReceivedHideRequest: false
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1,
                ...(0, $9wGTI.fg)('cc-engagement-omnibar-transition-fix') && {
                    hasReceivedHideRequest: true
                }
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $1P1Tu.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$13aafec54f1ab41c = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hasReceivedHideRequest
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $9zUhf.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useHasReceivedOmniBarHideRequest"] = $6d5fb7464c13acdf$export$13aafec54f1ab41c;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("3sspZ", function(module, exports) {

let $284a07df9063ee7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $284a07df9063ee7c$var$load("l8YLV"),
    $284a07df9063ee7c$var$load("3WB19"),
    $284a07df9063ee7c$var$load("kHOMt"),
    $284a07df9063ee7c$var$load("74vOE"),
    $284a07df9063ee7c$var$load("SepNY"),
    $284a07df9063ee7c$var$load("6wr18"),
    $284a07df9063ee7c$var$load("axHci"),
    $284a07df9063ee7c$var$load("6S3Gy"),
    $284a07df9063ee7c$var$load("21Qlg"),
    $284a07df9063ee7c$var$load("14xAG"),
    $284a07df9063ee7c$var$load("l1nJ9"),
    $284a07df9063ee7c$var$load("kJG13"),
    $284a07df9063ee7c$var$load("knK0D"),
    $284a07df9063ee7c$var$load("a9w2G"),
    $284a07df9063ee7c$var$load("hyzoX"),
    $284a07df9063ee7c$var$load("8UKe0"),
    $284a07df9063ee7c$var$load("iNa18"),
    $284a07df9063ee7c$var$load("Wowvf"),
    $284a07df9063ee7c$var$load("hhss7"),
    $284a07df9063ee7c$var$load("ffEVr"),
    $284a07df9063ee7c$var$load("7EorR"),
    $284a07df9063ee7c$var$load("dTsOE"),
    $284a07df9063ee7c$var$load("6Ie1c"),
    $284a07df9063ee7c$var$load("bIPPg"),
    $284a07df9063ee7c$var$load("4izLy"),
    $284a07df9063ee7c$var$load("9IEev")
]).then(()=>parcelRequire('7dXG0'));

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("141Kq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $62841e239617d5e4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $57b8ef09e6472437$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};


var $62841e239617d5e4$export$2e2bcd8739ae039 = (0, $57b8ef09e6472437$export$2e2bcd8739ae039);

});

parcelRegister("6yQVJ", function(module, exports) {

let $4c6ef9e5e74dd184$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c6ef9e5e74dd184$var$load("5iVCs").then(()=>parcelRequire('5xx4Y'));

});

parcelRegister("bzSID", function(module, exports) {

let $86dd689af41ba059$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86dd689af41ba059$var$load("k7RZQ").then(()=>parcelRequire('hAVgU'));

});

parcelRegister("2FP6T", function(module, exports) {

let $1f270e83f32cb461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f270e83f32cb461$var$load("9CFJc").then(()=>parcelRequire('lk8G1'));

});

parcelRegister("25qh2", function(module, exports) {

let $18506dd820d78f5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18506dd820d78f5b$var$load("3fPuK").then(()=>parcelRequire('aR1vS'));

});

parcelRegister("3tbTt", function(module, exports) {

let $286d4e6469420b68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $286d4e6469420b68$var$load("dUyEb").then(()=>parcelRequire('cryKi'));

});

parcelRegister("5HmEI", function(module, exports) {

let $42628adeb16c1acd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42628adeb16c1acd$var$load("PAD2J").then(()=>parcelRequire('6UEa7'));

});

parcelRegister("2JrHA", function(module, exports) {

let $1fd545cce82aadd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fd545cce82aadd1$var$load("GNuQo").then(()=>parcelRequire('eMR6r'));

});

parcelRegister("7K1vi", function(module, exports) {

let $5a2dfeea5ec5d421$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a2dfeea5ec5d421$var$load("fvsAU").then(()=>parcelRequire('lqRs8'));

});

parcelRegister("lvhk9", function(module, exports) {

let $fa79ee67eedd7f9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa79ee67eedd7f9c$var$load("h7dGJ").then(()=>parcelRequire('abQPO'));

});

parcelRegister("dolI8", function(module, exports) {

let $9bfe5b94426f2bc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bfe5b94426f2bc1$var$load("kg6sH").then(()=>parcelRequire('koNv9'));

});

parcelRegister("hqns1", function(module, exports) {

let $caf70e3c2540bb6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf70e3c2540bb6b$var$load("fqF5W").then(()=>parcelRequire('lHGQG'));

});

parcelRegister("1vs1T", function(module, exports) {

let $118e6dc5e8cffb51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $118e6dc5e8cffb51$var$load("1WNp5").then(()=>parcelRequire('hfuHa'));

});

parcelRegister("BAT91", function(module, exports) {

let $07101216ee604e5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07101216ee604e5b$var$load("iHPxa").then(()=>parcelRequire('4M9Uw'));

});

parcelRegister("l079O", function(module, exports) {

let $f49f26543ad6bdf7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f49f26543ad6bdf7$var$load("Qf3VH").then(()=>parcelRequire('8jbH9'));

});

parcelRegister("jEFBo", function(module, exports) {

let $e4f2060beb20487f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4f2060beb20487f$var$load("79OEV").then(()=>parcelRequire('4zJCj'));

});

parcelRegister("gTjoB", function(module, exports) {

let $c4c0d3fbc9057528$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4c0d3fbc9057528$var$load("27dMt").then(()=>parcelRequire('h0wiX'));

});

parcelRegister("kq4sh", function(module, exports) {

let $edd9b112db2caa32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $edd9b112db2caa32$var$load("bkVVv").then(()=>parcelRequire('fARzr'));

});

parcelRegister("bbLxs", function(module, exports) {

let $825598f47ca268c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $825598f47ca268c9$var$load("MLhYA").then(()=>parcelRequire('7wkkR'));

});

parcelRegister("gfPHN", function(module, exports) {

let $bd5627a8923fc90c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd5627a8923fc90c$var$load("ap7kW").then(()=>parcelRequire('7Ud5x'));

});

parcelRegister("gMTmr", function(module, exports) {

let $c38c128fb79e0a80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c38c128fb79e0a80$var$load("45YAR").then(()=>parcelRequire('dyiwH'));

});

parcelRegister("6ZJsB", function(module, exports) {

let $517bb411b7d3988c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $517bb411b7d3988c$var$load("kqhVG").then(()=>parcelRequire('i54xW'));

});

parcelRegister("dDMw7", function(module, exports) {

let $9ee48d5fc1aa3060$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ee48d5fc1aa3060$var$load("1susf").then(()=>parcelRequire('6kAMA'));

});

parcelRegister("bbzob", function(module, exports) {

let $824c2c56cd8c0a11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $824c2c56cd8c0a11$var$load("dl3k2").then(()=>parcelRequire('cIqRB'));

});

parcelRegister("c4U6C", function(module, exports) {

let $8cb1612c1183126f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cb1612c1183126f$var$load("aquXY").then(()=>parcelRequire('ffYaF'));

});

parcelRegister("6HUgO", function(module, exports) {

let $4e2268541cbfd7f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e2268541cbfd7f5$var$load("klApM"),
    $4e2268541cbfd7f5$var$load("eQgf0"),
    $4e2268541cbfd7f5$var$load("74vOE"),
    $4e2268541cbfd7f5$var$load("6wr18"),
    $4e2268541cbfd7f5$var$load("5uN9h"),
    $4e2268541cbfd7f5$var$load("1TOYq"),
    $4e2268541cbfd7f5$var$load("1yNQY"),
    $4e2268541cbfd7f5$var$load("djHM5"),
    $4e2268541cbfd7f5$var$load("eJQji"),
    $4e2268541cbfd7f5$var$load("kHOMt"),
    $4e2268541cbfd7f5$var$load("hhss7"),
    $4e2268541cbfd7f5$var$load("ffEVr"),
    $4e2268541cbfd7f5$var$load("7EorR"),
    $4e2268541cbfd7f5$var$load("Wowvf"),
    $4e2268541cbfd7f5$var$load("4Nzvy"),
    $4e2268541cbfd7f5$var$load("gY1B8")
]).then(()=>parcelRequire('gFKFJ'));

});

parcelRegister("cFYM0", function(module, exports) {
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $8zs3p = parcelRequire("8zs3p");

const $9c1f04fccaeb1d16$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $42omo.forwardRef)($9c1f04fccaeb1d16$var$_SideNavContent); // Placing this const below the function breaks Compiled!
const $9c1f04fccaeb1d16$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp"
};
function $9c1f04fccaeb1d16$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRef = (0, $42omo.useMemo)(()=>(0, $3654r.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: isFhsEnabled ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $9c1f04fccaeb1d16$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $9c1f04fccaeb1d16$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}
module.exports["SideNavBody"] = $9c1f04fccaeb1d16$export$28f21f3651df4fa1;

});

parcelRegister("eGUIL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $42omo.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("lpfM9", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceRightPanelBundle'
    });
};

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("72MFa"))).RightPanel,
    loading: $d8af34c11b1c225c$var$createLoadingComponent
});
module.exports["PanelLoader"] = $d8af34c11b1c225c$export$bec010aa49373196;

});

parcelRegister("72MFa", function(module, exports) {

let $520e77c7274b1f8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $520e77c7274b1f8d$var$load("ivbae"),
    $520e77c7274b1f8d$var$load("klApM"),
    $520e77c7274b1f8d$var$load("eQgf0"),
    $520e77c7274b1f8d$var$load("6wr18"),
    $520e77c7274b1f8d$var$load("5UCxV"),
    $520e77c7274b1f8d$var$load("8Sbjy"),
    $520e77c7274b1f8d$var$load("2O2Xv"),
    $520e77c7274b1f8d$var$load("736as"),
    $520e77c7274b1f8d$var$load("7EJ3Q"),
    $520e77c7274b1f8d$var$load("lGcru"),
    $520e77c7274b1f8d$var$load("lBu3j"),
    $520e77c7274b1f8d$var$load("tKhaz"),
    $520e77c7274b1f8d$var$load("jbxHq"),
    $520e77c7274b1f8d$var$load("9ijrN"),
    $520e77c7274b1f8d$var$load("37ldp"),
    $520e77c7274b1f8d$var$load("cyGuT"),
    $520e77c7274b1f8d$var$load("hhss7"),
    $520e77c7274b1f8d$var$load("ffEVr"),
    $520e77c7274b1f8d$var$load("jwTn5"),
    $520e77c7274b1f8d$var$load("aYdgM"),
    $520e77c7274b1f8d$var$load("74vOE"),
    $520e77c7274b1f8d$var$load("7EorR"),
    $520e77c7274b1f8d$var$load("Wowvf"),
    $520e77c7274b1f8d$var$load("4Nzvy"),
    $520e77c7274b1f8d$var$load("h3ABO"),
    $520e77c7274b1f8d$var$load("kC80R"),
    $520e77c7274b1f8d$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});

parcelRegister("8Hyz1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $2f7c8c88765be2b1$export$730cc5718beea0d0 = ()=>{
    return (0, $42omo.useContext)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext);
};
const $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac = ({ children: children })=>{
    const [enabledMessages, setEnabledMessages] = (0, $42omo.useState)([]);
    const enablePostOfficeSideNavMessage = (0, $42omo.useCallback)((message)=>{
        setEnabledMessages((prev)=>{
            if (prev.includes(message)) return prev;
            return [
                ...prev,
                message
            ];
        });
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            enabledMessages: enabledMessages,
            enablePostOfficeSideNavMessage: enablePostOfficeSideNavMessage
        }), [
        enabledMessages,
        enablePostOfficeSideNavMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["usePostOfficeSideNavMessages"] = $2f7c8c88765be2b1$export$730cc5718beea0d0;
module.exports["PostOfficeSideNavMessageProvider"] = $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("cLgYq", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");

const $80f6c4cf061c88c5$export$909966f260e2b2b = (articleId, setArticleId, routeName, setRouteName, routeGroup, setRouteGroup)=>({
        getArticleId: ()=>articleId,
        setArticleId: setArticleId,
        getRouteName: ()=>routeName,
        setRouteName: setRouteName,
        getRouteGroup: ()=>routeGroup,
        setRouteGroup: setRouteGroup
    });
const $80f6c4cf061c88c5$var$initialInProductHelpState = {
    articleId: '',
    routeName: '',
    routeGroup: ''
};
const $80f6c4cf061c88c5$var$inProductHelpActions = {
    setArticleId: (articleId)=>({ setState: setState })=>{
            setState({
                articleId: articleId
            });
        },
    setRouteName: (routeName)=>({ setState: setState })=>{
            setState({
                routeName: routeName
            });
        },
    setRouteGroup: (routeGroup)=>({ setState: setState })=>{
            setState({
                routeGroup: routeGroup
            });
        }
};
const $80f6c4cf061c88c5$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$80f6c4cf061c88c5$var$initialInProductHelpState
    },
    actions: $80f6c4cf061c88c5$var$inProductHelpActions,
    name: 'inProductHelpContext'
});
const $80f6c4cf061c88c5$export$d9f3a3de6974e16a = (0, $9zUhf.createActionsHook)($80f6c4cf061c88c5$var$Store);
const $80f6c4cf061c88c5$export$b1fca540f7ef5476 = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.articleId
});
const $80f6c4cf061c88c5$export$15e1d4730ce65e9d = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeName
});
const $80f6c4cf061c88c5$export$1dfb78b8caec7720 = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeGroup
});
const $80f6c4cf061c88c5$export$a611b87b3ebe1475 = (0, $FOT9i.createContainer)($80f6c4cf061c88c5$var$Store, {
    onInit: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        },
    onUpdate: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        }
});
const $80f6c4cf061c88c5$export$a61d77bd8effd79e = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($80f6c4cf061c88c5$export$a611b87b3ebe1475, null, children);
};
module.exports["useInProductHelpActions"] = $80f6c4cf061c88c5$export$d9f3a3de6974e16a;
module.exports["useInProductHelpArticleId"] = $80f6c4cf061c88c5$export$b1fca540f7ef5476;
module.exports["InProductHelpProvider"] = $80f6c4cf061c88c5$export$a61d77bd8effd79e;

});

parcelRegister("jNGt9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $917iu = parcelRequire("917iu");


var $3HOqx = parcelRequire("3HOqx");


var $dpPtd = parcelRequire("dpPtd");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $dPJCf = parcelRequire("dPJCf");

const $e71baba61e1a588e$var$messages = (0, $h82at.defineMessages)({
    nthUserOnboardingFlagTitle: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.title",
        defaultMessage: "Just in case you missed it"
    },
    nthUserOnboardingFlagContent: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.content",
        defaultMessage: "We've got some handy tips and tricks to help you get started in Confluence."
    },
    nthUserOnboardingFlagAction: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.action",
        defaultMessage: "Check it out"
    },
    nthUserOnboardingFlagLabel: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.flag.label",
        defaultMessage: "Lightbulb"
    }
});
const $e71baba61e1a588e$export$be5b862a7b78a50e = (url)=>{
    // Pattern: /spaces/{spaceKey}/pages/{contentId}/{page-title}
    const match = url.match(/\/spaces\/[^/]+\/pages\/(\d+)/);
    return match ? match[1] : null;
};
const $e71baba61e1a588e$var$DAYS_TO_WAIT_AFTER_ONBOARDING_COMPLETION = 1;
const $e71baba61e1a588e$var$useNthUserOnboardingFlag = ()=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const flagId = 'NTH_USER_ONBOARDING_FLAG';
    const dismissFlag = (0, $42omo.useRef)(null);
    const showNthUserOnboardingFlag = (0, $42omo.useCallback)((nthUserGSPage)=>{
        setOnboardingState({
            key: (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_FLAG_VIEWED,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewNthUserOnboardingFlag'
            }
        }).fire();
        const handleActionClick = ()=>{
            if (dismissFlag.current) dismissFlag.current();
            push(nthUserGSPage);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'flag',
                    actionSubjectId: flagId,
                    source: 'homepage'
                }
            }).fire();
        };
        dismissFlag.current = showFlag({
            id: flagId,
            testId: 'nth-user-onboarding-flag',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                label: $e71baba61e1a588e$var$messages.nthUserOnboardingFlagLabel.defaultMessage
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e71baba61e1a588e$var$messages.nthUserOnboardingFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e71baba61e1a588e$var$messages.nthUserOnboardingFlagContent),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e71baba61e1a588e$var$messages.nthUserOnboardingFlagAction),
                    onClick: handleActionClick
                }
            ],
            onDismissed: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'dismissed',
                        actionSubject: 'flag',
                        actionSubjectId: flagId,
                        source: 'homepage'
                    }
                }).fire();
            }
        });
    }, [
        showFlag,
        setOnboardingState,
        push,
        flagId,
        createAnalyticsEvent
    ]);
    return {
        showNthUserOnboardingFlag: showNthUserOnboardingFlag
    };
};
const $e71baba61e1a588e$var$NthUserOnboardingFlagInner = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_FLAG_VIEWED,
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP,
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_PAGE_VIEWED,
        (0, $dBcar.ONBOARDING_EXPERIENCES).IMPROVED_GET_STARTED_NTH_USER_PATH
    ]);
    const deserializedState = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { showNthUserOnboardingFlag: showNthUserOnboardingFlag } = $e71baba61e1a588e$var$useNthUserOnboardingFlag();
    const timestamp = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP];
    const nthUserFlagViewed = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_FLAG_VIEWED];
    const nthUserGSPage = deserializedState[0, $dBcar.IMPROVED_GET_STARTED_NTH_USER_PATH];
    const nthUserOnboardingPageViewed = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_PAGE_VIEWED];
    // Show flag once when all conditions are met
    (0, $42omo.useEffect)(()=>{
        if (!cloudId || !userId) return;
        if (onboardingStateLoading || onboardingStateError || !timestamp || nthUserFlagViewed || nthUserOnboardingPageViewed) return;
        const daysSinceCompletion = (0, $917iu.default)(new Date(), new Date(Number(timestamp)));
        if (daysSinceCompletion < $e71baba61e1a588e$var$DAYS_TO_WAIT_AFTER_ONBOARDING_COMPLETION || !nthUserGSPage) return;
        showNthUserOnboardingFlag(nthUserGSPage);
    }, [
        onboardingStateLoading,
        onboardingStateError,
        nthUserFlagViewed,
        nthUserOnboardingPageViewed,
        nthUserGSPage,
        deserializedState,
        showNthUserOnboardingFlag,
        timestamp,
        cloudId,
        userId
    ]);
    return null;
};
const $e71baba61e1a588e$export$ffbdb4c080ecfc55 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e71baba61e1a588e$var$NthUserOnboardingFlagInner, null));
};
module.exports["extractContentIdFromUrl"] = $e71baba61e1a588e$export$be5b862a7b78a50e;
module.exports["NthUserOnboardingFlag"] = $e71baba61e1a588e$export$ffbdb4c080ecfc55;

});

parcelRegister("hPTbh", function(module, exports) {
/**
 * Centralized analytics constants for the snippets package.
 *
 * Organized into three sections:
 *   1. Shared    – source, event types, origins, page modes (used by all events)
 *   2. UI        – subjects, actions, subject IDs, modal outcomes (sendUIEvent)
 *   3. Operational – subjects, actions (sendOperationalEvent)
 */ // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  Shared
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
/** Event type used to dispatch analytics events */ var $2394c5239b489cef$export$a0913705d36eb84c = /*#__PURE__*/ function(ANALYTICS_EVENT_TYPE) {
    ANALYTICS_EVENT_TYPE["SEND_UI_EVENT"] = "sendUIEvent";
    ANALYTICS_EVENT_TYPE["SEND_OPERATIONAL_EVENT"] = "sendOperationalEvent";
    return ANALYTICS_EVENT_TYPE;
}({});
var $2394c5239b489cef$export$17897eee0c3e7eb1 = /*#__PURE__*/ function(ANALYTICS_TYPE) {
    ANALYTICS_TYPE["UI"] = "ui";
    ANALYTICS_TYPE["OPERATIONAL"] = "operational";
    return ANALYTICS_TYPE;
}({});
const $2394c5239b489cef$export$f7109619a5e9e0d6 = 'confluenceSnippets';
var $2394c5239b489cef$export$8dd55f56fde129aa = /*#__PURE__*/ function(ANALYTICS_ORIGIN) {
    // snippet CRUD modals
    ANALYTICS_ORIGIN["CREATE_SNIPPET_MODAL"] = "createSnippetModal";
    ANALYTICS_ORIGIN["EDIT_SNIPPET_MODAL"] = "editSnippetModal";
    ANALYTICS_ORIGIN["DUPLICATE_SNIPPET_MODAL"] = "duplicateSnippetModal";
    ANALYTICS_ORIGIN["DELETE_SNIPPET_MODAL"] = "deleteSnippetModal";
    // onboarding
    ANALYTICS_ORIGIN["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // surfaces
    ANALYTICS_ORIGIN["SNIPPET_PANEL"] = "snippetPanel";
    ANALYTICS_ORIGIN["SNIPPET_GALLERY"] = "snippetGallery";
    // toolbars / menus
    ANALYTICS_ORIGIN["CONTEXTUAL_TOOLBAR"] = "contextualToolbar";
    ANALYTICS_ORIGIN["BLOCK_MENU"] = "blockMenu";
    return ANALYTICS_ORIGIN;
}({});
var $2394c5239b489cef$export$b397791890e3384b = /*#__PURE__*/ function(ANALYTICS_CREATE_SOURCE) {
    ANALYTICS_CREATE_SOURCE["EMPTY_PANEL"] = "snippetPanelEmpty";
    ANALYTICS_CREATE_SOURCE["SNIPPET_PANEL_LIST"] = "snippetPanelCreateItem";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_VIEW"] = "snippetHighlightView";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_EDIT"] = "snippetHighlightEdit";
    return ANALYTICS_CREATE_SOURCE;
}({});
var $2394c5239b489cef$export$a23e6d34a2dcf281 = /*#__PURE__*/ function(ANALYTICS_PAGE_MODE) {
    ANALYTICS_PAGE_MODE["VIEW"] = "view";
    ANALYTICS_PAGE_MODE["EDIT"] = "edit";
    ANALYTICS_PAGE_MODE["LIVE"] = "live";
    return ANALYTICS_PAGE_MODE;
}({});
var $2394c5239b489cef$export$eeb695ba3667fc27 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT) {
    ANALYTICS_UI_SUBJECT["BUTTON"] = "button";
    ANALYTICS_UI_SUBJECT["MODAL"] = "modal";
    ANALYTICS_UI_SUBJECT["TEXT_FIELD"] = "textField";
    ANALYTICS_UI_SUBJECT["DROPDOWN_ITEM"] = "dropdownItem";
    ANALYTICS_UI_SUBJECT["SNIPPETS"] = "snippets";
    return ANALYTICS_UI_SUBJECT;
}({});
var $2394c5239b489cef$export$2fdff18978b1ec73 = /*#__PURE__*/ function(ANALYTICS_UI_ACTION) {
    ANALYTICS_UI_ACTION["CLICKED"] = "clicked";
    ANALYTICS_UI_ACTION["CLOSED"] = "closed";
    ANALYTICS_UI_ACTION["TYPED"] = "typed";
    return ANALYTICS_UI_ACTION;
}({});
var $2394c5239b489cef$export$f6034aaa561169a2 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT_ID) {
    // button
    ANALYTICS_UI_SUBJECT_ID["CREATE_SNIPPET"] = "createSnippet";
    ANALYTICS_UI_SUBJECT_ID["DELETE_SNIPPET"] = "deleteSnippet";
    ANALYTICS_UI_SUBJECT_ID["EDIT_SNIPPET"] = "editSnippet";
    ANALYTICS_UI_SUBJECT_ID["DUPLICATE_SNIPPET"] = "duplicateSnippet";
    ANALYTICS_UI_SUBJECT_ID["INSERT_SNIPPET"] = "insertSnippet";
    ANALYTICS_UI_SUBJECT_ID["COPY_SNIPPET_LINK"] = "copySnippetLink";
    ANALYTICS_UI_SUBJECT_ID["USE_SNIPPET_DETAIL_PANEL"] = "useSnippetDetailPanel";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    // textField / button / dropdownItem (filter-related)
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_CATEGORY_FILTER"] = "snippetCategoryFilter";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SEARCH"] = "snippetSearch";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SORT_ORDER"] = "snippetSortOrder";
    // FirstSnippetCreatedModal (use attributes for viewed vs dismissed and dismissalAction)
    ANALYTICS_UI_SUBJECT_ID["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // Empty state primary actions
    ANALYTICS_UI_SUBJECT_ID["EMPTY_MY_TEMPLATES_CALL_TO_ACTION"] = "emptyMyTemplatesCallToAction";
    ANALYTICS_UI_SUBJECT_ID["EMPTY_FAVORITES_CALL_TO_ACTION"] = "emptyFavoritesCallToAction";
    return ANALYTICS_UI_SUBJECT_ID;
}({});
var $2394c5239b489cef$export$4d76a1418128341e = /*#__PURE__*/ function(MODAL_TYPE) {
    MODAL_TYPE["CREATE"] = "CREATE";
    MODAL_TYPE["EDIT"] = "EDIT";
    MODAL_TYPE["DUPLICATE"] = "DUPLICATE";
    return MODAL_TYPE;
}({});
var $2394c5239b489cef$export$42a4ee1a85ef55d2 = /*#__PURE__*/ function(MODAL_OUTCOME) {
    MODAL_OUTCOME["CREATED"] = "created";
    MODAL_OUTCOME["EDITED"] = "edited";
    MODAL_OUTCOME["DUPLICATED"] = "duplicated";
    MODAL_OUTCOME["DELETED"] = "deleted";
    MODAL_OUTCOME["CANCELLED"] = "cancelled";
    MODAL_OUTCOME["CLOSED"] = "closed";
    return MODAL_OUTCOME;
}({});
var $2394c5239b489cef$export$3c94fecf7ead2464 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_SUBJECT) {
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    ANALYTICS_OPERATIONAL_SUBJECT["INSERT_SNIPPET"] = "insertSnippet";
    // API failures
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_CREATE"] = "snippetApiCreate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DUPLICATE"] = "snippetApiDuplicate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UPDATE"] = "snippetApiUpdate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DELETE"] = "snippetApiDelete";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_FETCH"] = "snippetApiFetch";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SHARE"] = "snippetApiShare";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UNSHARE"] = "snippetApiUnshare";
    // API successes
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SAVE_SUCCESS"] = "snippetApiSaveSuccess";
    // AI metadata
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_AI_METADATA"] = "snippetApiAiMetadata";
    // Client-side errors
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_ADF_SERIALIZATION"] = "snippetAdfSerialization";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_PREVIEW_RENDER"] = "snippetPreviewRender";
    return ANALYTICS_OPERATIONAL_SUBJECT;
}({});
var $2394c5239b489cef$export$2fd2c1b71075f9e9 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_ACTION) {
    ANALYTICS_OPERATIONAL_ACTION["FAILED"] = "failed";
    ANALYTICS_OPERATIONAL_ACTION["SUCCEEDED"] = "succeeded";
    ANALYTICS_OPERATIONAL_ACTION["FETCHED"] = "fetched";
    return ANALYTICS_OPERATIONAL_ACTION;
}({});
module.exports["ANALYTICS_EVENT_TYPE"] = $2394c5239b489cef$export$a0913705d36eb84c;
module.exports["ANALYTICS_TYPE"] = $2394c5239b489cef$export$17897eee0c3e7eb1;
module.exports["ANALYTICS_SOURCE"] = $2394c5239b489cef$export$f7109619a5e9e0d6;
module.exports["ANALYTICS_ORIGIN"] = $2394c5239b489cef$export$8dd55f56fde129aa;
module.exports["ANALYTICS_CREATE_SOURCE"] = $2394c5239b489cef$export$b397791890e3384b;
module.exports["ANALYTICS_PAGE_MODE"] = $2394c5239b489cef$export$a23e6d34a2dcf281;
module.exports["ANALYTICS_UI_SUBJECT"] = $2394c5239b489cef$export$eeb695ba3667fc27;
module.exports["ANALYTICS_UI_ACTION"] = $2394c5239b489cef$export$2fdff18978b1ec73;
module.exports["ANALYTICS_UI_SUBJECT_ID"] = $2394c5239b489cef$export$f6034aaa561169a2;
module.exports["MODAL_TYPE"] = $2394c5239b489cef$export$4d76a1418128341e;
module.exports["MODAL_OUTCOME"] = $2394c5239b489cef$export$42a4ee1a85ef55d2;
module.exports["ANALYTICS_OPERATIONAL_SUBJECT"] = $2394c5239b489cef$export$3c94fecf7ead2464;
module.exports["ANALYTICS_OPERATIONAL_ACTION"] = $2394c5239b489cef$export$2fd2c1b71075f9e9;

});

parcelRegister("jxXkP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");


var $hPTbh = parcelRequire("hPTbh");

const $5d19246504a43db4$export$8076fd3f013c4bb9 = (origin)=>{
    const $ = (0, $frIzR.c)(28);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== origin) {
        t0 = (attributes)=>{
            if (!origin) return attributes;
            return {
                origin: origin,
                ...attributes
            };
        };
        $[0] = origin;
        $[1] = t0;
    } else t0 = $[1];
    const mergeAttributes = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== mergeAttributes) {
        t1 = (data)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_UI_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).UI,
                    ...data,
                    attributes: mergeAttributes(data.attributes)
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = mergeAttributes;
        $[4] = t1;
    } else t1 = $[4];
    const fireUIAnalytic = t1;
    let t2;
    if ($[5] !== createAnalyticsEvent || $[6] !== mergeAttributes) {
        t2 = (data_0)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_OPERATIONAL_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).OPERATIONAL,
                    ...data_0,
                    attributes: mergeAttributes(data_0.attributes)
                }
            }).fire();
        };
        $[5] = createAnalyticsEvent;
        $[6] = mergeAttributes;
        $[7] = t2;
    } else t2 = $[7];
    const fireOperationalAnalytic = t2;
    let t3;
    if ($[8] !== fireUIAnalytic) {
        t3 = (actionSubjectId, attributes_0)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).BUTTON,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId,
                attributes: attributes_0
            });
        };
        $[8] = fireUIAnalytic;
        $[9] = t3;
    } else t3 = $[9];
    const fireButtonClickedAnalytic = t3;
    let t4;
    if ($[10] !== fireUIAnalytic) {
        t4 = (actionSubjectId_0, attributes_1)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).MODAL,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLOSED,
                actionSubjectId: actionSubjectId_0,
                attributes: attributes_1
            });
        };
        $[10] = fireUIAnalytic;
        $[11] = t4;
    } else t4 = $[11];
    const fireModalClosedAnalytic = t4;
    let t5;
    if ($[12] !== fireUIAnalytic) {
        t5 = (actionSubjectId_1, attributes_2)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).TEXT_FIELD,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).TYPED,
                actionSubjectId: actionSubjectId_1,
                attributes: attributes_2
            });
        };
        $[12] = fireUIAnalytic;
        $[13] = t5;
    } else t5 = $[13];
    const fireTextFieldTypedAnalytic = t5;
    let t6;
    if ($[14] !== fireUIAnalytic) {
        t6 = (actionSubjectId_2, attributes_3)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).DROPDOWN_ITEM,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId_2,
                attributes: attributes_3
            });
        };
        $[14] = fireUIAnalytic;
        $[15] = t6;
    } else t6 = $[15];
    const fireDropdownItemClickedAnalytic = t6;
    let t7;
    if ($[16] !== fireOperationalAnalytic) {
        t7 = (actionSubject, attributes_4)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FAILED,
                attributes: attributes_4
            });
        };
        $[16] = fireOperationalAnalytic;
        $[17] = t7;
    } else t7 = $[17];
    const fireFailedAnalytic = t7;
    let t8;
    if ($[18] !== fireOperationalAnalytic) {
        t8 = (actionSubject_0, attributes_5)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject_0,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).SUCCEEDED,
                attributes: attributes_5
            });
        };
        $[18] = fireOperationalAnalytic;
        $[19] = t8;
    } else t8 = $[19];
    const fireSuccessAnalytic = t8;
    let t9;
    if ($[20] !== fireButtonClickedAnalytic || $[21] !== fireDropdownItemClickedAnalytic || $[22] !== fireFailedAnalytic || $[23] !== fireModalClosedAnalytic || $[24] !== fireOperationalAnalytic || $[25] !== fireSuccessAnalytic || $[26] !== fireTextFieldTypedAnalytic) {
        t9 = {
            fireOperationalAnalytic: fireOperationalAnalytic,
            fireButtonClickedAnalytic: fireButtonClickedAnalytic,
            fireModalClosedAnalytic: fireModalClosedAnalytic,
            fireTextFieldTypedAnalytic: fireTextFieldTypedAnalytic,
            fireDropdownItemClickedAnalytic: fireDropdownItemClickedAnalytic,
            fireFailedAnalytic: fireFailedAnalytic,
            fireSuccessAnalytic: fireSuccessAnalytic
        };
        $[20] = fireButtonClickedAnalytic;
        $[21] = fireDropdownItemClickedAnalytic;
        $[22] = fireFailedAnalytic;
        $[23] = fireModalClosedAnalytic;
        $[24] = fireOperationalAnalytic;
        $[25] = fireSuccessAnalytic;
        $[26] = fireTextFieldTypedAnalytic;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
};
module.exports["useSnippetAnalytics"] = $5d19246504a43db4$export$8076fd3f013c4bb9;

});

parcelRegister("cYuYM", function(module, exports) {

var $5vi32 = parcelRequire("5vi32");


var $9bL1w = parcelRequire("9bL1w");

const $955ee3c4efc889bc$export$349f17fbd3b37cd1 = ()=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    return !!(isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled);
};
module.exports["useIsSnippetCreateEnabled"] = $955ee3c4efc889bc$export$349f17fbd3b37cd1;

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo') && (0, $9wGTI.fg)('platform_editor_ai_add_embed_streaming');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("hpNab", function(module, exports) {

var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'loom-external-open',
        'rovo'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("dYU3e", function(module, exports) {


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");



var $9wGTI = parcelRequire("9wGTI");




var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    let single = true;
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch(true)
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client.__isAGGClient === true;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return client.query({
        query: query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext
    }).then((result)=>{
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
        return {
            ...result,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("emNvf", function(module, exports) {
/**
 * @generated SignedSource<<2102c751013adb87b04083d2d31e4555>>
 * @relayHash d82ceab955fc558f582faba05877ecf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03
const $34dcc93d00ac09e9$var$node = function() {
    var v0 = [
        {
            "concreteType": "LookAndFeelSettings",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "custom",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HeaderLookAndFeel",
                            "kind": "LinkedField",
                            "name": "horizontalHeader",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundColor"
                                },
                                {
                                    "concreteType": "NavigationLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "primaryNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "highlightColor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d82ceab955fc558f582faba05877ecf8",
            "id": "765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03",
            "metadata": {},
            "name": "ThemeQuery",
            "operationKind": "query",
            "text": "query ThemeQuery{lookAndFeel{custom{horizontalHeader{backgroundColor,primaryNavigation{highlightColor}}}}}"
        }
    };
}();
$34dcc93d00ac09e9$var$node.hash = "1e70f0bab96233984a0d61d455b5303b";
var $34dcc93d00ac09e9$export$2e2bcd8739ae039 = $34dcc93d00ac09e9$var$node;
module.exports["default"] = $34dcc93d00ac09e9$export$2e2bcd8739ae039;

});

parcelRegister("lyWac", function(module, exports) {

var $3mugH = parcelRequire("3mugH");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') {
                const fulfilledValue = result.value;
                if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                else if (Array.isArray(fulfilledValue)) {
                    const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                    errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                }
            }
        }
        if (errors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return errors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<fc3f514c1b8fc23b442bac6c90faf10b>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("hAiCi", function(module, exports) {
/**
 * @generated SignedSource<<03bdf8f361c8eb201c9dfdf04f8a02bd>>
 * @relayHash 03c88593e0a708b4a806a4bb00935330
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee
const $1d80fc45612ce410$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "value"
    }, v1 = [
        {
            "concreteType": "SiteConfiguration",
            "kind": "LinkedField",
            "name": "siteConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customSiteLogo"
                }
            ]
        },
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "siteTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "showApplicationTitle"
                }
            ]
        },
        {
            "concreteType": "SiteDescription",
            "kind": "LinkedField",
            "name": "siteDescription",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "03c88593e0a708b4a806a4bb00935330",
            "id": "2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee",
            "metadata": {},
            "name": "TopNavigationQuery",
            "operationKind": "query",
            "text": "query TopNavigationQuery{siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary},photos{value}}}"
        }
    };
}();
$1d80fc45612ce410$var$node.hash = "58252cd5493d65d590f00c523b3d3ad8";
var $1d80fc45612ce410$export$2e2bcd8739ae039 = $1d80fc45612ce410$var$node;
module.exports["default"] = $1d80fc45612ce410$export$2e2bcd8739ae039;

});

parcelRegister("74VX5", function(module, exports) {
/**
 * @generated SignedSource<<6dbe057c43272742b66eaa5c5b9d4422>>
 * @relayHash 13e9ccffd4783d3489f7fdc0bdb79076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8
const $7964c46f2f85665b$var$node = function() {
    var v0 = [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "13e9ccffd4783d3489f7fdc0bdb79076",
            "id": "9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8",
            "metadata": {},
            "name": "NotificationsButtonQuery",
            "operationKind": "query",
            "text": "query NotificationsButtonQuery{notifications{unseenNotificationCount}}"
        }
    };
}();
$7964c46f2f85665b$var$node.hash = "942a544fd139c706378825d031824679";
var $7964c46f2f85665b$export$2e2bcd8739ae039 = $7964c46f2f85665b$var$node;
module.exports["default"] = $7964c46f2f85665b$export$2e2bcd8739ae039;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<dba482b8278907dc3da4caa91ab1ec66>>
 * @relayHash 5ea23e55ef5088b9c4837d3773b81cb1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5ea23e55ef5088b9c4837d3773b81cb1",
            "id": "e1e2926e708d3fd40690e6907effdf9227a54de6cc9fa82c15ff0acd3a82250d",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "a1e29398bca6058e29a8240f26bd213b";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("MyxIQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bnKhH = parcelRequire("bnKhH");


var $5dPMD = parcelRequire("5dPMD");


var $301rJ = parcelRequire("301rJ");



var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");


var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $5dPMD.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'post-office',
                // Tells Tesseract to S2S with `post-office`
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $bnKhH.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $5dPMD.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $42omo.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $42omo.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $42omo.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, preloadedSessionContext, extraFetchOptions)=>{
    return $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(preloadedSessionContext),
        environment: {
            currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(preloadedSessionContext.environment)
        }
    }, extraFetchOptions);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-\/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<513d7f919c579d2248fb418730db53cb>>
 * @relayHash f5d07637afe71c7ca06b7f159493ea94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "otherContentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "transitionType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            v4 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v8 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v9 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v10 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "success"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v14 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v15 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v17 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v23 = [
        v5 /*: any*/ ,
        v20 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v21 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v24 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v23 /*: any*/ 
    }, v25 = [
        v21 /*: any*/ 
    ], v26 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v23 /*: any*/ 
            }
        ]
    }, v27 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v25 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v20 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v21 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v28 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v5 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f5d07637afe71c7ca06b7f159493ea94",
            "id": "e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType){content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a2315c6dd75143b0285f57068b70bc22";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<e3dd06d27d8a1f0e6d8bc9c98ac1162e>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("6UBEn", function(module, exports) {
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $3cc01bd0176870aa$var$MIN_VALUE = 0;
const $3cc01bd0176870aa$var$MAX_VALUE = 1;
const $3cc01bd0176870aa$var$increasingBarAnimation = null;
const $3cc01bd0176870aa$var$decreasingBarAnimation = null;
const $3cc01bd0176870aa$var$containerStyles = null;
const $3cc01bd0176870aa$var$containerStylesT26Shape = null;
const $3cc01bd0176870aa$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $3cc01bd0176870aa$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $3cc01bd0176870aa$var$barStyles = null;
const $3cc01bd0176870aa$var$barStylesT26Shape = null;
const $3cc01bd0176870aa$var$determinateBarStyles = null;
const $3cc01bd0176870aa$var$increasingBarStyles = null;
const $3cc01bd0176870aa$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $3cc01bd0176870aa$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $3cc01bd0176870aa$var$MIN_VALUE : Math.max($3cc01bd0176870aa$var$MIN_VALUE, Math.min(value, $3cc01bd0176870aa$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $3cc01bd0176870aa$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $3cc01bd0176870aa$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0",
            $3cc01bd0176870aa$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40",
                        (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
                    ])
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                        $3cc01bd0176870aa$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
                        (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $gMc0m.default)([
                "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
                $3cc01bd0176870aa$var$barAppearance[appearance],
                "_v564calv",
                (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
            ])
        })
    });
};
var $3cc01bd0176870aa$export$2e2bcd8739ae039 = $3cc01bd0176870aa$var$ProgressBar;
module.exports["default"] = $3cc01bd0176870aa$export$2e2bcd8739ae039;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("1wScy", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $11d2d2e303d6c19d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11d2d2e303d6c19d$var$hasOwnProperty = $11d2d2e303d6c19d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $11d2d2e303d6c19d$var$groupBy = $77wHb(function(result, value, key) {
    if ($11d2d2e303d6c19d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3PAnx(result, key, [
        value
    ]);
});
module.exports = $11d2d2e303d6c19d$var$groupBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("2twC9", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");


var $hkHTQ = parcelRequire("hkHTQ");

/** Used to match HTML entities and HTML characters. */ var $1cd796ba122ff88e$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $1cd796ba122ff88e$var$reHasEscapedHtml = RegExp($1cd796ba122ff88e$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $1cd796ba122ff88e$var$unescape(string) {
    string = $fPVB6(string);
    return string && $1cd796ba122ff88e$var$reHasEscapedHtml.test(string) ? string.replace($1cd796ba122ff88e$var$reEscapedHtml, $hkHTQ) : string;
}
module.exports = $1cd796ba122ff88e$var$unescape;

});

parcelRegister("hkHTQ", function(module, exports) {

var $jghHU = parcelRequire("jghHU");

/** Used to map HTML entities to characters. */ var $c9e65b8529dd6337$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $c9e65b8529dd6337$var$unescapeHtmlChar = $jghHU($c9e65b8529dd6337$var$htmlUnescapes);
module.exports = $c9e65b8529dd6337$var$unescapeHtmlChar;

});

parcelRegister("jwvcr", function(module, exports) {

var $gHaxX = parcelRequire("gHaxX");

var $fGuvu = parcelRequire("fGuvu");

var $d4Pk4 = parcelRequire("d4Pk4");


var $bNDrX = parcelRequire("bNDrX");

class $93b15711ba97ccdb$export$4f783fde6fb5beb2 {
    async getTapTraits(resourceIds, useLongCache = false, config) {
        try {
            const request = {
                resourceIds: resourceIds,
                requester: 'post-office'
            };
            let tapResponse;
            if (useLongCache) tapResponse = await this.tapClient.postForOptoutTraitsLongCache(request, undefined, config);
            else tapResponse = await this.tapClient.postForEntityTraits(request, undefined, config);
            this.metrics.counter('post-office.tap-client', {
                status: 'success',
                cached: useLongCache.toString(),
                endPoint: 'postForEntityTraits',
                method: 'POST'
            }).incr();
            return tapResponse.data.entities;
        } catch (error) {
            this.metrics.counter('post-office.tap-client', {
                status: 'error',
                cached: useLongCache.toString(),
                endPoint: 'postForEntityTraits',
                method: 'POST'
            }).incr();
            this.logger.error({
                error: error
            }, 'Error occurred when getting TAP traits');
            throw error;
        }
    }
    /*
   * Gets all TAP traits (including audiences) for a SITE USER.
   * This is cached for 5 minutes.
   */ async getSiteUserTraits(siteUserRequestParams) {
        return (0, $bNDrX.getSiteUserTraitsHelper)(siteUserRequestParams, {
            cachedTapClient: this.tapClient,
            requester: 'post-office',
            logger: this.logger
        });
    }
    constructor(metrics, logger, tapClient){
        this.metrics = metrics;
        this.logger = logger;
        this.tapClient = tapClient;
    }
}
/**
 * Shared utility to fetch TAP traits for a given entity
 * @param resourceAri - The resource ARI string of the entity to fetch TAP Traits for.
 * @param resourceType - The type of the resource (e.g. 'site-user', 'identity-user').
 * @param tapProvider - The TAP Provider to use.
 * @param logger - Optional logger for logging.
 * @returns The TAP Traits for the resource.
 */ const $93b15711ba97ccdb$var$fetchTapTraits = async (resourceAri, resourceType, tapProvider, logger, config)=>{
    const useLongCache = false; // Long Cache option is for Opt-out with a 10hr TTL, default option is 5-min TTL
    try {
        const tapSidecarResponse = await tapProvider.getTapTraits([
            resourceAri
        ], useLongCache, config);
        const tapTraits = tapSidecarResponse?.find(({ resourceId: resourceId })=>resourceId === resourceAri)?.attributes;
        logger?.info({
            resourceType: resourceType,
            tapTraitsLength: tapTraits !== undefined ? Object.keys(tapTraits).length : undefined
        }, `Successfully fetched TAP Traits for ${resourceType}`);
        return tapTraits;
    } catch (error) {
        logger?.error({
            error: error,
            resourceType: resourceType
        }, `Error fetching TAP Traits for ${resourceType}`);
        throw error;
    }
};
const $93b15711ba97ccdb$export$4d847601c52d1267 = async ({ userId: userId, siteId: siteId, tapProvider: tapProvider, logger: logger, config: config })=>{
    const siteUserResourceAri = (0, $fGuvu.MeasurementSiteUserAri).create({
        siteId: siteId,
        aaId: userId
    }).toString();
    return $93b15711ba97ccdb$var$fetchTapTraits(siteUserResourceAri, 'site-user', tapProvider, logger, config);
};
const $93b15711ba97ccdb$export$6ada1c1660a10f39 = async ({ siteId: siteId, tapProvider: tapProvider, logger: logger })=>{
    const siteResourceAri = (0, $d4Pk4.PlatformSiteAri).create({
        siteId: siteId
    }).toString();
    return $93b15711ba97ccdb$var$fetchTapTraits(siteResourceAri, 'site', tapProvider, logger);
};
const $93b15711ba97ccdb$export$fa4cc618076f71d8 = async ({ userId: userId, tapProvider: tapProvider, logger: logger })=>{
    const aaidResourceAri = (0, $gHaxX.IdentityUserAri).create({
        userId: userId
    }).toString();
    return $93b15711ba97ccdb$var$fetchTapTraits(aaidResourceAri, 'identity-user', tapProvider, logger);
};
module.exports["getTapTraitsForSite"] = $93b15711ba97ccdb$export$6ada1c1660a10f39;
module.exports["getTapTraitsForIdentityUser"] = $93b15711ba97ccdb$export$fa4cc618076f71d8;

});

parcelRegister("fGuvu", function(module, exports) {

var $qHG1y = parcelRequire("qHG1y");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/measurement/site-user/manifest.ts
var $b6b27147665fcc2c$var$measurementSiteUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $qHG1y.MeasurementSiteUserAriResourceOwner),
    resourceType: (0, $qHG1y.MeasurementSiteUserAriResourceType),
    resourceIdSlug: "{siteId}/{aaId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        aaId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/measurement/site-user/index.ts
var $b6b27147665fcc2c$export$b0483dc480916200 = class _MeasurementSiteUserAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get aaId() {
        return this._aaId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b6b27147665fcc2c$var$measurementSiteUserAriStaticOpts.qualifier,
            platformQualifier: $b6b27147665fcc2c$var$measurementSiteUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $b6b27147665fcc2c$var$measurementSiteUserAriStaticOpts.resourceOwner,
            resourceType: $b6b27147665fcc2c$var$measurementSiteUserAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}/${opts.aaId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId,
                aaId: opts.aaId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $b6b27147665fcc2c$var$measurementSiteUserAriStaticOpts);
        return new _MeasurementSiteUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $b6b27147665fcc2c$var$measurementSiteUserAriStaticOpts);
        return new _MeasurementSiteUserAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            aaId: this.aaId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId, this._aaId = opts.resourceIdSegmentValues.aaId;
    }
};
module.exports["MeasurementSiteUserAri"] = $b6b27147665fcc2c$export$b0483dc480916200;

});

parcelRegister("qHG1y", function(module, exports) {
// src/measurement/site-user/types.ts
var $05044f2083580970$export$b35bf3b27ec5088f = "measurement", $05044f2083580970$export$7d7796ed65d8fcaf = "site-user";
module.exports["MeasurementSiteUserAriResourceOwner"] = $05044f2083580970$export$b35bf3b27ec5088f;
module.exports["MeasurementSiteUserAriResourceType"] = $05044f2083580970$export$7d7796ed65d8fcaf;

});

parcelRegister("bNDrX", function(module, exports) {
async function $fef391d4648fc908$export$c66d0ce87bde337c({ resourceIds: resourceIds }, { cachedTapClient: cachedTapClient, logger: logger, requester: requester }) {
    try {
        const response = await cachedTapClient.postForSiteUserTraitsShortCache({
            requester: requester,
            resourceIds: resourceIds
        });
        return response.data?.entities;
    } catch (error) {
        logger.error({
            error: error
        }, 'Error occurred when retrieving EP Site User Traits');
        return undefined;
    }
}
module.exports["getSiteUserTraitsHelper"] = $fef391d4648fc908$export$c66d0ce87bde337c;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("jQRRW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $5pS3b = parcelRequire("5pS3b");

const $221a2b03be5b44a4$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5pS3b.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withIntlProvider"] = $221a2b03be5b44a4$export$a5d940130f33be3f;

});

parcelRegister("5pS3b", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $30lHU = parcelRequire("30lHU");

var $1cfRh = parcelRequire("1cfRh");


var $ewi8o = parcelRequire("ewi8o");

function $b2d267b4c02f41c6$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $1cfRh.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $b2d267b4c02f41c6$export$480518999dfc4151(props) {
    const { locale: locale } = $b2d267b4c02f41c6$var$useFetchLocale();
    const messages = (0, $ewi8o.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $30lHU.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}
module.exports["IntlProvider"] = $b2d267b4c02f41c6$export$480518999dfc4151;

});

parcelRegister("ewi8o", function(module, exports) {

var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");

const $9f428f426036dbfa$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $42omo.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};
module.exports["useIntlMessages"] = $9f428f426036dbfa$export$2641ec9a2025a81f;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("8SCD0", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ineA9 = parcelRequire("ineA9");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6c9af975b930043$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $e6c9af975b930043$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("9DoTa")));
        case 'da':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4qglW")));
        case 'de':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bfbM8")));
        case 'en-GB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("auur8")));
        case 'en-US':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqlmj")));
        case 'en-XA':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4LGQD")));
        case 'en-XB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iQahz")));
        case 'en-ZZ':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1vN03")));
        case 'en':
            return $e6c9af975b930043$var$importHelper(await Promise.resolve((parcelRequire("ineA9"))));
        case 'es':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("l8F02")));
        case 'et':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4lx9v")));
        case 'fi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7SJgz")));
        case 'fr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2hAcG")));
        case 'hr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3KRsA")));
        case 'hu':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lorva")));
        case 'it':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7z1yN")));
        case 'ja':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6Lmbg")));
        case 'ko':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hDbAj")));
        case 'nb':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("ifA95")));
        case 'nl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("c8rti")));
        case 'pl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kWAHY")));
        case 'pt-BR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("8m74M")));
        case 'ro':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("cHbRQ")));
        case 'ru':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iginQ")));
        case 'sl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("buteN")));
        case 'sr-RS':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kXpFG")));
        case 'sr-YR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6DRMN")));
        case 'sr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bytiP")));
        case 'sv':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("5eaPb")));
        case 'th':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2JhNV")));
        case 'tr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lJjy6")));
        case 'uk':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqddP")));
        case 'vi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lRJ6S")));
        case 'zh-CN':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        case 'zh-TW':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("aazgg")));
        case 'zh':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ineA9));
    }
};
module.exports["messagesLoader"] = $e6c9af975b930043$export$720676d8cac8fbb;

});

parcelRegister("9DoTa", function(module, exports) {

let $703b0ff5e45f39ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $703b0ff5e45f39ca$var$load("i5eMd").then(()=>parcelRequire('bvjlk'));

});

parcelRegister("4qglW", function(module, exports) {

let $33864678917c99b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33864678917c99b3$var$load("4UPfH").then(()=>parcelRequire('IzetR'));

});

parcelRegister("bfbM8", function(module, exports) {

let $82fa3abe0ee41d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82fa3abe0ee41d1e$var$load("gd4qs").then(()=>parcelRequire('b60fG'));

});

parcelRegister("auur8", function(module, exports) {

let $7a3450d5cacf3802$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a3450d5cacf3802$var$load("fviv5").then(()=>parcelRequire('d1j2S'));

});

parcelRegister("hqlmj", function(module, exports) {

let $caf56ecfe84fe48c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf56ecfe84fe48c$var$load("hEkXc").then(()=>parcelRequire('dnFPq'));

});

parcelRegister("4LGQD", function(module, exports) {

let $378cc9e57c8473fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $378cc9e57c8473fa$var$load("6oOC9").then(()=>parcelRequire('4WIcD'));

});

parcelRegister("iQahz", function(module, exports) {

let $db750f2ad2fc95cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db750f2ad2fc95cb$var$load("le1sE").then(()=>parcelRequire('7DdDO'));

});

parcelRegister("1vN03", function(module, exports) {

let $119eb210e4162adb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $119eb210e4162adb$var$load("eBoC7").then(()=>parcelRequire('hWRzS'));

});

parcelRegister("l8F02", function(module, exports) {

let $f63a26007ba32907$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f63a26007ba32907$var$load("bNv64").then(()=>parcelRequire('c7q37'));

});

parcelRegister("4lx9v", function(module, exports) {

let $32a2d6f90f7dc6dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32a2d6f90f7dc6dd$var$load("bAoKR").then(()=>parcelRequire('6eH2E'));

});

parcelRegister("7SJgz", function(module, exports) {

let $5bd0b07a6c7362cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bd0b07a6c7362cc$var$load("4Afgd").then(()=>parcelRequire('Plo13'));

});

parcelRegister("2hAcG", function(module, exports) {

let $1a99408df5c40000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a99408df5c40000$var$load("cMubu").then(()=>parcelRequire('iY0zC'));

});

parcelRegister("3KRsA", function(module, exports) {

let $2bbf230e3c7786a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bbf230e3c7786a6$var$load("oUCro").then(()=>parcelRequire('6luhh'));

});

parcelRegister("lorva", function(module, exports) {

let $f9312c1c621b494e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9312c1c621b494e$var$load("3fLE9").then(()=>parcelRequire('lqPAG'));

});

parcelRegister("7z1yN", function(module, exports) {

let $581d0323511a36f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $581d0323511a36f5$var$load("8hOn0").then(()=>parcelRequire('85Nk7'));

});

parcelRegister("6Lmbg", function(module, exports) {

let $4ec85677d908e5ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ec85677d908e5ea$var$load("h4OCL").then(()=>parcelRequire('gdGRk'));

});

parcelRegister("hDbAj", function(module, exports) {

let $cd5f10a6a7e39aac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd5f10a6a7e39aac$var$load("bcQs2").then(()=>parcelRequire('eVsDT'));

});

parcelRegister("ifA95", function(module, exports) {

let $d495aa769fbc0b39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d495aa769fbc0b39$var$load("aBa7j").then(()=>parcelRequire('76Zjl'));

});

parcelRegister("c8rti", function(module, exports) {

let $8d5b8aafb917ed74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d5b8aafb917ed74$var$load("b544F").then(()=>parcelRequire('8JOK1'));

});

parcelRegister("kWAHY", function(module, exports) {

let $f3f5b2f1a0e0f500$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3f5b2f1a0e0f500$var$load("K6fhx").then(()=>parcelRequire('5eTse'));

});

parcelRegister("8m74M", function(module, exports) {

let $6155ddfe74a250ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6155ddfe74a250ea$var$load("gZU54").then(()=>parcelRequire('1OKs8'));

});

parcelRegister("cHbRQ", function(module, exports) {

let $93e2b4d7e19c96a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93e2b4d7e19c96a8$var$load("hlJc4").then(()=>parcelRequire('Xa5VS'));

});

parcelRegister("iginQ", function(module, exports) {

let $d4b7fb3604fa2dd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4b7fb3604fa2dd6$var$load("4Wdqb").then(()=>parcelRequire('7W27q'));

});

parcelRegister("buteN", function(module, exports) {

let $85d92d084d6748bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85d92d084d6748bf$var$load("bJMZS").then(()=>parcelRequire('hu9se'));

});

parcelRegister("kXpFG", function(module, exports) {

let $03eff490f7a06afd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03eff490f7a06afd$var$load("exiT6").then(()=>parcelRequire('llE8x'));

});

parcelRegister("6DRMN", function(module, exports) {

let $4d601b614fe17619$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d601b614fe17619$var$load("jLkRH").then(()=>parcelRequire('195GW'));

});

parcelRegister("bytiP", function(module, exports) {

let $8699999c641b845b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8699999c641b845b$var$load("dmrYq").then(()=>parcelRequire('inCkW'));

});

parcelRegister("5eaPb", function(module, exports) {

let $3ce6a816be8813ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ce6a816be8813ae$var$load("k10Cs").then(()=>parcelRequire('6CeqQ'));

});

parcelRegister("2JhNV", function(module, exports) {

let $1fcd9849f2e198be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fcd9849f2e198be$var$load("g5LV7").then(()=>parcelRequire('88szQ'));

});

parcelRegister("lJjy6", function(module, exports) {

let $fd1cf6ff1ab4b3c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd1cf6ff1ab4b3c6$var$load("1n8w9").then(()=>parcelRequire('8mq9f'));

});

parcelRegister("hqddP", function(module, exports) {

let $caef1efdd7b47752$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caef1efdd7b47752$var$load("2QtDQ").then(()=>parcelRequire('gOCry'));

});

parcelRegister("lRJ6S", function(module, exports) {

let $feb18a1e86664bd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $feb18a1e86664bd6$var$load("i2vEA").then(()=>parcelRequire('8bOb4'));

});

parcelRegister("dNB4M", function(module, exports) {

let $a0bc9c843510574d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0bc9c843510574d$var$load("f1B4n").then(()=>parcelRequire('03O98'));

});

parcelRegister("aazgg", function(module, exports) {

let $767630bad9dc7d72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767630bad9dc7d72$var$load("l079e").then(()=>parcelRequire('eLabs'));

});

parcelRegister("3nDO6", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6YvRD = parcelRequire("6YvRD");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8393a846181017db$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8393a846181017db$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8393a846181017db$var$importHelper(await (parcelRequire("3MpkQ")));
        case 'da':
            return $8393a846181017db$var$importHelper(await (parcelRequire("byKYQ")));
        case 'de':
            return $8393a846181017db$var$importHelper(await (parcelRequire("Ny4Dt")));
        case 'en-GB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lwrPN")));
        case 'en-US':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cfGkc")));
        case 'en-XA':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eBjVi")));
        case 'en-XB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("b9V4D")));
        case 'en-ZZ':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cjS15")));
        case 'en':
            return $8393a846181017db$var$importHelper(await Promise.resolve((parcelRequire("6YvRD"))));
        case 'es':
            return $8393a846181017db$var$importHelper(await (parcelRequire("fUiux")));
        case 'et':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6DVur")));
        case 'fi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8FDQ0")));
        case 'fr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7zYd1")));
        case 'hr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kUL2N")));
        case 'hu':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6eZER")));
        case 'it':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eUqg6")));
        case 'ja':
            return $8393a846181017db$var$importHelper(await (parcelRequire("at2wl")));
        case 'ko':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ihALB")));
        case 'nb':
            return $8393a846181017db$var$importHelper(await (parcelRequire("1ZGET")));
        case 'nl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIxnh")));
        case 'pl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9WZ2j")));
        case 'pt-BR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bhB5c")));
        case 'ro':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ckNRb")));
        case 'ru':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ir1xn")));
        case 'sl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("di9OC")));
        case 'sr-RS':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIjgo")));
        case 'sr-YR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8E5tZ")));
        case 'sr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("75Frc")));
        case 'sv':
            return $8393a846181017db$var$importHelper(await (parcelRequire("aCqVE")));
        case 'th':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2q19p")));
        case 'tr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kP7UO")));
        case 'uk':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cJoPm")));
        case 'vi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("h62OK")));
        case 'zh-CN':
            return $8393a846181017db$var$importHelper(await (parcelRequire("95Xcn")));
        case 'zh-TW':
            return $8393a846181017db$var$importHelper(await (parcelRequire("dzsOs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6YvRD));
    }
};
module.exports["messagesLoader"] = $8393a846181017db$export$720676d8cac8fbb;

});

parcelRegister("3MpkQ", function(module, exports) {

let $2c0981d7c54f4e53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c0981d7c54f4e53$var$load("bv8GZ").then(()=>parcelRequire('74xff'));

});

parcelRegister("byKYQ", function(module, exports) {

let $022bfd294816e214$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $022bfd294816e214$var$load("cdeuH").then(()=>parcelRequire('hQIGt'));

});

parcelRegister("Ny4Dt", function(module, exports) {

let $094f020f0aa3b5f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $094f020f0aa3b5f7$var$load("7gF8f").then(()=>parcelRequire('j9sSr'));

});

parcelRegister("lwrPN", function(module, exports) {

let $fab22d73b102392e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fab22d73b102392e$var$load("djb49").then(()=>parcelRequire('4tVXT'));

});

parcelRegister("cfGkc", function(module, exports) {

let $8eb7b7970922d5fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8eb7b7970922d5fc$var$load("koawN").then(()=>parcelRequire('k7TQm'));

});

parcelRegister("eBjVi", function(module, exports) {

let $aa13f9b6f0cd2936$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa13f9b6f0cd2936$var$load("6htQT").then(()=>parcelRequire('lIWyQ'));

});

parcelRegister("b9V4D", function(module, exports) {

let $81fccea2c7692076$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81fccea2c7692076$var$load("fi75i").then(()=>parcelRequire('5QCdA'));

});

parcelRegister("cjS15", function(module, exports) {

let $8f8128f149f291d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f8128f149f291d2$var$load("ksTQ6").then(()=>parcelRequire('4EAWY'));

});

parcelRegister("fUiux", function(module, exports) {

let $b94a6e00f1130c23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b94a6e00f1130c23$var$load("5CGnz").then(()=>parcelRequire('1PSNt'));

});

parcelRegister("6DVur", function(module, exports) {

let $4d62fae3367e8fba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d62fae3367e8fba$var$load("X0Jic").then(()=>parcelRequire('cNrRQ'));

});

parcelRegister("8FDQ0", function(module, exports) {

let $65010e043670e359$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65010e043670e359$var$load("9Oxgj").then(()=>parcelRequire('5L1ix'));

});

parcelRegister("7zYd1", function(module, exports) {

let $584a81908bcf6b02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $584a81908bcf6b02$var$load("kAg8V").then(()=>parcelRequire('f4vYC'));

});

parcelRegister("kUL2N", function(module, exports) {

let $f39d8798e3aacd6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f39d8798e3aacd6e$var$load("36XYg").then(()=>parcelRequire('jRDUE'));

});

parcelRegister("6eZER", function(module, exports) {

let $48b3e0de1ed42ace$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48b3e0de1ed42ace$var$load("fM2oh").then(()=>parcelRequire('lmfGu'));

});

parcelRegister("eUqg6", function(module, exports) {

let $adaaaa1542ad404d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adaaaa1542ad404d$var$load("xnqy2").then(()=>parcelRequire('J7CId'));

});

parcelRegister("at2wl", function(module, exports) {

let $79ee915b8a5cfa5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79ee915b8a5cfa5f$var$load("awkVi").then(()=>parcelRequire('iEu8X'));

});

parcelRegister("ihALB", function(module, exports) {

let $d4f655a3a30906cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4f655a3a30906cd$var$load("11DLa").then(()=>parcelRequire('lklBt'));

});

parcelRegister("1ZGET", function(module, exports) {

let $173c9412aa2d6ea2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $173c9412aa2d6ea2$var$load("barSq").then(()=>parcelRequire('edhkG'));

});

parcelRegister("jIxnh", function(module, exports) {

let $e5ac03dff8d9aeff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5ac03dff8d9aeff$var$load("a8heY").then(()=>parcelRequire('aFb9z'));

});

parcelRegister("9WZ2j", function(module, exports) {

let $73e8e060a723dc38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73e8e060a723dc38$var$load("6hlNE").then(()=>parcelRequire('bAPfw'));

});

parcelRegister("bhB5c", function(module, exports) {

let $836e0c1dd75645f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $836e0c1dd75645f5$var$load("2bqSD").then(()=>parcelRequire('c1E8Q'));

});

parcelRegister("ckNRb", function(module, exports) {

let $8fae06d114550a7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fae06d114550a7b$var$load("j6IGj").then(()=>parcelRequire('88y6K'));

});

parcelRegister("ir1xn", function(module, exports) {

let $d6bbf0de65f9bce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6bbf0de65f9bce4$var$load("bJykp").then(()=>parcelRequire('8Rjw5'));

});

parcelRegister("di9OC", function(module, exports) {

let $9ad491ee252155d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ad491ee252155d7$var$load("7Rbde").then(()=>parcelRequire('awMdX'));

});

parcelRegister("jIjgo", function(module, exports) {

let $e5a111b573c22c47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5a111b573c22c47$var$load("l8auu").then(()=>parcelRequire('eNbID'));

});

parcelRegister("8E5tZ", function(module, exports) {

let $64b64febd9024da4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64b64febd9024da4$var$load("3ColL").then(()=>parcelRequire('YVOUf'));

});

parcelRegister("75Frc", function(module, exports) {

let $529924b6cea297fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $529924b6cea297fd$var$load("2VSOH").then(()=>parcelRequire('fEcqf'));

});

parcelRegister("aCqVE", function(module, exports) {

let $7bb257853d40c532$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bb257853d40c532$var$load("dh2Er").then(()=>parcelRequire('6TlJn'));

});

parcelRegister("2q19p", function(module, exports) {

let $1c2ee6fb468abb06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c2ee6fb468abb06$var$load("kyBJI").then(()=>parcelRequire('7Nysq'));

});

parcelRegister("kP7UO", function(module, exports) {

let $f28eb5e89a23de79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f28eb5e89a23de79$var$load("eBLgB").then(()=>parcelRequire('1gaUd'));

});

parcelRegister("cJoPm", function(module, exports) {

let $944cf23be3b0d1a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $944cf23be3b0d1a4$var$load("ahhGv").then(()=>parcelRequire('bcwM6'));

});

parcelRegister("h62OK", function(module, exports) {

let $c7252eb9922192b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7252eb9922192b6$var$load("1Zesg").then(()=>parcelRequire('7fZ9R'));

});

parcelRegister("95Xcn", function(module, exports) {

let $69f280464f678177$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69f280464f678177$var$load("eLlpV").then(()=>parcelRequire('15VSW'));

});

parcelRegister("dzsOs", function(module, exports) {

let $9e14e4de0de5cb5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e14e4de0de5cb5f$var$load("bV8sS").then(()=>parcelRequire('dU88R'));

});

parcelRegister("kdvUL", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Mosz = parcelRequire("8Mosz");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a5b98d263d96b9ca$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a5b98d263d96b9ca$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5kzWa")));
        case 'da':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("i4vm8")));
        case 'de':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2criv")));
        case 'en-GB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7leZF")));
        case 'en-US':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("lIduW")));
        case 'en-XA':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Ga8j")));
        case 'en-XB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9SvDD")));
        case 'en-ZZ':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ilsDR")));
        case 'en':
            return $a5b98d263d96b9ca$var$importHelper(await Promise.resolve((parcelRequire("8Mosz"))));
        case 'es':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("eA1bq")));
        case 'et':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("20oYo")));
        case 'fi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5uv0c")));
        case 'fr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aT1Cx")));
        case 'hr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("loDZu")));
        case 'hu':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("j3kFT")));
        case 'it':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ks52q")));
        case 'ja':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aTDBw")));
        case 'ko':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bTqNO")));
        case 'nb':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("10NvT")));
        case 'nl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("4Yta3")));
        case 'pl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7T2DO")));
        case 'pt-BR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("86KYZ")));
        case 'ro':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9ZXMc")));
        case 'ru':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bP7Hx")));
        case 'sl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("3iSMg")));
        case 'sr-RS':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("gjRTJ")));
        case 'sr-YR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("dDE21")));
        case 'sr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7Se25")));
        case 'sv':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("giWmH")));
        case 'th':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2rtZr")));
        case 'tr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("az1hp")));
        case 'uk':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hW673")));
        case 'vi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("34J1c")));
        case 'zh-CN':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cMfEi")));
        case 'zh-TW':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("iVQsE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Mosz));
    }
};
module.exports["messagesLoader"] = $a5b98d263d96b9ca$export$720676d8cac8fbb;

});

parcelRegister("5kzWa", function(module, exports) {

let $3e1ab25bd080ef18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e1ab25bd080ef18$var$load("1jsQH").then(()=>parcelRequire('fa8lP'));

});

parcelRegister("i4vm8", function(module, exports) {

let $d280ec5dc220c64f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d280ec5dc220c64f$var$load("deyvi").then(()=>parcelRequire('e3sAb'));

});

parcelRegister("2criv", function(module, exports) {

let $19a1e074f016a288$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19a1e074f016a288$var$load("6dERU").then(()=>parcelRequire('gch8x'));

});

parcelRegister("7leZF", function(module, exports) {

let $558620019a9af14d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $558620019a9af14d$var$load("kTurq").then(()=>parcelRequire('8ptsW'));

});

parcelRegister("lIduW", function(module, exports) {

let $fce82d783e15c0ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fce82d783e15c0ae$var$load("fbIIm").then(()=>parcelRequire('a6GY6'));

});

parcelRegister("6Ga8j", function(module, exports) {

let $4dce8689974dee0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4dce8689974dee0c$var$load("7l3it").then(()=>parcelRequire('8fxxk'));

});

parcelRegister("9SvDD", function(module, exports) {

let $7311b2ec66131e05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7311b2ec66131e05$var$load("i64HJ").then(()=>parcelRequire('efBlj'));

});

parcelRegister("ilsDR", function(module, exports) {

let $d5b067deab340511$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5b067deab340511$var$load("j0PWv").then(()=>parcelRequire('ks6TI'));

});

parcelRegister("eA1bq", function(module, exports) {

let $a9d558780c2a5d28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9d558780c2a5d28$var$load("dlmud").then(()=>parcelRequire('imT4f'));

});

parcelRegister("20oYo", function(module, exports) {

let $175ef3f7b5281c9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $175ef3f7b5281c9e$var$load("7snhF").then(()=>parcelRequire('cQTYN'));

});

parcelRegister("5uv0c", function(module, exports) {

let $3ff7cd8091ce22a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ff7cd8091ce22a4$var$load("cbkj0").then(()=>parcelRequire('j8AG8'));

});

parcelRegister("aT1Cx", function(module, exports) {

let $7ed04c3d213b805a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ed04c3d213b805a$var$load("17m16").then(()=>parcelRequire('cdNFz'));

});

parcelRegister("loDZu", function(module, exports) {

let $f93adc2ef4ae79f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f93adc2ef4ae79f5$var$load("eQZk8").then(()=>parcelRequire('8akbo'));

});

parcelRegister("j3kFT", function(module, exports) {

let $ddee55b7ab979037$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddee55b7ab979037$var$load("b4NO6").then(()=>parcelRequire('gPFiy'));

});

parcelRegister("ks52q", function(module, exports) {

let $ee3a549cc562cf0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee3a549cc562cf0d$var$load("1K1Fj").then(()=>parcelRequire('dIMMS'));

});

parcelRegister("aTDBw", function(module, exports) {

let $7eedc2fbe15b315c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eedc2fbe15b315c$var$load("38sfA").then(()=>parcelRequire('css4w'));

});

parcelRegister("bTqNO", function(module, exports) {

let $8a899f28c59c2af5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a899f28c59c2af5$var$load("bjmre").then(()=>parcelRequire('9R9u0'));

});

parcelRegister("10NvT", function(module, exports) {

let $0bcc32df5e9c1b1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bcc32df5e9c1b1f$var$load("asvK9").then(()=>parcelRequire('6DTdr'));

});

parcelRegister("4Yta3", function(module, exports) {

let $39f362cd04b24307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $39f362cd04b24307$var$load("7v6wU").then(()=>parcelRequire('ceZMk'));

});

parcelRegister("7T2DO", function(module, exports) {

let $5bdfb7f14449e2c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bdfb7f14449e2c0$var$load("aEpRh").then(()=>parcelRequire('jtjwW'));

});

parcelRegister("86KYZ", function(module, exports) {

let $5e73541143b39bdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e73541143b39bdc$var$load("3fuR9").then(()=>parcelRequire('l8CqS'));

});

parcelRegister("9ZXMc", function(module, exports) {

let $74782de4a4745e6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74782de4a4745e6c$var$load("bSjyK").then(()=>parcelRequire('fFbIU'));

});

parcelRegister("bP7Hx", function(module, exports) {

let $89ba6e7402c93988$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89ba6e7402c93988$var$load("fMrUo").then(()=>parcelRequire('hHfxK'));

});

parcelRegister("3iSMg", function(module, exports) {

let $267d8b2ea98c2197$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $267d8b2ea98c2197$var$load("glLvq").then(()=>parcelRequire('lr9gd'));

});

parcelRegister("gjRTJ", function(module, exports) {

let $be183aac679ffec9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be183aac679ffec9$var$load("fFGjZ").then(()=>parcelRequire('ilsFV'));

});

parcelRegister("dDE21", function(module, exports) {

let $9eddf85990b84494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9eddf85990b84494$var$load("fEAqG").then(()=>parcelRequire('8xJoA'));

});

parcelRegister("7Se25", function(module, exports) {

let $5bb876238d07b83c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bb876238d07b83c$var$load("e9tHh").then(()=>parcelRequire('b1h3K'));

});

parcelRegister("giWmH", function(module, exports) {

let $bdeb99e2433e700b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdeb99e2433e700b$var$load("9eNkX").then(()=>parcelRequire('2OLbL'));

});

parcelRegister("2rtZr", function(module, exports) {

let $1c755dc3df24f4b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c755dc3df24f4b3$var$load("fTPgj").then(()=>parcelRequire('lSTN4'));

});

parcelRegister("az1hp", function(module, exports) {

let $7b0e2a6644cdd48f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b0e2a6644cdd48f$var$load("h0uBE").then(()=>parcelRequire('74ATO'));

});

parcelRegister("hW673", function(module, exports) {

let $d0ec98572b185326$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0ec98572b185326$var$load("lKa7i").then(()=>parcelRequire('3fixv'));

});

parcelRegister("34J1c", function(module, exports) {

let $23d4aa8a0a9f8628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23d4aa8a0a9f8628$var$load("9aufD").then(()=>parcelRequire('kafqC'));

});

parcelRegister("cMfEi", function(module, exports) {

let $94d61b4e9741d415$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94d61b4e9741d415$var$load("gDiIK").then(()=>parcelRequire('19yAM'));

});

parcelRegister("iVQsE", function(module, exports) {

let $dc863e8c0dddf9f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc863e8c0dddf9f8$var$load("j9OUx").then(()=>parcelRequire('jSsWA'));

});

parcelRegister("9oJIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kO3gu = parcelRequire("kO3gu");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("jCM2u")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("fqrVl")).Reasons);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $32c19fce160b377b$export$655b6c19a0daddb8;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}workflowApplicationChanged{contentId changeType newWorkflowStatusId contentStatus version __typename}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}contentAccessDecisionMade{contentId decision __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("2VQ4B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $bhXnY = parcelRequire("bhXnY");


var $5EhNr = parcelRequire("5EhNr");

const $010b88689ec70f7f$export$a267cdf45880b07b = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5EhNr.UFOSegmentLoadEnd), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhXnY.Bm3PageSegmentLoadEnd), props);
};
module.exports["PageSegmentLoadEnd"] = $010b88689ec70f7f$export$a267cdf45880b07b;

});

parcelRegister("bhXnY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $9bfe2b6f868e7303$var$noop = ()=>{};
const $9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $9bfe2b6f868e7303$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $9bfe2b6f868e7303$export$b20cfab4e3fe23b6 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent);
module.exports["Bm3PageSegmentLoadEnd"] = $9bfe2b6f868e7303$export$b20cfab4e3fe23b6;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("5EhNr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");

const $e32532ca00da3b97$var$noop = ()=>{};
const $e32532ca00da3b97$var$UFOSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $e32532ca00da3b97$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
            (0, $cbc8g.addUFOCustomData)({
                ...finalCustomData,
                ...typeof stopTimeRef.current === 'number' ? {
                    stopTime: stopTimeRef.current
                } : {},
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $e32532ca00da3b97$export$9859c9d857077c0b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e32532ca00da3b97$var$UFOSegmentLoadEndComponent);
module.exports["UFOSegmentLoadEnd"] = $e32532ca00da3b97$export$9859c9d857077c0b;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("dIDyF", function(module, exports) {

var $jO9zg = parcelRequire("jO9zg");

const $c2412d4c16af1f46$export$c43c7444da662fa1 = '1';
const $c2412d4c16af1f46$export$e99efa3985fa3c26 = 'in-product-help';
const $c2412d4c16af1f46$export$23aa6670f346c214 = 368;
const $c2412d4c16af1f46$export$dd8cabd06ab03363 = {
    summary: 'summary',
    wasThisHelpful: 'customfield_10081',
    description: 'description',
    reason: 'customfield_10082',
    title: 'customfield_10083',
    contentId: 'customfield_10084',
    contentLink: 'customfield_10088',
    feedbackContext: 'customfield_10047',
    routeGroup: 'customfield_10085',
    routeName: 'customfield_10086',
    customerName: 'customfield_10045',
    email: 'email',
    contactMe: 'customfield_10043'
};
const $c2412d4c16af1f46$export$597555bbf10f10b8 = {
    yes: {
        id: '10182',
        label: 'yes'
    },
    no: {
        id: '10183',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$cd692d959c11a1e9 = {
    noAccurate: {
        id: '10184',
        label: (0, $jO9zg.notAccurateLabel)
    },
    noClear: {
        id: '10185',
        label: (0, $jO9zg.notClearLabel)
    },
    noRelevant: {
        id: '10186',
        label: (0, $jO9zg.notRelevantLabel)
    }
};
const $c2412d4c16af1f46$export$ee3be114bf2680b4 = {
    yes: {
        id: '10109',
        label: 'yes'
    },
    no: {
        id: '10111',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$31f0ec6fc5b07a82 = 'afae180b-eb61-43c5-bc3f-5f65349a8853';
const $c2412d4c16af1f46$export$d006cfb73688051e = '279';
module.exports["HELP_PANEL_ID"] = $c2412d4c16af1f46$export$e99efa3985fa3c26;
module.exports["HELP_PANEL_WIDTH"] = $c2412d4c16af1f46$export$23aa6670f346c214;
module.exports["FEEDBACK_FIELDS_ID"] = $c2412d4c16af1f46$export$dd8cabd06ab03363;
module.exports["WAS_THIS_HELPFUL_OPTIONS"] = $c2412d4c16af1f46$export$597555bbf10f10b8;
module.exports["FEEDBACK_REASON_OPTIONS"] = $c2412d4c16af1f46$export$cd692d959c11a1e9;
module.exports["CAN_BE_CONTACTED_OPTIONS"] = $c2412d4c16af1f46$export$ee3be114bf2680b4;
module.exports["EMBEDDABLE_KEY"] = $c2412d4c16af1f46$export$31f0ec6fc5b07a82;
module.exports["REQUEST_TYPE_ID"] = $c2412d4c16af1f46$export$d006cfb73688051e;

});

parcelRegister("jO9zg", function(module, exports) {
const $136af91396913aa8$export$653b1475ad2952b = "It wasn\u2019t accurate";
const $136af91396913aa8$export$910eb5168d5e4926 = "It wasn\u2019t clear";
const $136af91396913aa8$export$7e4b37ff0a487bc2 = "It wasn\u2019t relevant";
module.exports["notAccurateLabel"] = $136af91396913aa8$export$653b1475ad2952b;
module.exports["notClearLabel"] = $136af91396913aa8$export$910eb5168d5e4926;
module.exports["notRelevantLabel"] = $136af91396913aa8$export$7e4b37ff0a487bc2;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        }
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        }
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<c4de1f2f464f7c58da863fcc2b8f8310>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<6c06bb421a64deed65b923b9eaef1fcf>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<db055c87cd42b74d8aeb77e7e48c9c82>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<a16e57d7fd38ec5242980bcfc517bf2e>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("7aAR0"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("7aAR0", function(module, exports) {

let $53860e001f0fbb87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $53860e001f0fbb87$var$load("klApM"),
    $53860e001f0fbb87$var$load("eQgf0"),
    $53860e001f0fbb87$var$load("74vOE"),
    $53860e001f0fbb87$var$load("ajMch"),
    $53860e001f0fbb87$var$load("6wr18"),
    $53860e001f0fbb87$var$load("ffEVr"),
    $53860e001f0fbb87$var$load("kjZZD"),
    $53860e001f0fbb87$var$load("d4Stt"),
    $53860e001f0fbb87$var$load("4izLy"),
    $53860e001f0fbb87$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("3Xs1I", function(module, exports) {

var $1SNEF = parcelRequire("1SNEF");

const $cf20926a3ed5ce71$export$b107cc869756fe73 = (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};
module.exports["QuickReloadSubscriber"] = $cf20926a3ed5ce71$export$b107cc869756fe73;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>(0, $17wUi.confluenceSessionStorageInstance).getItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_WIDTH"] = $f378941f4cbfa1d0$export$48f59b832d015459;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["shouldRenderApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$41945f41a6acb22;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("ilSNM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af5bdeaecdb0e37d55178bb1e6c281ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5c4b2a6e8ca72fd$var$_react = $d5c4b2a6e8ca72fd$var$_interopRequireDefault((parcelRequire("42omo")));

var $d5c4b2a6e8ca72fd$var$_baseNew = $d5c4b2a6e8ca72fd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d5c4b2a6e8ca72fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5c4b2a6e8ca72fd$var$LogInIcon = (props)=>/*#__PURE__*/ $d5c4b2a6e8ca72fd$var$_react.default.createElement($d5c4b2a6e8ca72fd$var$_baseNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$d5c4b2a6e8ca72fd$var$LogInIcon.displayName = 'LogInIcon';
var $d5c4b2a6e8ca72fd$var$_default = module.exports.default = $d5c4b2a6e8ca72fd$var$LogInIcon;

});

parcelRegister("kNHXO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55422f7c50559ad266d0694af3ada2f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f24a7c82f1a8c849$var$_react = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("42omo")));

var $f24a7c82f1a8c849$var$_baseNew = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f24a7c82f1a8c849$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f24a7c82f1a8c849$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $f24a7c82f1a8c849$var$_react.default.createElement($f24a7c82f1a8c849$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$f24a7c82f1a8c849$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $f24a7c82f1a8c849$var$_default = module.exports.default = $f24a7c82f1a8c849$var$AppSwitcherIcon;

});

parcelRegister("3uA7H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b031be5ae5f446$var$_react = $28b031be5ae5f446$var$_interopRequireDefault((parcelRequire("42omo")));

var $28b031be5ae5f446$var$_baseNew = $28b031be5ae5f446$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $28b031be5ae5f446$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28b031be5ae5f446$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $28b031be5ae5f446$var$_react.default.createElement($28b031be5ae5f446$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$28b031be5ae5f446$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $28b031be5ae5f446$var$_default = module.exports.default = $28b031be5ae5f446$var$SidebarCollapseIcon;

});

parcelRegister("cN7t9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87b126ba38d591666b6bb1a2ae894895>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94ffdadf1a3ed504$var$_react = $94ffdadf1a3ed504$var$_interopRequireDefault((parcelRequire("42omo")));

var $94ffdadf1a3ed504$var$_baseNew = $94ffdadf1a3ed504$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $94ffdadf1a3ed504$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94ffdadf1a3ed504$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $94ffdadf1a3ed504$var$_react.default.createElement($94ffdadf1a3ed504$var$_baseNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$94ffdadf1a3ed504$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $94ffdadf1a3ed504$var$_default = module.exports.default = $94ffdadf1a3ed504$var$SidebarExpandIcon;

});

parcelRegister("jK29N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::282b63b14f5d8b9b1a4035ff1652d30e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5f3fc87e4383614$var$_react = $e5f3fc87e4383614$var$_interopRequireDefault((parcelRequire("42omo")));

var $e5f3fc87e4383614$var$_baseNew = $e5f3fc87e4383614$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e5f3fc87e4383614$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5f3fc87e4383614$var$LogOutIcon = (props)=>/*#__PURE__*/ $e5f3fc87e4383614$var$_react.default.createElement($e5f3fc87e4383614$var$_baseNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$e5f3fc87e4383614$var$LogOutIcon.displayName = 'LogOutIcon';
var $e5f3fc87e4383614$var$_default = module.exports.default = $e5f3fc87e4383614$var$LogOutIcon;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("618I0"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("618I0", function(module, exports) {

let $4619977a62937b7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4619977a62937b7e$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("2azjJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $g5lKx = parcelRequire("g5lKx");


var $g0EzZ = parcelRequire("g0EzZ");

function $5648f131343e99e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5648f131343e99e5$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$5648f131343e99e5$var$AkGrid(multiplier * num),
        half: ()=>$5648f131343e99e5$var$AkGrid(0.5 * num),
        twice: ()=>$5648f131343e99e5$var$AkGrid(2 * num)
    });
const $5648f131343e99e5$export$56446adcecbeec34 = {
    searchDialog: (0, $g5lKx.layers).dialog()
};
const $5648f131343e99e5$export$85fc379452d91af0 = $5648f131343e99e5$var$AkGrid(1);
const $5648f131343e99e5$export$b9930dabfa4a3a3 = '56px';
const $5648f131343e99e5$export$f6af7620e8789c39 = '200px';
const $5648f131343e99e5$export$64d8573e83b64ff8 = '150px';
const $5648f131343e99e5$export$a3da89b899389ed8 = '780px';
const $5648f131343e99e5$export$ce4512df260a325a = 780;
const $5648f131343e99e5$export$a406031ed42c8e02 = '1130px';
const $5648f131343e99e5$export$e00021bea368c518 = $5648f131343e99e5$export$85fc379452d91af0.multiple(4);
const $5648f131343e99e5$export$30310ee354b45eb0 = $5648f131343e99e5$export$85fc379452d91af0.multiple(6);
const $5648f131343e99e5$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $g0EzZ.N900)})`;
const $5648f131343e99e5$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $g0EzZ.N300)})`;
const $5648f131343e99e5$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $g0EzZ.N20)})`;
const $5648f131343e99e5$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $g0EzZ.P300)})`;
const $5648f131343e99e5$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
module.exports["zIndex"] = $5648f131343e99e5$export$56446adcecbeec34;
module.exports["grid"] = $5648f131343e99e5$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $5648f131343e99e5$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $5648f131343e99e5$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $5648f131343e99e5$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $5648f131343e99e5$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $5648f131343e99e5$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $5648f131343e99e5$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $5648f131343e99e5$export$30310ee354b45eb0;
module.exports["primaryTextColour"] = $5648f131343e99e5$export$eeb0307e2964e28d;
module.exports["itemLinkSecondaryColor"] = $5648f131343e99e5$export$7168c0a11fb9ab29;
module.exports["itemHighlightColor"] = $5648f131343e99e5$export$4ac85ff259fe4fce;
module.exports["visitedLinkColor"] = $5648f131343e99e5$export$271fb8b1437b1d62;
module.exports["nowrapEllipsis"] = $5648f131343e99e5$export$b6b16ffe83ef4b56;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("fZitC", function(module, exports) {
const $51296ea8f82bf4e5$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $51296ea8f82bf4e5$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_m, r, g, b)=>r + r + g + g + b + b);
const $51296ea8f82bf4e5$var$rgbFromHex = (input)=>{
    const fullHex = $51296ea8f82bf4e5$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $51296ea8f82bf4e5$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $51296ea8f82bf4e5$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $51296ea8f82bf4e5$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $51296ea8f82bf4e5$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $51296ea8f82bf4e5$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $51296ea8f82bf4e5$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $51296ea8f82bf4e5$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $51296ea8f82bf4e5$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $51296ea8f82bf4e5$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $51296ea8f82bf4e5$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $51296ea8f82bf4e5$var$rgbToLch = (rgb)=>$51296ea8f82bf4e5$var$labToLch($51296ea8f82bf4e5$var$xyzToLab($51296ea8f82bf4e5$var$rgbToXyz(rgb)));
const $51296ea8f82bf4e5$var$lchToRgb = (lch)=>$51296ea8f82bf4e5$var$xyzToRgb($51296ea8f82bf4e5$var$labToXyz($51296ea8f82bf4e5$var$lchToLab(lch)));
const $51296ea8f82bf4e5$export$f38e45b0889fb431 = (hexColor)=>{
    const rgb = $51296ea8f82bf4e5$var$rgbFromHex(hexColor);
    if (rgb === null) return undefined;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $51296ea8f82bf4e5$var$rgbToLch(rgb);
    return lch.l;
};
const $51296ea8f82bf4e5$var$modifyLightness = (hexColor, percent, getShouldModifyLightness)=>{
    const rgb = $51296ea8f82bf4e5$var$rgbFromHex(hexColor);
    if (rgb === null) return hexColor;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $51296ea8f82bf4e5$var$rgbToLch(rgb);
    if (getShouldModifyLightness(lch.l)) lch.l = $51296ea8f82bf4e5$var$clamp(percent, 0, 100);
    return $51296ea8f82bf4e5$var$rgbToHex($51296ea8f82bf4e5$var$lchToRgb(lch));
};
const $51296ea8f82bf4e5$export$5ec9a60e757390f1 = (hexColor, capPercent)=>{
    return $51296ea8f82bf4e5$var$modifyLightness(hexColor, capPercent, (lightnessValue)=>lightnessValue > capPercent);
};
const $51296ea8f82bf4e5$export$16d9f224c1d58542 = (hexColor, minPercent)=>{
    return $51296ea8f82bf4e5$var$modifyLightness(hexColor, minPercent, (lightnessValue)=>lightnessValue < minPercent);
};
module.exports["getLightnessPercentage"] = $51296ea8f82bf4e5$export$f38e45b0889fb431;
module.exports["reduceLightness"] = $51296ea8f82bf4e5$export$5ec9a60e757390f1;
module.exports["increaseLightness"] = $51296ea8f82bf4e5$export$16d9f224c1d58542;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), t2);
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<b74dcf07c76f428fadc277c7af55376b>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("ckcSY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45233a62a3f56b9e4911deb2a2339447>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f91591f413eb2d9$var$_react = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $8f91591f413eb2d9$var$_baseNew = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8f91591f413eb2d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f91591f413eb2d9$var$NotificationIcon = (props)=>/*#__PURE__*/ $8f91591f413eb2d9$var$_react.default.createElement($8f91591f413eb2d9$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$8f91591f413eb2d9$var$NotificationIcon.displayName = 'NotificationIcon';
var $8f91591f413eb2d9$var$_default = module.exports.default = $8f91591f413eb2d9$var$NotificationIcon;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== height || $[1] !== t2 || $[2] !== type) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t2;
            $[2] = type;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $h82at.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("kqIWy", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            variables: {
                spaceKey: spaceKey
            }
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const options = t0;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t1;
    if ($[2] !== data) {
        t1 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path
        } : undefined;
        $[2] = data;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== error || $[5] !== loading || $[6] !== t1) {
        t2 = {
            loading: loading,
            data: t1,
            error: error
        };
        $[4] = error;
        $[5] = loading;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("kxhju", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("28NpI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1d2d6708d394f801c1e7c6452a7750c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18f2a8adc52b2e32$var$_react = $18f2a8adc52b2e32$var$_interopRequireDefault((parcelRequire("42omo")));

var $18f2a8adc52b2e32$var$_baseNew = $18f2a8adc52b2e32$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $18f2a8adc52b2e32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18f2a8adc52b2e32$var$ThemeIcon = (props)=>/*#__PURE__*/ $18f2a8adc52b2e32$var$_react.default.createElement($18f2a8adc52b2e32$var$_baseNew.default, Object.assign({
        name: "ThemeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$18f2a8adc52b2e32$var$ThemeIcon.displayName = 'ThemeIcon';
var $18f2a8adc52b2e32$var$_default = module.exports.default = $18f2a8adc52b2e32$var$ThemeIcon;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("lBYCH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $42omo.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipQuery || $[9] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery
        };
        $[8] = skipQuery;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[11] = t8;
            $[12] = t9;
        } else {
            t8 = $[11];
            t9 = $[12];
        }
        let t10;
        if ($[13] !== error || $[14] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[13] = error;
            $[14] = loading;
            $[15] = t10;
        } else t10 = $[15];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[16] !== allowedWebItems || $[17] !== data || $[18] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[16] = allowedWebItems;
        $[17] = data;
        $[18] = notAllowedWebItems;
        $[19] = webItems;
        $[20] = webSections;
    } else {
        webItems = $[19];
        webSections = $[20];
    }
    let t8;
    if ($[21] !== error || $[22] !== webItems || $[23] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[21] = error;
        $[22] = webItems;
        $[23] = webSections;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("8w1c1", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("4qrTW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8K0Og = parcelRequire("8K0Og");

const $14a2b16d436ce3a5$export$93d4e7f90805808f = ()=>(0, $42omo.useContext)((0, $8K0Og.ThemeContext));
module.exports["useTheme"] = $14a2b16d436ce3a5$export$93d4e7f90805808f;

});

parcelRegister("8K0Og", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ahT8g = parcelRequire("ahT8g");

const $64b78fb356e75cc1$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ahT8g.defaultTheme));
const $64b78fb356e75cc1$export$d8964aec282183a3 = $64b78fb356e75cc1$export$2c657da244d00bd6.Provider;
module.exports["ThemeContext"] = $64b78fb356e75cc1$export$2c657da244d00bd6;
module.exports["ThemeProvider"] = $64b78fb356e75cc1$export$d8964aec282183a3;

});

parcelRegister("ahT8g", function(module, exports) {

var $g0EzZ = parcelRequire("g0EzZ");


var $lCH0w = parcelRequire("lCH0w");


var $jeF0t = parcelRequire("jeF0t");

const $245571a50d5c46d4$export$eeee8619e1b91cb0 = (0, $jeF0t.generateTheme)({
    name: (0, $lCH0w.DEFAULT_THEME_NAME),
    backgroundColor: (0, $g0EzZ.N0),
    highlightColor: (0, $g0EzZ.B400)
});
const $245571a50d5c46d4$export$164de7ab8df77ef0 = $245571a50d5c46d4$export$eeee8619e1b91cb0;
module.exports["atlassianTheme"] = $245571a50d5c46d4$export$eeee8619e1b91cb0;
module.exports["defaultTheme"] = $245571a50d5c46d4$export$164de7ab8df77ef0;

});

parcelRegister("lCH0w", function(module, exports) {
const $08762123b36e773e$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $08762123b36e773e$var$defaultThemeCopy = JSON.parse(JSON.stringify($08762123b36e773e$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $08762123b36e773e$export$77823bc9863eaa03 = $08762123b36e773e$var$defaultThemeCopy;
const $08762123b36e773e$export$2491e13b198e597d = 'atlassian';
var $08762123b36e773e$export$2e2bcd8739ae039 = $08762123b36e773e$var$defaultTheme;
module.exports["defaultThemeBrandRefresh"] = $08762123b36e773e$export$77823bc9863eaa03;
module.exports["DEFAULT_THEME_NAME"] = $08762123b36e773e$export$2491e13b198e597d;

});

parcelRegister("jeF0t", function(module, exports) {

var $lCH0w = parcelRequire("lCH0w");


var $3cLqS = parcelRequire("3cLqS");

const $1ebbdfb973eaad0e$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $1ebbdfb973eaad0e$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $1ebbdfb973eaad0e$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.65) : (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.8) : (0, $3cLqS.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        }
    };
};
const $1ebbdfb973eaad0e$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $3cLqS.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $1ebbdfb973eaad0e$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $3cLqS.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $lCH0w.DEFAULT_THEME_NAME)) return 0, $lCH0w.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $1ebbdfb973eaad0e$var$generateButtonCSSStates($1ebbdfb973eaad0e$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $3cLqS.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $3cLqS.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $3cLqS.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $3cLqS.getBoxShadow)((0, $3cLqS.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $3cLqS.getContrastColor)(0.1, $1ebbdfb973eaad0e$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
module.exports["generateTheme"] = $1ebbdfb973eaad0e$export$2e4ecffaca289a18;

});

parcelRegister("3cLqS", function(module, exports) {

var $lcPXp = parcelRequire("lcPXp");

const $6a9c68de2b00e336$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $lcPXp.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $6a9c68de2b00e336$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $6a9c68de2b00e336$var$hex = '[a-z0-9]';
const $6a9c68de2b00e336$var$shortHandHexColorPattern = new RegExp(`#(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})`, 'i');
const $6a9c68de2b00e336$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $6a9c68de2b00e336$var$isShortHexColor = (color)=>color && color.length === 4;
const $6a9c68de2b00e336$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$6a9c68de2b00e336$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $6a9c68de2b00e336$var$completeTriplet = (colors)=>`#${$6a9c68de2b00e336$var$repeat(colors[1], 6)}`;
const $6a9c68de2b00e336$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $6a9c68de2b00e336$export$db8d2130677f868c = (color)=>{
    if ($6a9c68de2b00e336$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($6a9c68de2b00e336$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($6a9c68de2b00e336$var$isTriplet(colors)) return $6a9c68de2b00e336$var$completeTriplet(colors);
            else return $6a9c68de2b00e336$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $6a9c68de2b00e336$export$10a10e7cd1193377 = (color)=>{
    const converted = $6a9c68de2b00e336$export$db8d2130677f868c(color);
    return (0, $lcPXp.default).contrastRatio(converted).hex;
};
const $6a9c68de2b00e336$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$6a9c68de2b00e336$export$7229be6d7219ee6a((0, $lcPXp.default).contrast(contrastValue, color).hex, opacityValue);
module.exports["hexToRGBA"] = $6a9c68de2b00e336$export$7229be6d7219ee6a;
module.exports["getBoxShadow"] = $6a9c68de2b00e336$export$bba5a971afe05444;
module.exports["generateTextColor"] = $6a9c68de2b00e336$export$10a10e7cd1193377;
module.exports["getContrastColor"] = $6a9c68de2b00e336$export$77a1051494882576;

});

parcelRegister("awSMG", function(module, exports) {
const $4ce470d2dd3584e9$export$6ff460ddb5710005 = 'editor:offline-steps-';
const $4ce470d2dd3584e9$export$7023de141f2ab721 = 'meta';
const $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7 = 'steps';
const $4ce470d2dd3584e9$export$9fd1ded1027f9ea2 = 2;
module.exports["OFFLINE_STEPS_DATABASE_NAME_PREFIX"] = $4ce470d2dd3584e9$export$6ff460ddb5710005;
module.exports["OFFLINE_META_STORE_NAME"] = $4ce470d2dd3584e9$export$7023de141f2ab721;
module.exports["OFFLINE_STEPS_STORE_NAME"] = $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7;
module.exports["OFFLINE_STEPS_DATABASE_VERSION"] = $4ce470d2dd3584e9$export$9fd1ded1027f9ea2;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("1M8gH"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("1M8gH"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("ddmQY"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("1M8gH", function(module, exports) {

let $14b0b011b18aa89c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14b0b011b18aa89c$var$load("lkOIY"),
    $14b0b011b18aa89c$var$load("dRpV3"),
    $14b0b011b18aa89c$var$load("6wr18"),
    $14b0b011b18aa89c$var$load("4ukIM"),
    $14b0b011b18aa89c$var$load("ffEVr"),
    $14b0b011b18aa89c$var$load("kHOMt"),
    $14b0b011b18aa89c$var$load("hhss7"),
    $14b0b011b18aa89c$var$load("7EorR"),
    $14b0b011b18aa89c$var$load("Wowvf"),
    $14b0b011b18aa89c$var$load("4Nzvy"),
    $14b0b011b18aa89c$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("ddmQY", function(module, exports) {

let $99ee3773125bddc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ee3773125bddc9$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("CRB7F", function(module, exports) {

var $84DXu = parcelRequire("84DXu");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/long-running-task/manifest.ts
var $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $84DXu.ConfluenceLongRunningTaskAriResourceOwner),
    resourceType: (0, $84DXu.ConfluenceLongRunningTaskAriResourceType),
    resourceIdSlug: "activation/{activationId}/{taskId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        taskId: /[0-9]+/
    }
};
// src/confluence/long-running-task/index.ts
var $074d201f1b439f20$export$ebd9af01759f4a9a = class _ConfluenceLongRunningTaskAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get taskId() {
        return this._taskId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.qualifier,
            platformQualifier: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.resourceOwner,
            resourceType: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.taskId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                taskId: opts.taskId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            taskId: this.taskId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._taskId = opts.resourceIdSegmentValues.taskId;
    }
};
module.exports["ConfluenceLongRunningTaskAri"] = $074d201f1b439f20$export$ebd9af01759f4a9a;

});

parcelRegister("84DXu", function(module, exports) {
// src/confluence/long-running-task/types.ts
var $5e0db15e3d7f033e$export$c3f2be88215e7f96 = "confluence", $5e0db15e3d7f033e$export$d803f499be36f7e2 = "long-running-task";
module.exports["ConfluenceLongRunningTaskAriResourceOwner"] = $5e0db15e3d7f033e$export$c3f2be88215e7f96;
module.exports["ConfluenceLongRunningTaskAriResourceType"] = $5e0db15e3d7f033e$export$d803f499be36f7e2;

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("9Zu7R", function(module, exports) {

var $cqKco = parcelRequire("cqKco");


var $1DWH0 = parcelRequire("1DWH0");

const $d7b10312e31a364c$export$208fd20af21dc523 = (0, $1DWH0.default)()((0, $cqKco.default));
module.exports["NotificationIndicator"] = $d7b10312e31a364c$export$208fd20af21dc523;

});

parcelRegister("cqKco", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c4sKh = parcelRequire("c4sKh");

const $28ae02d12db6a953$var$MAX_NOTIFICATIONS_COUNT = 9;
const $28ae02d12db6a953$var$NAVIGATION_CHANNEL = 'navigation';
class $28ae02d12db6a953$var$NotificationIndicator extends (0, $42omo.Component) {
    async componentDidMount() {
        this.notificationLogProvider = await this.props.notificationLogProvider;
        this.refresh('mount');
        this.updateInterval();
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.refreshRate !== this.props.refreshRate) this.updateInterval();
    }
    componentWillUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
        if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    updateInterval() {
        const { refreshRate: refreshRate } = this.props;
        if (this.intervalId) clearInterval(this.intervalId);
        if (refreshRate && refreshRate > 0) this.intervalId = window.setInterval(this.timerTick, refreshRate);
    }
    render() {
        const { count: count } = this.state;
        const { appearance: appearance, max: max } = this.props;
        return count ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-test-selector": "NotificationIndicator",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                testId: "notification-indicator-badge",
                max: max,
                appearance: appearance,
                children: count
            })
        }) : null;
    }
    constructor(...args){
        super(...args);
        this.intervalId = void 0;
        this.visibilityChangesSinceTimer = 0;
        this.notificationLogProvider = void 0;
        this.state = {
            count: this.props.ssrInitialValue || null
        };
        this.onVisibilityChange = ()=>{
            if (this.props.refreshOnVisibilityChange && this.shouldRefresh()) {
                this.visibilityChangesSinceTimer++;
                this.refresh('visibility');
            }
        };
        this.shouldRefresh = ()=>{
            return typeof document !== 'undefined' && !document.hidden || this.props.refreshOnHidden;
        };
        this.timerTick = ()=>{
            this.visibilityChangesSinceTimer = 0;
            this.refresh('timer');
        };
        this.handleAnalytics = (countUpdateProperties)=>{
            const { newCount: newCount, oldCount: oldCount, source: source } = countUpdateProperties;
            // Only fire an 'activating' analytics event if the notification indicator is 'activating' for the first time
            // ie going from a number of 0 (the indicator is not visible)
            // to a number > 0 (the indicator becomes visible)
            if (this.props.createAnalyticsEvent && newCount > 0 && oldCount === 0) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'activated',
                    attributes: {
                        badgeCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($28ae02d12db6a953$var$NAVIGATION_CHANNEL);
            }
            if (this.props.createAnalyticsEvent && newCount !== oldCount) {
                const event = this.props.createAnalyticsEvent({
                    actionSubject: 'notificationIndicator',
                    action: 'updated',
                    attributes: {
                        oldCount: oldCount,
                        newCount: newCount,
                        refreshSource: source
                    }
                });
                event.fire($28ae02d12db6a953$var$NAVIGATION_CHANNEL);
            }
        };
        this.refresh = async (source)=>{
            // Provider should be available by this point, if not, we exit.
            if (!this.notificationLogProvider) return;
            // If user is not viewing the webpage, then skip this refresh to avoid unnecessary request.
            if (!this.shouldRefresh()) return;
            const visibilityChangesSinceTimer = this.visibilityChangesSinceTimer;
            const updatingEvent = {
                source: source,
                visibilityChangesSinceTimer: visibilityChangesSinceTimer
            };
            const updatingResult = this.props.onCountUpdating && this.props.onCountUpdating(updatingEvent) || {};
            if (updatingResult.skip) return;
            try {
                const count = updatingResult.countOverride || (await this.notificationLogProvider.countUnseenNotifications({
                    queryParams: {
                        currentCount: this.state.count || 0
                    }
                })).count;
                if (this.state.count === null || this.state.count !== count) {
                    const countUpdateProperties = {
                        oldCount: this.state.count || 0,
                        newCount: count,
                        source: source
                    };
                    this.handleAnalytics(countUpdateProperties);
                    if (this.props.onCountUpdated) this.props.onCountUpdated(countUpdateProperties);
                    this.setState({
                        count: count
                    });
                }
            } catch (e) {
            // Do nothing
            }
        };
    }
}
$28ae02d12db6a953$var$NotificationIndicator.defaultProps = {
    appearance: 'important',
    max: $28ae02d12db6a953$var$MAX_NOTIFICATIONS_COUNT,
    refreshRate: 0,
    refreshOnHidden: false,
    refreshOnVisibilityChange: true
};
var $28ae02d12db6a953$export$2e2bcd8739ae039 = $28ae02d12db6a953$var$NotificationIndicator;
module.exports["default"] = $28ae02d12db6a953$export$2e2bcd8739ae039;

});

parcelRegister("14QAi", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");


var $lzcvT = parcelRequire("lzcvT");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

parcelRegister("c3uZU", function(module, exports) {
$parcel$export(module.exports, "NotificationLogClient", () => (parcelRequire("eOM9G")).default);

var $eOM9G = parcelRequire("eOM9G");


});

parcelRegister("eOM9G", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");

const $5fd92637de1593c4$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
const $5fd92637de1593c4$export$a61d46c15216c8a4 = '/gateway/api/graphql';
class $5fd92637de1593c4$export$2e2bcd8739ae039 {
    async countUnseenNotifications(options = {}) {
        const query = /* GraphQL */ `
			query NotificationLogClientUnseenCount($workspaceId: String, $routingWorkspaceId: String) {
				notifications {
					unseenNotificationCount(
						workspaceId: $workspaceId
						routingWorkspaceId: $routingWorkspaceId
					)
				}
			}
		`;
        const response = await (0, $dwp40.utils).requestService({
            url: this.graphQLBaseUrl
        }, {
            // Don't add trailing slash, it causes 404s
            path: '',
            ...options,
            queryParams: {
                q: this.source,
                ...options.queryParams
            },
            requestInit: {
                mode: 'cors',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...options.requestInit?.headers
                },
                body: JSON.stringify({
                    query: query,
                    variables: {
                        workspaceId: this.cloudId,
                        routingWorkspaceId: this.routingWorkspaceId
                    }
                }),
                ...options.requestInit
            }
        });
        return {
            count: response.data.notifications.unseenNotificationCount
        };
    }
    constructor({ graphQLBaseUrl: graphQLBaseUrl = $5fd92637de1593c4$export$a61d46c15216c8a4, cloudId: cloudId, source: source = $5fd92637de1593c4$export$b055de0e665cb20c, routingWorkspaceId: routingWorkspaceId } = {}){
        this.graphQLBaseUrl = void 0;
        this.cloudId = void 0;
        this.source = void 0;
        this.routingWorkspaceId = void 0;
        this.graphQLBaseUrl = graphQLBaseUrl;
        this.cloudId = cloudId;
        this.source = source;
        this.routingWorkspaceId = routingWorkspaceId;
    }
}
module.exports["default"] = $5fd92637de1593c4$export$2e2bcd8739ae039;

});

parcelRegister("cH0rK", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $QU6QS = parcelRequire("QU6QS");


var $2ZJmt = parcelRequire("2ZJmt");


var $9wGTI = parcelRequire("9wGTI");

const $704173a03d8ffca7$export$94931606b6900781 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onConfirm: onConfirm } = t0;
    const intl = (0, $1cfRh.default)();
    let t1;
    if ($[0] !== intl || $[1] !== onConfirm) {
        t1 = (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), {
            message: intl.formatMessage($704173a03d8ffca7$var$i18n.unsavedChanges),
            onConfirm: onConfirm
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Prompt), {
            message: ()=>{
                if (confirm(intl.formatMessage($704173a03d8ffca7$var$i18n.unsavedChanges))) {
                    onConfirm();
                    return true;
                }
                return false;
            }
        });
        $[0] = intl;
        $[1] = onConfirm;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $704173a03d8ffca7$var$i18n = (0, $h82at.defineMessages)({
    unsavedChanges: {
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    }
});
module.exports["UnsavedNotificationCommentDraftPrompt"] = $704173a03d8ffca7$export$94931606b6900781;

});

parcelRegister("f4ikL", function(module, exports) {
const $e427a1545778ede9$export$8ceafede401119f2 = (intl)=>{
    const confirmMessage = intl.formatMessage({
        id: "app-navigation.notifications.unsaved-changes.confirm",
        defaultMessage: "Do you want to discard this comment? Your comment will be lost if you do."
    });
    return window.confirm(confirmMessage);
};
const $e427a1545778ede9$export$7bc0d27643cb0f0 = (event)=>{
    // Check if the close event was triggered by a link click
    if (event && event.type === 'click') {
        const target = event.target;
        const link = target.closest('a');
        if (link && link.href && !link.href.startsWith('javascript:')) // If it's a link click, don't show confirmation - let Prompt handle it
        return true;
    }
    return false;
};
const $e427a1545778ede9$export$5e3c850ff2c69d53 = (event, intl, onClose)=>{
    if ($e427a1545778ede9$export$7bc0d27643cb0f0(event)) return;
    if (event && event.type === 'keydown') {
        const keyboardEvent = event;
        if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') {
            if (!$e427a1545778ede9$export$8ceafede401119f2(intl)) return;
        }
    }
    onClose();
};
module.exports["confirmDiscardNotificationCommentDraft"] = $e427a1545778ede9$export$8ceafede401119f2;
module.exports["handlePopupCloseWithUnsavedChanges"] = $e427a1545778ede9$export$5e3c850ff2c69d53;

});

parcelRegister("mghzX", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXjWU = parcelRequire("aXjWU");

const $f31df34f0e245783$export$d5e80b5916277837 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { id: id, children: children } = t0;
    let t1;
    if ($[0] !== id) {
        t1 = {
            triggerId: id
        };
        $[0] = id;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: fireTrigger } = (0, $aXjWU.useFirePostOfficeTrigger)(t1);
    let t2;
    let t3;
    if ($[2] !== fireTrigger) {
        t2 = ()=>{
            fireTrigger({
                isActive: true
            });
            return ()=>{
                fireTrigger({
                    isActive: false
                });
            };
        };
        t3 = [
            fireTrigger
        ];
        $[2] = fireTrigger;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[5] !== children || $[6] !== id) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: id
        }, children);
        $[5] = children;
        $[6] = id;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
module.exports["PostOfficeHtmlTarget"] = $f31df34f0e245783$export$d5e80b5916277837;

});

parcelRegister("41c4c", function(module, exports) {

var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");

const $c0dbaa4ed1720915$export$5ca34e43e28ce619 = ()=>{
    return (0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER)
    });
};
module.exports["preloadProfileMenu"] = $c0dbaa4ed1720915$export$5ca34e43e28ce619;

});

parcelRegister("kLRO8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8MTIk = parcelRequire("8MTIk");

const $a12fcbbfbeaca916$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MTIk.IconButton), {
        component: component,
        href: href,
        icon: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    }));
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$a12fcbbfbeaca916$export$2e2bcd8739ae039 = (_props)=>{};
module.exports["Profile"] = $a12fcbbfbeaca916$export$5120f2d0b8d4cab8;

});

parcelRegister("3sMdn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $3scmi = parcelRequire("3scmi");


var $56M4r = parcelRequire("56M4r");


var $6F6hl = parcelRequire("6F6hl");


var $hmRr5 = parcelRequire("hmRr5");


var $4cUZH = parcelRequire("4cUZH");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $0affb4f68c8513c7$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $4cUZH.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $3scmi.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                "aria-checked": selected,
                "aria-describedby": `${id}-radio`,
                description: description,
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $hmRr5.default), {
                    checked: selected
                }),
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemradio",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                // Thanks to spread props, this attribute are passed to ButtonItem, even though
                // it's not in the component's prop types.
                // @ts-expect-error
                title: title,
                interactionName: interactionName,
                ...rest,
                // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
                "aria-current": undefined,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6F6hl.default), {
                id: `${id}-radio`,
                children: [
                    "radio button ",
                    selected
                ]
            })
        ]
    });
};
var $0affb4f68c8513c7$export$2e2bcd8739ae039 = $0affb4f68c8513c7$var$DropdownItemRadio;
module.exports["default"] = $0affb4f68c8513c7$export$2e2bcd8739ae039;

});

parcelRegister("hmRr5", function(module, exports) {
/* radio-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $01850bf21ecc815c$var$svgStyles = null; /**
                         * __Radio icon__
                         *
                         * Used to visually represent the selected state in DropdownItemRadio
                         *
                         * @internal
                         */ 
const $01850bf21ecc815c$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "7.5",
                    fill: "currentColor",
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $01850bf21ecc815c$export$2e2bcd8739ae039 = $01850bf21ecc815c$var$RadioIcon;
module.exports["default"] = $01850bf21ecc815c$export$2e2bcd8739ae039;

});

parcelRegister("4cUZH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mnSH = parcelRequire("6mnSH");


var $nVQ0B = parcelRequire("nVQ0B");

function $1119aafb00a8a88b$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $42omo.useContext)((0, $nVQ0B.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $42omo.useContext)((0, $6mnSH.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $42omo.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
	 * Set the initial state of the context provider's store,
	 * if it doesn't already have a persisted value for this id.
	 */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = {
            ...existing,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $1119aafb00a8a88b$export$2e2bcd8739ae039 = $1119aafb00a8a88b$var$useRadioState;
module.exports["default"] = $1119aafb00a8a88b$export$2e2bcd8739ae039;

});

parcelRegister("6mnSH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $ea384564884ae281$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $42omo.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $ee7An.default)
});
module.exports["RadioGroupContext"] = $ea384564884ae281$export$a79eda4ff50e30b6;

});

parcelRegister("M3hWz", function(module, exports) {
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input. The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 *
 * This component is intended to be used for server side rendering only as
 * the event listeners for the input are attached via a HTML script tag.
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aDlrJ = parcelRequire("aDlrJ");

var $eSS4z = parcelRequire("eSS4z");

const $3b55a543569211e8$export$fa4a5af93371d2d1 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aDlrJ.SearchInputSkeletonInteractiveSSR), {
            ...props
        })
    });
};
module.exports["ProductSearchInputSkeletonInteractiveSSR"] = $3b55a543569211e8$export$fa4a5af93371d2d1;

});

parcelRegister("aDlrJ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fwSxy = parcelRequire("fwSxy");


var $iSHbD = parcelRequire("iSHbD");


var $2wQTl = parcelRequire("2wQTl");


var $eSS4z = parcelRequire("eSS4z");

const $a560394ad49f84af$export$ed08cb5579938462 = ({ advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes, shouldFillContainer: shouldFillContainer })=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRsearchInputWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: "ssr-search-input-popout-container",
            "data-ssr-placeholder": "search-input",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $l998X.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwSxy.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            dangerouslySetInnerHTML: {
                                __html: (0, $2wQTl.script)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};
module.exports["SearchInputSkeletonInteractiveSSR"] = $a560394ad49f84af$export$ed08cb5579938462;

});

parcelRegister("2wQTl", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable */ // @ts-ignore
const $da2d6e1979a6c520$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;
module.exports["script"] = $da2d6e1979a6c520$export$bc237d627614fc48;

});

parcelRegister("kysoj", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $9wGTI = parcelRequire("9wGTI");

const $9a64fd0ce05b42e8$export$3977b992ec7f3f3b = (inputRef)=>{
    if (!(0, $9wGTI.fg)('quickfind-ghosttext')) return undefined;
    let ghostText;
    const searchInput = inputRef?.current;
    if (typeof HTMLInputElement !== 'undefined' && searchInput instanceof HTMLInputElement && searchInput?.placeholder) ghostText = searchInput.placeholder;
    // If found in DOM/ref and valid, use it
    if (ghostText && ghostText.length > 0) return ghostText;
    return (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT);
};
module.exports["getPersistedGhostText"] = $9a64fd0ce05b42e8$export$3977b992ec7f3f3b;

});

parcelRegister("92JEG", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $d66becf3e4056778$export$8bcdb86a7ad5ef4b = ()=>{
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED)
    ]);
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $ivb8S.deserializeState)(data);
    return {
        isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed
    };
};
module.exports["useHasDismissedNav4CollapseReminderSpotlight"] = $d66becf3e4056778$export$8bcdb86a7ad5ef4b;

});


//# sourceMappingURL=PageLayout.01d5ab52.js.map
